import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { EqtargetcostingService } from 'src/app/services/eqtargetcosting.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { DoublingEditorComponent } from '../../non-plc/costsavings/doubling-editor.component';
import { messages } from 'src/app/popUpMessages/messages';
import { Eqcosts } from 'src/app/models/Eqcosts';
import { Eqsummaries } from 'src/app/models/EqSummaries';
import { ProjectService } from 'src/app/services/project.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { EqTaretcostingCalcPopupComponent } from '../eq-taretcosting-calc-popup/eq-taretcosting-calc-popup.component';
import { Eqtargetcosts } from 'src/app/models/EqTargetcosts';
import { EditEqCalcComponent } from '../edit-eq-calc/edit-eq-calc.component';
import { AddMaterialComponent } from '../add-material/add-material.component';
import { DeleteiconComponent } from '../../deleteIconNormalGrid/deleteicon.component';
import { ColumnResizedEvent, FirstDataRenderedEvent, RowNode } from 'ag-grid-community';
import { combineLatest, forkJoin, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { EditEqBkCalcComponent } from '../edit-eq-bk-calc/edit-eq-bk-calc.component';
import { ConfigurationLockService } from 'src/app/services/configuration-lock.service';
import { UnSavedChangesServiceService } from 'src/app/services/un-saved-changes-service.service';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { CommentboxComponent } from 'src/app/commentbox/commentbox.component';
import { EnumModuleId } from 'src/app/enum/EnumModuleId';
import { SupplierTargetService } from 'src/app/services/suppliertarget.service';

let countryCode;
let grids;

@Component({
  selector: 'app-eq-targetcosting',
  templateUrl: './eq-targetcosting.component.html',
  styleUrls: ['./eq-targetcosting.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EqTargetcostingComponent implements OnInit, OnDestroy {
  @ViewChild('commentBox') commentBox: CommentboxComponent;
  hasCommentUnsavedChanges: boolean = false;
  public expandedGroupKeys: string[] = [];
  firstLoadMap: { [gridId: string]: boolean } = {
    configGrid: true,
    refGrid: true,
    tarGrid: true,
    optAGrid: true,
    optBGrid: true,
    optCGrid: true
  };
  public gridApi: any;
  public sizeToFitRefresh: number = 0;
  public showGrid = false;
  eqConfigurationData: any;

  public defaultColDef: any;
  public hasUnsavedChanges: boolean = false;
  public submitted: boolean = false;
  public alertErrorBox = [];
  TCEQTargetCostSummaries: any[] = [];
  TCEQTargetCosts: any[] = [];
  submitResponse: any;
  public businessAreaId: number;
  public businessLineId: number;
  public userInOrg: any;
  public allUserList: any;
  gmkGroup: string;
  bkFactorValue: number;
  fkFactorValue: number;
  bkFactorList: any[];

  TCSimulationData: any;

  optAVisible: boolean = false;
  optBVisible: boolean = false;
  optCVisible: boolean = false;
  isEditable: boolean = true;

  gridData: any[];
  masterGridData: any[];
  gridDataSummary: any[];
  public modifiedGridData = [];

  configGridApi: any;
  configGridColumnApi: any;
  configColumnDefs: any;
  configDefaultColDef: any;
  configGridData: any[];
  configPinnedTopData: any;
  public configFrameworkComponents;
  getRowHeightConfig: any;
  domLayoutConfig: string;

  refGridApi: any;
  refGridColumnApi: any;
  refColumnDefs: any;
  refDefaultColDef: any;
  refGridData: any[];
  refPinnedTopData: any;
  public refFrameworkComponents;
  getRowHeightRef: any;
  domLayoutRef: string;

  tarColumnDefs: any;
  tarGridData: any[];
  tarDefaultColDef: any;
  tarGridApi: any;
  tarGridColumnApi: any;
  tarPinnedTopData: any;
  public tarFrameworkComponents;
  getRowHeightTar: any;
  domLayoutTar: string;

  optAColumnDefs: any;
  optAGridData: any[];
  optAGridApi: any;
  optAGridColumnApi: any;
  optAPinnedTopData: any;
  public optAFrameworkComponents;
  getRowHeightoptA: any;
  // optADefaultColDef: {
  //   suppressMovable: boolean; sortable: boolean;
  //   // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
  //   wrapText: boolean;
  // };
  optADefaultColDef: any;
  OptADomLayout: string;

  optBColumnDefs: any;
  optBGridData: any[];
  optBGridApi: any;
  optBGridColumnApi: any;
  optBPinnedTopData: any;
  public optBFrameworkComponents;
  getRowHeightoptB: any;
  // optBDefaultColDef: {
  //   suppressMovable: boolean; sortable: boolean;
  //   // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
  //   wrapText: boolean;
  // };
  optBDefaultColDef: any;
  OptBDomLayout: string;

  optCColumnDefs: any;
  optCGridData: any[];
  optCGridApi: any;
  optCGridColumnApi: any;
  optCPinnedTopData: any;
  public optCFrameworkComponents;
  getRowHeightoptC: any;
  // optCDefaultColDef: {
  //   suppressMovable: boolean; sortable: boolean;
  //   // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
  //   wrapText: boolean;
  // };
  optCDefaultColDef: any;
  OptCDomLayout: string;

  refTitle: string = "";
  tarTitle: string = "";
  optATitle: string = "";
  optBTitle: string = "";
  optCTitle: string = "";

  configurationId: any;

  kmatDropdown: any[];
  vbloDropdown: any[];
  componentDropdown: any[];

  configSummaryGridApi: any;
  configColumnDefsSummary: any;
  getRowHeightConfigSummary: any;
  configDefaultColDefSummary: any;
  domLayoutConfigSummary: any;

  refSummaryGridApi: any;
  refColumnDefsSummary: any;
  getRowHeightRefSummary: any;
  refDefaultColDefSummary: any;
  domLayoutRefSummary: any;
  refSummaryFrameworkComponents: any;

  tarSummaryGridApi: any;
  tarColumnDefsSummary: any;
  getRowHeightTarSummary: any;
  tarDefaultColDefSummary: any;
  domLayoutTarSummary: any;
  tarSummaryFrameworkComponents: any;

  optASummaryGridApi: any;
  optAColumnDefsSummary: any;
  getRowHeightOptASummary: any;
  optADefaultColDefSummary: any;
  domLayoutOptASummary: any;
  optASummaryFrameworkComponents: any;

  optBSummaryGridApi: any;
  optBColumnDefsSummary: any;
  getRowHeightOptBSummary: any;
  optBDefaultColDefSummary: any;
  domLayoutOptBSummary: any;
  optBSummaryFrameworkComponents: any;

  optCSummaryGridApi: any;
  optCColumnDefsSummary: any;
  getRowHeightOptCSummary: any;
  optCDefaultColDefSummary: any;
  domLayoutOptCSummary: any;
  optCSummaryFrameworkComponents: any;

  sizeToFitRefreshConfigSummary: number = 0;
  sizeToFitRefreshRefSummary: number = 0;
  sizeToFitRefreshTarSummary: number = 0;
  sizeToFitRefreshOptASummary: number = 0;
  sizeToFitRefreshOptBSummary: number = 0;
  sizeToFitRefreshOptCSummary: number = 0;
  sizeToFitRefreshConfig: number = 0;
  sizeToFitRefreshRef: number = 0;
  sizeToFitRefreshTar: number = 0;
  sizeToFitRefreshOptA: number = 0;
  sizeToFitRefreshOptB: number = 0;
  sizeToFitRefreshOptC: number = 0;
  rowClassRules: any;
  autoGroupColumnDef: any;
  groupRowRendererParamsSummary: any;
  groupRowRendererParams: any;
  frameworkComponents: any;
  configSub: any;
  lockStatusSub: any;
  unsavedSub: any;
  combinedSub: any;
  objData: any;
  moduleId: Number = 6;
  selectedScenario: any[];
  rowGroupPanelShow: string;
  groupedColumns: any;
  defaultGroupSortComparator: any;
  rowClassRulesSummary: any;
  showAdditionalRows: boolean = false;
  showAdditionalMEKRows: boolean = false;
  isProgrammaticToggle: boolean = false;
  isExpanded: boolean = false;
  isGrouped: boolean = false;
  expandCollapse: String = "Expand Groups"
  isUpdating: boolean = false;
  sortingState: any;
  isVisibleAddOption: boolean = true;
  refGridOpened: boolean = true;
  tarGridOpened: boolean = true;
  optAGridOpened: boolean = true;
  optBGridOpened: boolean = true;
  optCGridOpened: boolean = true;
  private summaryTrigger = new Subject<void>();
  menuData: any[] = [];
  tcEQMenuRoleId: number;
  tcEQMenuIsDisplay: boolean;

  private filterSource: string | null = null; // 'config' | 'ref' | 'target' | etc.
  originalColumnDefs: any;

  //lock/unlock page variables
  roleBasedEditable: boolean = false;
  isLocked: boolean = false;
  lockedByUserId: string | null = null;
  lockedByUserName: string | null = null;
  lockStatusInfo: any = null;

  public agGridContext = {
    onSimulationDataUpdate: (updatedSimulationData: any[]) => this.onSimulationDataUpdate(updatedSimulationData)
  };
  IsSimulationDataModified: boolean = false;

  //Implement user accesstype
  HasMinorAccess: boolean;
  actualsCreationbkFactorList: any;
  M300bkFactorList: any;

  //MasterSupplierInfoData
  supplierInfoMasterList: any[] = [];

  OptTarget: number = 0.00;
  OptForecast: number = 0.00;
  OptActuals: number = 0.00;
  scmOptionData: any;
  constructor(
    private toast: ToasterService,
    private sharedService: SharedServiceService,
    private projectService: ProjectService,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private router: Router,
    private menuService: MenuService,
    private userService: UserInfoService,
    private eqtargetcostingService: EqtargetcostingService,
    private configurationLockService: ConfigurationLockService,
    private unSavedChangeService: UnSavedChangesServiceService,
    private supplierTargetService: SupplierTargetService
  ) {
    this.frameworkComponents = {
      doublingEditor: DoublingEditorComponent,
      groupRowInnerRenderer: AddMaterialComponent,
      EditEqCalcComponent: EditEqCalcComponent,
      EditEqBkCalcComponent: EditEqBkCalcComponent
    }

    this.groupRowRendererParamsSummary = {
      suppressCount: true,
    }

    this.groupRowRendererParams = {
      suppressCount: true,
      innerRenderer: 'groupRowInnerRenderer',
    }

    this.defaultGroupSortComparator = function (nodeA, nodeB) {
      if (nodeA.key == "Please Select" || nodeA.key == "0") {
        return -1;
      } else if (nodeB.key == "Please Select" || nodeB.key == "0") {
        return 1;
      } else {
        return 0;
      }
    };
  }

  ngOnInit(): void {
    this.localStorageService.remove("configuration");
    this.sharedService.getProjectIdAndTitle();
    this.menuService.menu.subscribe(menudata => {
      if (menudata && menudata.length > 0) {
        this.menuData = menudata;
        const eqMenu = this.menuData.find(m => m.Route === "tc-eq");
        if (eqMenu) {
          this.tcEQMenuRoleId = eqMenu.RoleId;
          this.tcEQMenuIsDisplay = eqMenu.IsDisplay;
          if (this.tcEQMenuRoleId > 5) {
            this.HasMinorAccess = true;
          }
          else {
            this.HasMinorAccess = false;
          }
        }
      }
    });
    let projectId = this.localStorageService.get("projectId");


    countryCode = this.localStorageService.get('countryCode');

    this.sharedService.eqAddedRow.subscribe(data => {
      this.isVisibleAddOption = false;
      this.hasUnsavedChanges = true;
      this.refGridApi.applyTransaction({
        add: [data.addObject], addIndex: data.addIndex
      })
      this.tarGridApi.applyTransaction({
        add: [data.addObject], addIndex: data.addIndex
      })

      if (this.optAVisible) {
        data.addObject.OptionA = {
          ScenarioTitle: "",
          TargetCostMEK: {
            EQId: 0,
            PerPiece: 0,
            Quantity: 0,
            Weight: 0,
            PerSystem: 0,
            DeltaTCVsRefMEK: 0,
          },
          ForecastMEK: {
            EQId: 0,
            PerPiece: 0,
            PerSystem: 0,
            DeltaFCVsRefMEK: 0,
            ActualsMEK: 0,
            DeltaTCVsACT: 0,
          }
        }
        this.optAGridApi.applyTransaction({
          add: [data.addObject], addIndex: data.addIndex
        })
      }

      if (this.optBVisible) {
        data.addObject.OptionB = {
          ScenarioTitle: "",
          TargetCostMEK: {
            EQId: 0,
            PerPiece: 0,
            Quantity: 0,
            Weight: 0,
            PerSystem: 0,
            DeltaTCVsRefMEK: 0,
          },
          ForecastMEK: {
            EQId: 0,
            PerPiece: 0,
            PerSystem: 0,
            DeltaFCVsRefMEK: 0,
            ActualsMEK: 0,
            DeltaTCVsACT: 0,
          }
        }
        this.optBGridApi.applyTransaction({
          add: [data.addObject], addIndex: data.addIndex
        })
      }

      if (this.optCVisible) {
        data.addObject.OptionC = {
          ScenarioTitle: "",
          TargetCostMEK: {
            EQId: 0,
            PerPiece: 0,
            Quantity: 0,
            Weight: 0,
            PerSystem: 0,
            DeltaTCVsRefMEK: 0,
          },
          ForecastMEK: {
            EQId: 0,
            PerPiece: 0,
            PerSystem: 0,
            DeltaFCVsRefMEK: 0,
            ActualsMEK: 0,
            DeltaTCVsACT: 0,
          }
        }
        this.optCGridApi.applyTransaction({
          add: [data.addObject], addIndex: data.addIndex
        })
      }
    });

    this.sharedService.eqDeleteRow.subscribe(data => {
      this.hasUnsavedChanges = true;
      data.IsRemoved = true;

      if (data.EQId != 0) {
        const rowsToRemove = this.gridData.filter(x => x.EQId == data.EQId);
        this.refGridApi.applyTransaction({
          remove: rowsToRemove
        });

        this.tarGridApi.applyTransaction({
          remove: rowsToRemove
        });

        if (this.optAVisible) {
          this.optAGridApi.applyTransaction({
            remove: rowsToRemove
          })
        }

        if (this.optBVisible) {
          this.optBGridApi.applyTransaction({
            remove: rowsToRemove
          })
        }

        if (this.optCVisible) {
          this.optCGridApi.applyTransaction({
            remove: rowsToRemove
          })
        }

        // this.gridData = this.gridData.filter((row) => row.EQId !== data.EQId);
        this.gridData = sortGridData(this.gridData);

        let isPushed = false;
        if (this.modifiedGridData.length == 0) {
          this.modifiedGridData.push(data);
          isPushed = true;
        }
        else {
          this.modifiedGridData.forEach(row => {
            if (data.EQId == row.EQId) {
              isPushed = true;
            }
          })
        }
        if (!isPushed) {
          this.modifiedGridData.push(data);
        }
      }
      else {
        let rowToRemove;
        if (data.hasOwnProperty("IsManual")) {
          this.refGridApi.forEachNode(x => {
            if (!x.group && x.data.KMATId === data.KMATId && x.data.KMATVBLOId === data.KMATVBLOId && x.data.VBLOId === data.VBLOId &&
              x.data.VBLO === data.VBLO && x.data.Material === data.Material && x.data.MaterialNo === data.MaterialNo && x.data.Component === data.Component) {
              rowToRemove = x.data;
            }
          })
        }
        else {
          rowToRemove = this.gridData.find(x => x.KMATId === data.KMATId && x.KMATVBLOId === data.KMATVBLOId && x.VBLOId === data.VBLOId &&
            x.VBLO === data.VBLO && x.Material === data.Material && x.MaterialNo === data.MaterialNo && x.Component === data.Component
          );
        }
        this.refGridApi.applyTransaction({
          remove: [rowToRemove]
        });

        this.tarGridApi.applyTransaction({
          remove: [rowToRemove]
        });

        if (this.optAVisible) {
          this.optAGridApi.applyTransaction({
            remove: [rowToRemove]
          })
        }

        if (this.optBVisible) {
          this.optBGridApi.applyTransaction({
            remove: [rowToRemove]
          })
        }

        if (this.optCVisible) {
          this.optCGridApi.applyTransaction({
            remove: [rowToRemove]
          })
        }

        // this.gridData = this.gridData.filter( x => x !== rowToRemove);
        // this.gridData = sortGridData(this.gridData);
        // if(this.modifiedGridData.length != 0){
        //   this.modifiedGridData = this.modifiedGridData.filter(x => x !== rowToRemove);
        // }
        // let isPushed = false;
        // if (this.modifiedGridData.length == 0) {
        //   this.modifiedGridData.push(data);
        //   isPushed = true;
        // }
        // else {
        //   this.modifiedGridData.forEach(row => {
        //     if (data.KMATId === row.KMATId && data.KMATVBLOId === row.KMATVBLOId && data.VBLOId === row.VBLOId &&
        //       data.VBLO === row.VBLO && data.MaterialNo === row.MaterialNo && data.Material === row.Material && data.Component === row.Component
        //     ) {
        //       isPushed = true;
        //     }
        //   })
        // }
        // if (!isPushed) {
        //   this.modifiedGridData.push(data);
        // }
      }
      let total = 0;
      this.refGridApi.forEachNodeAfterFilter(node => {
        if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
          total += Number(node.data.ReferencceScenario.MEKPerSystem)
        }
      })
      this.gridDataSummary.find(x => x.Name == "MEKTotal").ReferenceScenario.PerSystem = total;
      this.refSummaryGridApi.redrawRows();

      this.calculateSummaryMekTotalTarget();
      if (this.optAVisible) {
        this.calculateSummaryMekTotalOptionA();
      }
      if (this.optBVisible) {
        this.calculateSummaryMekTotalOptionB();
      }
      if (this.optCVisible) {
        this.calculateSummaryMekTotalOptionC();
      }
    })

    // this.unSavedChangeService.check$.subscribe((callback) => {

    //   if (this.hasUnsavedChanges) {
    //     const unSavedDialog = this.dialog.open(DialogComponent, { data: { message: messages.UnsavedChanges, okBtn: "Yes", cancelBtn: "No" } })
    //     unSavedDialog.afterClosed().subscribe(async result => {
    //       if (result) {
    //         const submitResult = await this.submit();
    //         // this.hasUnsavedChanges = false;
    //         if(submitResult !== false){
    //          callback(true); 
    //         }
    //         // this.submit();
    //       }
    //       else {
    //         callback(false);
    //       }
    //     });
    //   }
    //   else {
    //     callback(true);
    //   }
    // })
    this.unsavedSub = this.unSavedChangeService.checkRequest$.subscribe(() => {
      if (this.hasUnsavedChanges) {
        const unSavedDialog = this.dialog.open(DialogComponent, { data: { message: messages.UnsavedChanges, okBtn: "Yes", cancelBtn: "No" } })
        unSavedDialog.afterClosed().subscribe(async result => {
          if (result === true) {
            // await this.submit();
            const submitResult = await this.submit();
            if (submitResult !== false) {
              this.unSavedChangeService.respondCheck(true); // Proceed
            }
            else {
              this.hasUnsavedChanges = false; // Reset unsaved changes flag
              this.unSavedChangeService.respondCheck(true); // Proceed (discard)
            }
          } else {
            this.hasUnsavedChanges = false; // Reset unsaved changes flag
            this.unSavedChangeService.respondCheck(true); // Proceed (discard)
          }
        });
      }
      else {
        this.unSavedChangeService.respondCheck(true);
        // return;
      }
    });

    if (projectId != null) {
      this.projectService.getTCData(projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {
          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              this.showGrid = true
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
                if (this.userInOrg != undefined) {

                  let userIsFinancialController = data.Data.FinancialControllerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsFinancialControllerProxy = data.Data.FinancialControllerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  // let userIsSubmitter = data.Data.SubmitterId.split(',').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManager = data.Data.ProductManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManagerProxy = data.Data.ProductManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManager = data.Data.ProjectManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManagerProxy = data.Data.ProjectManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManager = data.Data.ServiceManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManagerProxy = data.Data.ServiceManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineer = data.Data.ProcurementEngineerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineerproxy = data.Data.ProcurementEngineerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitect = data.Data.SystemArchitectIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitectProxy = data.Data.SystemArchitectProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsWatchList = data.Data.WatchListIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);

                  if (this.userInOrg.TargetRoleId == 1) {
                    this.roleBasedEditable = true;
                  }
                  else if (this.userInOrg.TargetRoleId == 3 || this.userInOrg.TargetRoleId == 2) {
                    if (data.Data.SubmitterId == this.userInOrg.UserId || userIsFinancialController || userIsFinancialControllerProxy
                      || userIsProductManager || userIsProductManagerProxy || userIsProjectManager || userIsProjectManagerProxy
                      || userIsProcurementEngineer || userIsProcurementEngineerproxy
                      || userIsSystemArchitect || userIsSystemArchitectProxy
                    ) {
                      this.roleBasedEditable = true;
                    }
                    else {
                      this.roleBasedEditable = false;
                    }
                  }
                  // this.setupLockAndConfigSubscription();
                }

                // Subscribe to configurationId changes
                this.configSub = this.sharedService.configurationId
                  .pipe(
                    filter(configId => !!configId),
                    distinctUntilChanged()
                  )
                  .subscribe(configId => {
                    this.configurationId = configId;
                    this.objData = {
                      projectId: projectId,
                      moduleId: Number(EnumModuleId.EqTargetCost),
                      configurationId: this.configurationId
                    }

                    // Pass objData to commentbox component
                    if (this.commentBox) {
                      this.commentBox.updateCommentData(this.objData);
                    }

                    // Fetch lock status for the new configId (AppComponent should do this, but safe here)
                    // this.configurationLockService.fetchLockStatus(configId, ...); // Only if needed
                    // Do NOT call loadData() here!
                  });

                // Subscribe to lockStatus changes
                this.lockStatusSub = this.configurationLockService.lockStatus$
                  .pipe(
                    filter(lockStatus => lockStatus !== null)
                  )
                  .subscribe(lockStatus => {
                    // Only call loadData if lockStatus is for the current configId
                    if (lockStatus.ConfigId == this.configurationId) {
                      this.lockStatusInfo = lockStatus;
                      this.isEditable = lockStatus.isLocked && lockStatus.lockedByUserId === this.userInOrg?.UserId
                        ? this.roleBasedEditable
                        : false;
                        this.loadData(this.configurationId);
                    }
                  });

                this.summaryTrigger.pipe(debounceTime(100)).subscribe(() => {
                  this.calculateSummaryMekTotalRef();
                  this.calculateSummaryMekTotalTarget();
                  if (this.optAVisible) this.calculateSummaryMekTotalOptionA();
                  if (this.optBVisible) this.calculateSummaryMekTotalOptionB();
                  if (this.optCVisible) this.calculateSummaryMekTotalOptionC();
                });
              })
            }
          })
        }
      });
    } else {
      this.businessAreaId = this.businessLineId = 0;
    }

  }

  // setupLockAndConfigSubscription() {
  //   this.combinedSub?.unsubscribe();

  //   this.combinedSub = combineLatest([
  //     this.sharedService.configurationId.pipe(
  //       filter(configId => !!configId),
  //       distinctUntilChanged()
  //     ),
  //     this.configurationLockService.lockStatus$.pipe(
  //       filter(lockStatus => lockStatus !== null),
  //       distinctUntilChanged((a, b) =>
  //         a && b &&
  //         a.isLocked === b.isLocked &&
  //         a.lockedByUserId === b.lockedByUserId &&
  //         a.lockedByUserName === b.lockedByUserName &&
  //         a.ConfigId === b.ConfigId
  //       )
  //     )
  //   ]).subscribe(([configId, lockStatus]) => {
  //     // if (lockStatus.ConfigId === configId) {
  //     this.configurationId = configId;
  //     this.lockStatusInfo = lockStatus;
  //     this.isEditable = lockStatus.isLocked && lockStatus.lockedByUserId === this.userInOrg?.UserId
  //       ? this.roleBasedEditable
  //       : false;
  //     this.loadData(configId);
  //     // }
  //   });
  // }

  loadData(configId) {
    this.showGrid = false;
    this.expandCollapse = "Expand Groups";
    this.isExpanded = false;
    // this.showGrid = false;
    this.configurationId = configId;
    if (this.configurationId == 0) {
      return;
    }
    this.optAVisible = false;
    this.optBVisible = false;
    this.optCVisible = false;
    // let tcEQMenu = this.menuData.find(m => m.Route == "tc-eq");
    // this.eqtargetcostingService.getEqTargetcostingData(this.configurationId, this.businessAreaId, this.businessLineId, this.tcEQMenuRoleId, this.userInOrg.UserId).subscribe({
    //   next: d => {
    forkJoin({
      eqData: this.eqtargetcostingService.getEqTargetcostingData(this.configurationId, this.businessAreaId, this.businessLineId, this.tcEQMenuRoleId, this.userInOrg.UserId),
      supplierInfo: this.supplierTargetService.getAllSupplierTargetData(this.businessAreaId, this.businessLineId)
    }).subscribe({
      next: ({ eqData: d, supplierInfo }) => {
        let errorMsgeFromBack = d.Data.Message;
        if (d.StatusCode == 200) {
          if (supplierInfo.StatusCode == 200) {
            this.supplierInfoMasterList = supplierInfo?.Data ?? supplierInfo ?? [];
          }
          this.eqConfigurationData = d.Data;
          this.TCEQTargetCostSummaries = this.eqConfigurationData.TCEQTargetCostSummaries;
          this.TCEQTargetCosts = this.eqConfigurationData.TCEQTargetCosts;
          this.TCSimulationData = this.eqConfigurationData.TCEQsimulationTargetCost;

          // if (this.TCEQTargetCostSummaries[0].Name == "CalculationScenario")
          //   this.selectedScenario = this.TCEQTargetCostSummaries.splice(0, 1);
          let IsEQSavedDataFromDB = this.TCEQTargetCosts.some(item => item.EQId > 0);
          let IsEQSummarySavedDataFromDB = this.TCEQTargetCostSummaries.some(item => item.Id > 0);

          if (!IsEQSavedDataFromDB || !IsEQSummarySavedDataFromDB) {
            this.hasUnsavedChanges = true;
          }

          if (this.TCEQTargetCosts.length == 0) {
            return;
          }

          // Set IsNewAndUnconfirmed = false for all loaded simulation data
          if (Array.isArray(this.TCSimulationData)) {
            this.TCSimulationData.forEach(row => {
              // Only set for assembly rows, not for summary rows like "Total", "Overhead", etc.
              if (
                row.Name &&
                !["Total", "Overhead", "Labour", "Assembly group"].includes(row.Name)
              ) {
                row.IsNewAndUnconfirmed = false;
              }
            });
          }

          if (this.TCEQTargetCosts.some(x => x.OptionA)) this.optAVisible = true
          if (this.TCEQTargetCosts.some(x => x.OptionB)) this.optBVisible = true
          if (this.TCEQTargetCosts.some(x => x.OptionC)) this.optCVisible = true

          this.refTitle = this.TCEQTargetCosts[0].ReferencceScenario.ScenarioTitle ?? ""
          this.tarTitle = this.TCEQTargetCosts[0].TargetScenario.ScenarioTitle ?? ""
          this.optATitle = this.TCEQTargetCosts[0].OptionA?.ScenarioTitle ?? ""
          this.optBTitle = this.TCEQTargetCosts[0].OptionB?.ScenarioTitle ?? ""
          this.optCTitle = this.TCEQTargetCosts[0].OptionC?.ScenarioTitle ?? ""

          this.bkFactorList = d.Data.OverheadCosts;
          this.bkFactorValue = d.Data.OverheadCosts.find(x => x.OverheadCostType == "BK Factor")?.FactorValue ?? 1;
          this.fkFactorValue = d.Data.OverheadCosts.find(x => x.OverheadCostType == "FK Factor")?.FactorValue ?? 1;
          this.actualsCreationbkFactorList = d.Data.OverheadCostsActualsCreationDate;
          this.M300bkFactorList = d.Data.OverheadCostsM300FY;

          this.vbloDropdown = ["Create new VBLO", ...new Set(this.TCEQTargetCosts.map(d => d.VBLO))]
          this.kmatDropdown = [...new Set(this.TCEQTargetCosts.map(d => d.KMAT))]
          this.componentDropdown = ["Create new Component", ...new Set(this.TCEQTargetCosts.map(d => d.Component))]

          // this.TCEQTargetCostSummaries.forEach(x => {
          //   //if (["BK", "TotalBK", "Overhead", "Labour", "MEKTotal"].includes(x.Name))
          //   x["rowGroup"] = "Summary";
          // })

          this.gridData = this.TCEQTargetCosts;
          this.gridData = sortGridData(this.gridData);
          // this.gridDataSummary = this.filterSummaryRowsForMinorAccess(this.TCEQTargetCostSummaries);
          this.gridDataSummary = this.TCEQTargetCostSummaries;

          this.gridData.forEach(d => {
            // d["IsEditable"] = this.isEditable;
            // Set IsEditable based on IsReadOrWriteAccess and IsReadAccess
            if (this.lockStatusInfo?.isLocked && this.lockStatusInfo.lockedByUserId === this.userInOrg.UserId) {
              if (d.IsReadOrWriteAccess) {
                d["IsEditable"] = true;
              } else if (d.IsReadAccess) {
                d["IsEditable"] = false;
              } else {
                d["IsEditable"] = this.isEditable;
              }
            }
            else {
              // Page is locked by other user or not locked, always non-editable
              d["IsEditable"] = false;
            }
            if (d.Component == d.Material) {
              let count = 0;
              this.gridData.forEach((node) => {
                if (node.Assembly == d.Assembly && node.KMAT == d.KMAT && node.VBLO == d.VBLO && node.Component == d.Component && node.Component != node.Material)
                  count++;
              })
              if (count != 0) {
                d["HasChild"] = true;
              }
            }
          })

          this.gridDataSummary.forEach(d => {
            d["IsEditable"] = (this.lockStatusInfo?.isLocked && this.lockStatusInfo.lockedByUserId === this.userInOrg.UserId) ? this.isEditable : false;
          })

          for (let i of this.gridData) {
            i.TargetScenario.TargetCostMEK.Quantity = i.TargetScenario.TargetCostMEK.Quantity ?? i.ReferencceScenario.Quantity;
            i.TargetScenario.TargetCostMEK.Weight = i.TargetScenario.TargetCostMEK.Weight ?? i.ReferencceScenario.Weight;
            i.TargetScenario.TargetCostMEK.PerPiece = i.TargetScenario.TargetCostMEK.PerPiece ?? i.ReferencceScenario.MEKsPerPiece;
            i.TargetScenario.TargetCostMEK.PerSystem = i.TargetScenario.TargetCostMEK.PerSystem ?? i.ReferencceScenario.MEKPerSystem;
            i.TargetScenario.ForecastMEK.PerPiece = i.TargetScenario.ForecastMEK.PerPiece ?? i.ReferencceScenario.Forecastperpiece;
            i.TargetScenario.ForecastMEK.PerSystem = i.TargetScenario.ForecastMEK.PerSystem ?? i.ReferencceScenario.MEKPerSystem;
            i.TargetScenario.ForecastMEK.ActualsMEK = i.TargetScenario.ForecastMEK.ActualsMEK ?? i.ReferencceScenario.MEKsPerPiece;
            i.TargetScenario.ForecastMEK.ActualsMEKPerSystem = i.TargetScenario.ForecastMEK.ActualsMEKPerSystem ?? i.ReferencceScenario.MEKPerSystem;
            i.TargetScenario.TargetCostMEK.EQId = i.TargetScenario.TargetCostMEK.EQId ?? 0;
            i.TargetScenario.ForecastMEK.EQId = i.TargetScenario.ForecastMEK.EQId ?? 0;
            i.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = i.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK ?? 0;
            i.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = i.TargetScenario.ForecastMEK.DeltaFCVsRefMEK ?? 0;
            i.TargetScenario.ForecastMEK.DeltaTCVsACT = i.TargetScenario.ForecastMEK.DeltaTCVsACT ?? 0;

            if (this.optAVisible && (i.OptionA == null || i.OptionA?.TargetCostMEK?.EQId == null)) {
              i.OptionA = {
                TargetCostMEK: {
                  EQId: 0,
                  Quantity: i.ReferencceScenario.Quantity,
                  Weight: i.ReferencceScenario.Weight,
                  PerPiece: i.ReferencceScenario.MEKsPerPiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                },
                ForecastMEK: {
                  EQId: 0,
                  PerPiece: i.ReferencceScenario.Forecastperpiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                  ActualsMEK: i.ReferencceScenario.MEKsPerPiece,
                  ActualsMEKPerSystem: i.ReferencceScenario.MEKPerSystem,
                }
              }
            }

            if (this.optBVisible && (i.OptionB == null || i.OptionB?.TargetCostMEK?.EQId == null)) {
              i.OptionB = {
                TargetCostMEK: {
                  EQId: 0,
                  Quantity: i.ReferencceScenario.Quantity,
                  Weight: i.ReferencceScenario.Weight,
                  PerPiece: i.ReferencceScenario.MEKsPerPiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                },
                ForecastMEK: {
                  EQId: 0,
                  PerPiece: i.ReferencceScenario.Forecastperpiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                  ActualsMEK: i.ReferencceScenario.MEKsPerPiece,
                  ActualsMEKPerSystem: i.ReferencceScenario.MEKPerSystem,
                }
              }
            }

            if (this.optCVisible && (i.OptionC == null || i.OptionC?.TargetCostMEK?.EQId == null)) {
              i.OptionC = {
                TargetCostMEK: {
                  EQId: 0,
                  Quantity: i.ReferencceScenario.Quantity,
                  Weight: i.ReferencceScenario.Weight,
                  PerPiece: i.ReferencceScenario.MEKsPerPiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                },
                ForecastMEK: {
                  EQId: 0,
                  PerPiece: i.ReferencceScenario.Forecastperpiece,
                  PerSystem: i.ReferencceScenario.MEKPerSystem,
                  ActualsMEK: i.ReferencceScenario.MEKsPerPiece,
                  ActualsMEKPerSystem: i.ReferencceScenario.MEKPerSystem,
                }
              }
            }
          }

          for (let i of this.TCEQTargetCostSummaries) {
            if (i.TargetScenario == null) {
              i.TargetScenario = {
                TargetCost: {
                  Id: 0,
                  PerSystem: i.ReferenceScenario.PerSystem
                },
                Forecast: {
                  Id: 0,
                  PerSystem: i.ReferenceScenario.PerSystem,
                  ActualMEKs: i.ReferenceScenario.PerSystem
                }
              }
            }
          }
          // this.gridData.forEach(d => {
          //   if (d.Assembly === 'Image System') {
          //     d['isDisplayAssembly'] = false;
          //   }
          //   else {
          //     d['isDisplayAssembly'] = true;
          //   }
          // });
          this.masterGridData = [...this.gridData];
          this.gridData = this.gridData.filter(ele => ele.IsDisplayAssembly);
          // console.log("Loaded Grid Data: ", this.gridData);
          this.loadConfigGridStructureSummary();
          this.loadRefGridStructureSummary();
          this.loadTarGridStructureSummary();
          this.loadOptAGridStructureSummary();
          this.loadOptBGridStructureSummary();
          this.loadOptCGridStructureSummary();
          this.loadConfigurationGridStructure();
          this.loadRefGridStructure();
          this.loadTarGridStructure();
          this.loadOptAGridStructure();
          this.loadOptBGridStructure();
          this.loadOptCGridStructure();
          this.showGrid = true;
          // this.syncSimulationAssembliesWithReference();
        } else {
          //Show errorCode and errorMessage in the UI
          this.showGrid = true;
          let errorContainer = [
            { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer);
        }
      },
      error: err => {
        this.showGrid = true;
      }
    });
  }

  canSave(): boolean {
    // Must be locked by current user
    if (!this.lockStatusInfo?.isLocked || this.lockStatusInfo.lockedByUserId !== this.userInOrg?.UserId) {
      return false;
    }
    // Check all grids for at least one record with IsReadOrWriteAccess
    const hasAccess = (arr: any[]) => Array.isArray(arr) && arr.some(row => row.IsReadOrWriteAccess);
    return (
      hasAccess(this.gridData)
    );
  }


  private filterSummaryRowsForMinorAccess(summaryRows: any[]): any[] {
    if (!this.HasMinorAccess) return summaryRows;
    // Hide rows by Description
    return summaryRows.filter(row =>
      !["Price", "Margin in %", "therein Labour"].includes(row.Description)
    );
  }

  addNewRow() {
    let txtOption = "";
    if (this.optAVisible == true && this.optBVisible == true && this.optCVisible == false) {      
      txtOption = "OptionC";
      this.eqtargetcostingService.getOptionDatafromSCM(this.configurationId, txtOption).subscribe(d => {
        this.scmOptionData = d.Data;

        this.optCVisible = true;
        for (let i of this.gridData) {
          i.OptionC = {
            TargetCostMEK: {
              EQId: 0,
              Quantity: i.ReferencceScenario.Quantity,
              Weight: i.ReferencceScenario.Weight,
              PerPiece: i.ReferencceScenario.MEKsPerPiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
            },
            ForecastMEK: {
              EQId: 0,
              PerPiece: i.ReferencceScenario.Forecastperpiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
              ActualsMEK: i.ReferencceScenario.MEKPerSystem,
              // ActualsMEKPerSystem: i.ReferencceScenario.MEKPerSystem,
            }
          }
        }
        for (let i of this.gridDataSummary) {
          i.OptionC = {
            TargetCost: {
              Id: 0,
              PerSystem: i.ReferenceScenario.PerSystem
            },
            Forecast: {
              Id: 0,
              PerSystem: i.ReferenceScenario.PerSystem,
              ActualMEKs: i.ReferenceScenario.PerSystem
            }
          }
        }

        if (this.scmOptionData[0] != 0 || this.scmOptionData[1] != 0 || this.scmOptionData[2] != 0) {
          let data = this.gridDataSummary.find(x => x.Name == "Labour");
          data.OptionC.TargetCost.PerSystem = this.scmOptionData[0];
          data.OptionC.Forecast.PerSystem = this.scmOptionData[1];
          data.OptionC.Forecast.ActualMEKs = this.scmOptionData[2];
        }

        this.firstLoadMap['optCGrid'] = false;

        setTimeout(() => {
          let model = {
            Name: { values: ['CRP', 'BK', 'Margin', 'TotalBK', 'Overhead', 'Labour', 'MEKMEKDelta', 'MEKTotal', 'MEKOverhead', 'MEKLabour', 'MEKMEKTotal', 'DeltaBK'], filterType: 'set', type: 'notEqual' }
          };

          this.optCSummaryGridApi.setFilterModel(model);
          this.optCSummaryGridApi.onFilterChanged();
          this.optCSummaryGridApi.redrawRows();
        }, 100);
      });
    }
    if (this.optAVisible == true && this.optBVisible == false) {     
      txtOption = "OptionB";
      this.eqtargetcostingService.getOptionDatafromSCM(this.configurationId, txtOption).subscribe(d => {
        this.scmOptionData = d.Data;

        this.optBVisible = true;
      for (let i of this.gridData) {
        if (i.OptionB == null) {
          i.OptionB = {
            TargetCostMEK: {
              EQId: 0,
              Quantity: i.ReferencceScenario.Quantity,
              Weight: i.ReferencceScenario.Weight,
              PerPiece: i.ReferencceScenario.MEKsPerPiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
            },
            ForecastMEK: {
              EQId: 0,
              PerPiece: i.ReferencceScenario.Forecastperpiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
              ActualsMEK: i.ReferencceScenario.MEKPerSystem,
            }
          }
        }
      }
      for (let i of this.gridDataSummary) {
        i.OptionB = {
          TargetCost: {
            Id: 0,
            PerSystem: i.ReferenceScenario.PerSystem
          },
          Forecast: {
            Id: 0,
            PerSystem: i.ReferenceScenario.PerSystem,
            ActualMEKs: i.ReferenceScenario.PerSystem
          }
        }
      }

      if (this.scmOptionData[0] != 0 || this.scmOptionData[1] != 0 || this.scmOptionData[2] != 0) {
        let data = this.gridDataSummary.find(x => x.Name == "Labour");
        data.OptionB.TargetCost.PerSystem = this.scmOptionData[0];
        data.OptionB.Forecast.PerSystem = this.scmOptionData[1];
        data.OptionB.Forecast.ActualMEKs = this.scmOptionData[2];
      }

      this.firstLoadMap['optBGrid'] = false;
      setTimeout(() => {
        let model = {
          Name: { values: ['CRP', 'BK', 'Margin', 'TotalBK', 'Overhead', 'Labour', 'MEKMEKDelta', 'MEKTotal', 'MEKOverhead', 'MEKLabour', 'MEKMEKTotal', 'DeltaBK'], filterType: 'set', type: 'notEqual' }
        };

        this.optBSummaryGridApi.setFilterModel(model);
        this.optBSummaryGridApi.onFilterChanged();
        this.optBSummaryGridApi.redrawRows();
      }, 100);
      });
    }
    if (this.optBVisible == false) {
      txtOption = "OptionA";
      this.eqtargetcostingService.getOptionDatafromSCM(this.configurationId, txtOption).subscribe(d => {
        this.scmOptionData = d.Data;

        this.optAVisible = true;
        for (let i of this.gridData) {
          i.OptionA = {
            TargetCostMEK: {
              EQId: 0,
              Quantity: i.ReferencceScenario.Quantity,
              Weight: i.ReferencceScenario.Weight,
              PerPiece: i.ReferencceScenario.MEKsPerPiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
            },
            ForecastMEK: {
              EQId: 0,
              PerPiece: i.ReferencceScenario.Forecastperpiece,
              PerSystem: i.ReferencceScenario.MEKPerSystem,
              ActualsMEK: i.ReferencceScenario.MEKPerSystem,
            }
          }
        }
        for (let i of this.gridDataSummary) {
          i.OptionA = {
            TargetCost: {
              Id: 0,
              PerSystem: i.ReferenceScenario.PerSystem
            },
            Forecast: {
              Id: 0,
              PerSystem: i.ReferenceScenario.PerSystem,
              ActualMEKs: i.ReferenceScenario.PerSystem
            }
          }
        }

        if (this.scmOptionData[0] != 0 || this.scmOptionData[1] != 0 || this.scmOptionData[2] != 0) {
          let data = this.gridDataSummary.find(x => x.Name == "Labour");
          data.OptionA.TargetCost.PerSystem = this.scmOptionData[0];
          data.OptionA.Forecast.PerSystem = this.scmOptionData[1];
          data.OptionA.Forecast.ActualMEKs = this.scmOptionData[2];
        }
    
        this.firstLoadMap['optAGrid'] = false;

        setTimeout(() => {
          let model = {
            Name: { values: ['CRP', 'BK', 'Margin', 'TotalBK', 'Overhead', 'Labour', 'MEKMEKDelta', 'MEKTotal', 'MEKOverhead', 'MEKLabour', 'MEKMEKTotal', 'DeltaBK'], filterType: 'set', type: 'notEqual' }
          };

          this.optASummaryGridApi.setFilterModel(model);
          this.optASummaryGridApi.onFilterChanged();
          this.optASummaryGridApi.redrawRows();
        }, 100);
      });
    }
  }

  loadConfigGridStructureSummary() {

    this.configColumnDefsSummary = [
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "Summary",
        field: "Description",
        cellClass: (params) => {
          if (["Overhead", "Labour", "MEKTotal", "MEKOverhead", "MEKLabour", "MEKMEKTotal", "MEKMEKDelta"].includes(params.data.Name)) {
            return "bk-indent"
          }
        },
        cellRenderer: (params) => {
          if (params.value == "BK (bottom-up)" && !this.showAdditionalRows) {
            return `<span class="ag-icon ag-icon-tree-closed" unselectable="on" role="presentation"></span> <span> ${params.value} </span>`;
          } else if (params.value == "BK (bottom-up)" && this.showAdditionalRows) {
            return `<span class="ag-icon ag-icon-tree-open" unselectable="on" role="presentation"></span> <span> ${params.value} </span>`;
          }
          if (params.value == "BK Target" && !this.showAdditionalMEKRows) {
            return `<span class="ag-icon ag-icon-tree-closed" unselectable="on" role="presentation"></span> <span> ${params.value} </span>`;
          } else if (params.value == "BK Target" && this.showAdditionalMEKRows) {
            return `<span class="ag-icon ag-icon-tree-open" unselectable="on" role="presentation"></span> <span> ${params.value} </span>`;
          }
          return params.value
        }
      }
    ];

    this.getRowHeightConfigSummary = 25

    this.configDefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutConfigSummary = "autoHeight";
  }

  ngOnDestroy(): void {
    this.combinedSub?.unsubscribe();
    this.configSub?.unsubscribe();
    this.lockStatusSub?.unsubscribe();
    this.unsavedSub?.unsubscribe();

    // Clear grid API references
    this.refGridApi = null;
    this.configGridApi = null;
    this.tarGridApi = null;
    this.optAGridApi = null;
    this.optBGridApi = null;
    this.optCGridApi = null;

    // Also clear column API references
    this.refGridColumnApi = null;
    this.configGridColumnApi = null;
    this.tarGridColumnApi = null;
    this.optAGridColumnApi = null;
    this.optBGridColumnApi = null;
    this.optCGridColumnApi = null;
  }

  onFirstDataRenderedConfigSummary(params) {
    let model = {
      Name: { values: ['CRP', 'BK', 'Margin', 'TotalBK', 'Overhead', 'Labour', 'MEKTotal', 'MEKOverhead', 'MEKLabour', 'MEKMEKTotal', 'DeltaBK', 'MEKMEKDelta'], filterType: 'set', type: 'notEqual' }
    };

    this.configSummaryGridApi.setFilterModel(model);
    this.configSummaryGridApi.onFilterChanged();

    this.refSummaryGridApi.setFilterModel(model);
    this.refSummaryGridApi.onFilterChanged();

    this.tarSummaryGridApi.setFilterModel(model);
    this.tarSummaryGridApi.onFilterChanged();

    if (this.optAVisible) {
      this.optASummaryGridApi.setFilterModel(model);
      this.optASummaryGridApi.onFilterChanged();
    }

    if (this.optBVisible) {
      this.optBSummaryGridApi.setFilterModel(model);
      this.optBSummaryGridApi.onFilterChanged();
    }

    if (this.optCVisible) {
      this.optCSummaryGridApi.setFilterModel(model);
      this.optCSummaryGridApi.onFilterChanged();
    }
  }

  // Row clicked handler to show the additional rows
  onRowClicked(params) {
    if (params.node.data.Name === 'TotalBK') {
      this.showAdditionalRows = !this.showAdditionalRows;
      this.configSummaryGridApi.redrawRows();

      this.toggleRowVisibility(this.configSummaryGridApi);
      this.toggleRowVisibility(this.refSummaryGridApi);
      this.toggleRowVisibility(this.tarSummaryGridApi);
      if (this.optASummaryGridApi != undefined)
        this.toggleRowVisibility(this.optASummaryGridApi);
      if (this.optBSummaryGridApi != undefined)
        this.toggleRowVisibility(this.optBSummaryGridApi);
      if (this.optCSummaryGridApi != undefined)
        this.toggleRowVisibility(this.optCSummaryGridApi);
    }
    if (params.node.data.Name === 'BK') {
      this.showAdditionalMEKRows = !this.showAdditionalMEKRows;
      this.configSummaryGridApi.redrawRows();

      this.toggleRowVisibility(this.configSummaryGridApi);
      this.toggleRowVisibility(this.refSummaryGridApi);
      this.toggleRowVisibility(this.tarSummaryGridApi);
      if (this.optASummaryGridApi != undefined)
        this.toggleRowVisibility(this.optASummaryGridApi);
      if (this.optBSummaryGridApi != undefined)
        this.toggleRowVisibility(this.optBSummaryGridApi);
      if (this.optCSummaryGridApi != undefined)
        this.toggleRowVisibility(this.optCSummaryGridApi);
    }
  }


  toggleRowVisibility(api) {
    if (this.gridDataSummary) {
      for (let i = 0; i < this.gridDataSummary.length; i++) {
        const rowNode = api.getRowNode(i);
        if (rowNode) {
          // Hide specific rows for minor access
          if (
            this.HasMinorAccess &&
            ["Price", "Margin in %", "therein Labour"].includes(rowNode.data.Description)
          ) {
            rowNode.setRowHeight(0);
          } else if ((!this.showAdditionalMEKRows && i > 3 && i < 8) || (!this.showAdditionalRows && i > 8 && i < 12)) {
            rowNode.setRowHeight(0);
          } else {
            rowNode.setRowHeight(25);
          }
        }
      }
      // After updating the row heights, refresh the rows
      api.onRowHeightChanged();
    }
  }
  onConfigGridReadySummary(params: any) {
    this.configSummaryGridApi = params.api;
    this.configSummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshConfigSummary = 1;

    // // Filter rows for display only
    // const filteredRows = this.filterSummaryRowsForMinorAccess(this.TCEQTargetCostSummaries);
    // this.configSummaryGridApi.setRowData(filteredRows);

    this.toggleRowVisibility(params.api);
    //this.toggleRowVisibilitymek(params.api);
  }

  onConfigRowGroupOpenedSummary(params) {
    let refRow = this.refSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.refSummaryGridApi.setRowNodeExpanded(refRow, params.expanded);

    let tarRow = this.tarSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.tarSummaryGridApi.setRowNodeExpanded(tarRow, params.expanded);

    if (this.optAVisible) {
      let optA = this.optASummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optASummaryGridApi.setRowNodeExpanded(optA, params.expanded);
    }

    if (this.optBVisible) {
      let optB = this.optBSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optBSummaryGridApi.setRowNodeExpanded(optB, params.expanded);
    }

    if (this.optCVisible) {
      let optC = this.optCSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optCSummaryGridApi.setRowNodeExpanded(optC, params.expanded);
    }
  }

  onGridConfigChangedSummary(params) {
    this.configSummaryGridApi = params.api;
    this.configSummaryGridApi.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedConfigSummary(params) {
    if (this.sizeToFitRefreshConfigSummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onConfigCellValueChangedSummary(params) {
  }

  loadRefGridStructureSummary() {
    this.refColumnDefsSummary = [
      // {
      //   field: "rowGroup",
      //   //rowGroup: true,
      //   hide: true,
      // },
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "",
        width: 276
      },
      {
        headerName: "Value",
        field: "ReferenceScenario.PerSystem",
        width: 88,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.Name != "CRP" && params.node.data.Name != "Margin" && params.node.data.Name != "BK")
            return "colorTotal"
        },
        headerTooltip: "Value",
        editable: (params) => {
          if (this.isEditable && !params.node.group && (params.node.data.Name == "CRP" || params.node.data.Name == "Margin" || params.node.data.Name == "BK")) {
            return true;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.ReferenceScenario.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.ReferenceScenario.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overHeadNew = this.CalculateRefOverhead(labor);
              total = overHeadNew + labor + mekTotal;
              params.node.data.ReferenceScenario.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.ReferenceScenario.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.ReferenceScenario.PerSystem);
              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateRefOverhead(labor);
              params.node.data.ReferenceScenario.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.ReferenceScenario.PerSystem;
            }
            return (params.node.data.ReferenceScenario.PerSystem);
          }
        }
      }
    ];

    this.getRowHeightRefSummary = 25

    this.refDefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutRefSummary = "autoHeight";

    this.refSummaryFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
      groupRowInnerRenderer: AddMaterialComponent,
    };
  }

  onRefGridReadySummary(params: any) {
    this.refSummaryGridApi = params.api;
    this.refSummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshRefSummary = 1

    this.toggleRowVisibility(params.api);
    //this.toggleRowVisibilitymek(params.api);

  }

  // calculateMekTotalWithBKFactor(gridData: any[], bkFactorList: any[]): number {
  //   let total = 0;
  //   if (!Array.isArray(gridData) || !Array.isArray(bkFactorList)) return 0;

  //   const uniqueKMATs = Array.from(new Set(gridData.map(row => row.KMATId)));

  //   uniqueKMATs.forEach(kmatId => {
  //     const bkObj = bkFactorList.find(bk => bk.KMATId === kmatId && bk.OverheadCostType === "BK Factor");
  //     const bkFactor = bkObj ? Number(bkObj.FactorValue) : 1;

  //     // Sum MEKTotal for this KMAT group (only active, non-group, non-child rows)
  //     let mekTotalForKMAT = 0;
  //     gridData.forEach(row => {
  //       if (
  //         row.KMATId === kmatId &&
  //         !row.group &&
  //         !row.HasChild &&
  //         (row.IsActive == null || row.IsActive === true)
  //       ) {
  //         mekTotalForKMAT += Number(row.ReferencceScenario?.MEKPerSystem ?? 0);
  //       }
  //     });
  //     // console.log(mekTotalForKMAT);
  //     total += mekTotalForKMAT * (bkFactor - 1);
  //     // console.log(total);
  //   });
  //   return total;
  // }
  // ...existing code...

  calculateMekTotalWithBKFactor(gridData: any[], bkFactorList: any[]): number {
    let total = 0;
    if (!Array.isArray(gridData) || !Array.isArray(bkFactorList)) return 0;

    // Get unique GMK groups (including null/empty)
    const uniqueGMKGroups = Array.from(
      new Set(gridData.map(row => row?.GMKGroup ?? ''))
    );
    uniqueGMKGroups.forEach(gmkGroup => {
      // Find BK factor for this GMK group
      const bkObj = bkFactorList.find(
        bk => (bk?.GMKGroup ?? '') === gmkGroup && bk?.OverheadCostType === "BK Factor"
      );
      const bkFactor = bkObj ? Number(bkObj.FactorValue) : 1;

      // Sum MEKTotal for this GMK group (only active, non-group, non-child rows)
      let mekTotalForGMKGroup = 0;
      gridData.forEach(row => {
        if (
          (row?.GMKGroup ?? '') === gmkGroup &&
          !row?.group &&
          !row?.HasChild &&
          (row?.IsActive == null || row?.IsActive === true)
        ) {
          mekTotalForGMKGroup += Number(row?.ReferencceScenario?.MEKPerSystem ?? 0);
        }
      });

      total += mekTotalForGMKGroup * (bkFactor - 1);
    });

    return total;
  }

  CalculateRefOverhead(labor: number): number {
    // const eqGridData = this.getRefGridData(); // or use this.refGridData if available
    const eqGridData: any[] = [];
    if (this.refGridApi && typeof this.refGridApi.forEachNodeAfterFilter === 'function') {
      this.refGridApi.forEachNodeAfterFilter(node => {
        if (
          !node.group &&
          node.data &&
          !node.data.HasChild &&
          (node.data.IsActive == null || node.data.IsActive == true)
        ) {
          eqGridData.push(node.data);
        }
      });
    }
    //for Reference grid we have to use the actualscretaiondate factor list
    const bkFactorList = this.actualsCreationbkFactorList || [];
    // console.log(bkFactorList);

    // Use the extracted method
    const kmatGroupTotal = this.calculateMekTotalWithBKFactor(eqGridData, bkFactorList);

    // Find FKFactor of leading KMAT
    const leadingKMATObj = bkFactorList.find(bk => bk.OverheadCostType === "FK Factor" && bk.ispimary === true && bk.ismaterialGMK === true);
    const fkFactor = leadingKMATObj ? Number(leadingKMATObj.FactorValue) : 1;

    // Calculate "therein Overhead"
    const thereinOverhead = labor * (fkFactor - 1);

    // console.log(kmatGroupTotal + thereinOverhead);
    return kmatGroupTotal + thereinOverhead;
  }

  CalculateTotalRefOverhead(labor: number): number {
    // const eqGridData = this.getRefGridData(); // or use this.refGridData if available
    const eqGridData: any[] = [];
    if (this.refGridApi && typeof this.refGridApi.forEachNode === 'function') {
      const allRefRows = this.getAllGridDataIncludingHidden(this.refGridApi, this.masterGridData);

      allRefRows.forEach(row => {
        if (
          !row.group &&
          !row.HasChild &&
          (row.IsActive == null || row.IsActive == true)
        ) {
          eqGridData.push(row);
        }
      });
      // this.refGridApi.forEachNode(node => {
      //   if (
      //     !node.group &&
      //     node.data &&
      //     !node.data.HasChild &&
      //     (node.data.IsActive == null || node.data.IsActive == true)
      //   ) {
      //     eqGridData.push(node.data);
      //   }
      // });
    }
    const bkFactorList = this.actualsCreationbkFactorList || [];
    // console.log(bkFactorList);

    // Use the extracted method
    const kmatGroupTotal = this.calculateMekTotalWithBKFactor(eqGridData, bkFactorList);

    // Find FKFactor of leading KMAT
    const leadingKMATObj = bkFactorList.find(bk => bk.OverheadCostType === "FK Factor" && bk.ispimary === true && bk.ismaterialGMK === true);
    const fkFactor = leadingKMATObj ? Number(leadingKMATObj.FactorValue) : 1;

    // Calculate "therein Overhead"
    const thereinOverhead = labor * (fkFactor - 1);

    // console.log(kmatGroupTotal + thereinOverhead);
    return kmatGroupTotal + thereinOverhead;
  }

  // calculateMekTotalWithBKFactorForScenario(gridData: any[], scenario: string, typeOfMEK: string, type: string, bkFactorList: any[]): number {
  //   // console.log(gridData, scenario, typeOfMEK, type);
  //   let total = 0;
  //   if (!Array.isArray(gridData) || !Array.isArray(bkFactorList)) return 0;

  //   const uniqueKMATs = Array.from(new Set(gridData.map(row => row.KMATId)));
  //   // console.log(uniqueKMATs)
  //   // console.log(uniqueKMATs);

  //   uniqueKMATs.forEach(kmatId => {
  //     // console.log(kmatId)
  //     const bkObj = bkFactorList.find(bk => bk.KMATId === kmatId && bk.OverheadCostType === "BK Factor");
  //     const bkFactor = bkObj ? Number(bkObj.FactorValue) : 1;

  //     // Sum MEKTotal for this KMAT group (only active, non-group, non-child rows)
  //     let mekTotalForKMAT = 0;
  //     gridData.forEach(row => {
  //       if (
  //         row.KMATId === kmatId &&
  //         !row.group &&
  //         !row.HasChild &&
  //         (row.IsActive == null || row.IsActive === true)
  //       ) {
  //         mekTotalForKMAT += Number(row[scenario]?.[typeOfMEK]?.[type] ?? 0);
  //       }
  //     });
  //     // console.log(mekTotalForKMAT);
  //     total += mekTotalForKMAT * (bkFactor - 1);
  //   });
  //   // console.log(total);
  //   return total;
  // }

  calculateMekTotalWithBKFactorForScenario(
    gridData: any[],
    scenario: string,
    typeOfMEK: string,
    type: string,
    bkFactorList: any[]
  ): number {
    let total = 0;
    if (!Array.isArray(gridData) || !Array.isArray(bkFactorList)) return 0;

    // Unique GMK groups (includes null/undefined as '')
    const uniqueGMKGroups = Array.from(
      new Set(gridData.map(row => row?.GMKGroup ?? ''))
    );

    uniqueGMKGroups.forEach(gmkGroup => {
      // BK factor for same GMK group
      const bkObj = bkFactorList.find(
        bk => (bk?.GMKGroup ?? '') === gmkGroup && bk?.OverheadCostType === "BK Factor"
      );
      const bkFactor = bkObj ? Number(bkObj.FactorValue) : 1;

      // Sum MEK total for this GMK group
      let mekTotalForGMKGroup = 0;
      gridData.forEach(row => {
        if (
          (row?.GMKGroup ?? '') === gmkGroup &&
          !row?.group &&
          !row?.HasChild &&
          (row?.IsActive == null || row?.IsActive === true)
        ) {
          mekTotalForGMKGroup += Number(row?.[scenario]?.[typeOfMEK]?.[type] ?? 0);
        }
      });

      total += mekTotalForGMKGroup * (bkFactor - 1);
    });

    return total;
  }

  CalculateScenarioOverhead(labor: number, scenario: string, typeOfMEK: string, type: string): number {
    // console.log("InCalculateOverhead Method")
    // const eqGridData = this.getRefGridData(); // or use this.refGridData if available
    let gridApi: any;
    switch (scenario) {
      case 'TargetScenario':
        gridApi = this.tarGridApi;
        break;
      case 'OptionA':
        gridApi = this.optAGridApi;
        break;
      case 'OptionB':
        gridApi = this.optBGridApi;
        break;
      case 'OptionC':
        gridApi = this.optCGridApi;
        break;
      default:
        gridApi = this.tarGridApi; // fallback
    }
    const eqGridData: any[] = [];
    if (gridApi && typeof gridApi.forEachNodeAfterFilter === 'function') {
      gridApi.forEachNodeAfterFilter(node => {
        if (
          !node.group &&
          node.data &&
          !node.data.HasChild &&
          (node.data.IsActive == null || node.data.IsActive == true)
        ) {
          eqGridData.push(node.data);
        }
      });
    }
    // const bkFactorList = this.bkFactorList || [];
    let bkFactorList: any[];
    if (type === 'ActualsMEKPerSystem' && typeOfMEK === 'ForecastMEK') {
      bkFactorList = this.bkFactorList || [];
    }
    else {
      bkFactorList = this.M300bkFactorList || [];
    }
    // Use the extracted method
    const kmatGroupTotal = this.calculateMekTotalWithBKFactorForScenario(eqGridData, scenario, typeOfMEK, type, bkFactorList);

    // Find FKFactor of leading KMAT
    const leadingKMATObj = bkFactorList.find(bk => bk.OverheadCostType === "FK Factor" && bk.ispimary === true && bk.ismaterialGMK === true);
    const fkFactor = leadingKMATObj ? Number(leadingKMATObj.FactorValue) : 1;

    // Calculate "therein Overhead"
    const thereinOverhead = labor * (fkFactor - 1);

    return kmatGroupTotal + thereinOverhead;
  }

  CalculateTotalScenarioOverhead(labor: number, scenario: string, typeOfMEK: string, type: string): number {
    // console.log("InCalculateOverhead Method")
    // const eqGridData = this.getRefGridData(); // or use this.refGridData if available
    let gridApi: any;
    switch (scenario) {
      case 'TargetScenario':
        gridApi = this.tarGridApi;
        break;
      case 'OptionA':
        gridApi = this.optAGridApi;
        break;
      case 'OptionB':
        gridApi = this.optBGridApi;
        break;
      case 'OptionC':
        gridApi = this.optCGridApi;
        break;
      default:
        gridApi = this.tarGridApi; // fallback
    }
    const eqGridData: any[] = [];
    if (gridApi && typeof gridApi.forEachNode === 'function') {
      // gridApi.forEachNode(node => {
      //   if (
      //     !node.group &&
      //     node.data &&
      //     !node.data.HasChild &&
      //     (node.data.IsActive == null || node.data.IsActive == true)
      //   ) {
      //     eqGridData.push(node.data);
      //   }
      // });
      const allRows = this.getAllGridDataIncludingHidden(gridApi, this.masterGridData);
      allRows.forEach(row => {
        if (
          !row.group &&
          !row.HasChild &&
          (row.IsActive == null || row.IsActive == true)
        ) {
          eqGridData.push(row);
        }
      });
    }
    // const bkFactorList = this.bkFactorList || [];
    let bkFactorList: any[];
    if (type === 'ActualsMEKPerSystem' && typeOfMEK === 'ForecastMEK') {
      bkFactorList = this.bkFactorList || [];
    }
    else {
      bkFactorList = this.M300bkFactorList || [];
    }

    // Use the extracted method
    const kmatGroupTotal = this.calculateMekTotalWithBKFactorForScenario(eqGridData, scenario, typeOfMEK, type, bkFactorList);

    // Find FKFactor of leading KMAT
    const leadingKMATObj = bkFactorList.find(bk => bk.OverheadCostType === "FK Factor" && bk.ispimary === true && bk.ismaterialGMK === true);
    const fkFactor = leadingKMATObj ? Number(leadingKMATObj.FactorValue) : 1;

    // Calculate "therein Overhead"
    const thereinOverhead = labor * (fkFactor - 1);

    return kmatGroupTotal + thereinOverhead;
  }

  // CalculateOverhead(labor: number): number {
  //   console.log(this.bkFactorValue, this.fkFactorValue)
  //   // 1. Gather grid data and BKFactor list
  //   const eqGridData = this.getRefGridData(); // or use this.refGridData if available
  //   const bkFactorList = this.bkFactorValue || [];

  //   // 2. Calculate sum of all KMAT group totals with BKFactor
  //   let kmatGroupTotal = 0;
  //   const uniqueKMATs = Array.from(new Set(eqGridData.map(row => row.KMATId)));

  //   uniqueKMATs.forEach(kmatId => {
  //     // Find BKFactor for this KMAT
  //     const bkObj = bkFactorList.find(bk => bk.KMATId === kmatId);
  //     const bkFactor = bkObj ? Number(bkObj.BKFactor) : 1;

  //     // Sum MEKTotal for this KMAT group (only active, non-group, non-child rows)
  //     let mekTotalForKMAT = 0;
  //     eqGridData.forEach(row => {
  //       if (
  //         row.KMATId === kmatId &&
  //         !row.group &&
  //         !row.HasChild &&
  //         (row.IsActive == null || row.IsActive === true)
  //       ) {
  //         mekTotalForKMAT += Number(row.ReferencceScenario?.MEKPerSystem ?? 0);
  //       }
  //     });

  //     kmatGroupTotal += mekTotalForKMAT * bkFactor;
  //   });

  //   // 3. Find FKFactor of leading KMAT
  //   const leadingKMATObj = bkFactorList.find(bk => bk.LeadingKMAT);
  //   const fkFactor = leadingKMATObj ? Number(leadingKMATObj.FKFactor) : 1;

  //   // 4. Calculate "therein Overhead"
  //   const thereinOverhead = labor * fkFactor;

  //   // 5. Optionally, calculate MEKTotalPerSystem
  //   // const mekTotalPerSystem = labor + kmatGroupTotal;

  //   // 6. Return the sum (you can adjust what you want to return)
  //   // If you want only the overhead, return thereinOverhead
  //   // If you want total overhead including KMAT group, return kmatGroupTotal + thereinOverhead
  //   return kmatGroupTotal + thereinOverhead;
  // }

  onRefRowGroupOpenedSummary(params) {
    let configRow = this.configSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.configSummaryGridApi.setRowNodeExpanded(configRow, params.expanded);

    let tarRow = this.tarSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.tarSummaryGridApi.setRowNodeExpanded(tarRow, params.expanded);

    if (this.optAVisible) {
      let optA = this.optASummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optASummaryGridApi.setRowNodeExpanded(optA, params.expanded);
    }

    if (this.optBVisible) {
      let optB = this.optBSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optBSummaryGridApi.setRowNodeExpanded(optB, params.expanded);
    }

    if (this.optCVisible) {
      let optC = this.optCSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optCSummaryGridApi.setRowNodeExpanded(optC, params.expanded);
    }
  }

  onGridRefChangedSummary(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedRefSummary(params) {
    if (this.sizeToFitRefreshRefSummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  toggleRefGrid() {
    this.refGridOpened = !this.refGridOpened;
  }

  // getGridWidth(): number {
  //   //   if (this.refGridOpened && this.tarGridOpened) {
  //   //     return 800;

  //    if (this.tarGridOpened) {
  //         850 
  //     } else {
  //        number(calc(100vw - 300));
  //     }
  //   }

  getsummaryGridWidthA(): string {
    if (this.optAVisible) {
      if (this.tarGridOpened && this.refGridOpened && this.optAGridOpened) {
        return '850px';
      } else if (this.tarGridOpened && !this.refGridOpened && this.optAGridOpened) {
        return 'calc(100vw - 650px - 280px )';
      }
      else if (this.refGridOpened && !this.tarGridOpened && this.optAGridOpened) {

        return 'calc(100vw - 300px - 280px)';
      }
      else if (!this.refGridOpened && !this.tarGridOpened && !this.optAGridOpened) {

        return 'calc(100vw - 650px )';
      }
      else if (this.refGridOpened && this.tarGridOpened && !this.optAGridOpened) {

        return 'calc(100vw - 650px - 280px)';
      }
    }
    if (this.optBVisible) {
      if (this.tarGridOpened && this.refGridOpened && this.optBGridOpened) {
        return '850px';
      } else if (this.tarGridOpened && !this.refGridOpened && this.optBGridOpened) {
        return 'calc(100vw - 650px - 280px )';
      }
      else if (this.refGridOpened && !this.tarGridOpened && this.optBGridOpened) {

        return 'calc(100vw - 300px - 280px)';
      }
      else if (!this.refGridOpened && !this.tarGridOpened && !this.optBGridOpened) {

        return 'calc(100vw - 650px )';
      }
      else if (this.refGridOpened && this.tarGridOpened && !this.optBGridOpened) {

        return 'calc(100vw - 650px - 280px)';
      }
    }
    if (this.optCVisible) {
      if (this.tarGridOpened && this.refGridOpened && this.optCGridOpened) {
        return '850px';
      } else if (this.tarGridOpened && !this.refGridOpened && this.optCGridOpened) {
        return 'calc(100vw - 650px - 280px )';
      }
      else if (this.refGridOpened && !this.tarGridOpened && this.optCGridOpened) {

        return 'calc(100vw - 300px - 280px)';
      }
      else if (!this.refGridOpened && !this.tarGridOpened && !this.optCGridOpened) {

        return 'calc(100vw - 650px )';
      }
      else if (this.refGridOpened && this.tarGridOpened && !this.optCGridOpened) {

        return 'calc(100vw - 650px - 280px)';
      }
    }
    else {
      if (this.tarGridOpened && this.refGridOpened && this.optAGridOpened && this.optBGridOpened && this.optCGridOpened) {
        return '850px';
      } else if (this.tarGridOpened && !this.refGridOpened && this.optAGridOpened && this.optBGridOpened && this.optCGridOpened) {
        return 'calc(100vw - 650px - 280px )';
      }
      else if (this.refGridOpened && !this.tarGridOpened && this.optAGridOpened && this.optBGridOpened && this.optCGridOpened) {

        return 'calc(100vw - 300px - 280px)';
      }
      else if (!this.refGridOpened && !this.tarGridOpened && this.optAGridOpened && this.optBGridOpened && this.optCGridOpened) {
        return 'calc(100vw - 650px )';
      }
    }
  }

  getsummaryGridWidth(): string {
    const configGridBaseWidth = 1100;
    const refGridBaseWidth = 300;
    const tarGridBaseWidth = 500;
    const optGridBaseWidth = 650;
    const collapsedGridWidth = 40;
    const fixedMargin = 280;

    const refWidth = this.refGridOpened ? refGridBaseWidth : collapsedGridWidth;
    const tarWidth = this.tarGridOpened ? tarGridBaseWidth : collapsedGridWidth;

    const optAWidth = this.optAVisible && this.optAGridOpened ? optGridBaseWidth : collapsedGridWidth;
    const optBWidth = this.optBVisible && this.optBGridOpened ? optGridBaseWidth : collapsedGridWidth;
    const optCWidth = this.optCVisible && this.optCGridOpened ? optGridBaseWidth : collapsedGridWidth;

    const totalOccupiedWidth = refWidth + tarWidth + optAWidth + optBWidth + optCWidth;

    const viewportWidth = window.innerWidth;

    let configWidth = viewportWidth - fixedMargin - totalOccupiedWidth;

    if (configWidth < configGridBaseWidth) {
      configWidth = configGridBaseWidth;
    }

    return `${configWidth}px`;
  }



  toggleTarGrid() {
    this.tarGridOpened = !this.tarGridOpened;
  }

  toggleOptAGrid() {
    if (this.optAVisible) {
      this.optAGridOpened = !this.optAGridOpened;
    }
  }

  toggleOptBGrid() {
    if (this.optBVisible) {
      this.optBGridOpened = !this.optBGridOpened;
    }
  }

  toggleOptCGrid() {
    if (this.optCVisible) {
      this.optCGridOpened = !this.optCGridOpened;
    }
  }

  onRefCellValueChangedSummary(params) {
    this.hasUnsavedChanges = true;
    if (params.colDef.field === "ReferenceScenario.PerSystem" && params.data.Description === "therein Labour" && params.data.Name === "Labour") {
      // Find the corresponding simulation data for this assembly
      if (this.TCSimulationData) {
        this.IsSimulationDataModified = true;
        this.TCSimulationData.forEach(simulation => {
          if (simulation.Name === 'Labour' && simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
            simulation.CostValue = Number(params.data.ReferenceScenario.PerSystem).toFixed(0);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Labour' && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - params.data.ReferenceScenario.PerSystem) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Labour' && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - params.data.ReferenceScenario.PerSystem) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Labour' && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - params.data.ReferenceScenario.PerSystem) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Labour' && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - params.data.ReferenceScenario.PerSystem) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
        });

        let mekTotal = 0;
        this.refGridApi.forEachNode(node => {
          if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
            mekTotal += Number(node.data.ReferencceScenario.MEKPerSystem)
          }
        });

        // const updatedOverhead =
        //   mekTotal * (Number(this.bkFactorValue ?? 1) - 1) +
        //   Number(params.data.ReferenceScenario.PerSystem) * (Number(this.fkFactorValue ?? 1) - 1);

        const updatedOverhead = this.CalculateRefOverhead(Number(params.data.ReferenceScenario.PerSystem));

        // console.log(this.refSummaryGridApi.getDisplayedRowAtIndex(7));
        // const updatedOverhead = this.refSummaryGridApi.getDisplayedRowAtIndex(7).data.ReferenceScenario.PerSystem;
        this.TCSimulationData.forEach(simulation => {
          if (simulation.Name === 'Overhead' && simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
            simulation.CostValue = Number(updatedOverhead).toFixed(0);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Overhead' && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
          if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
            simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
            simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
            simulation.UserId = this.userInOrg.UserId;
          }
        });
      }
      this.updateSummaryRowsInSimulationData();
      // console.log("Refcellvalue changed summary")
    }
  }

  loadTarGridStructureSummary() {
    this.tarColumnDefsSummary = [
      {
        field: "rowGroup",
        //rowGroup: true,
        hide: true,
      },
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "",
        width: 180
      },
      {
        headerName: "Value",
        field: "TargetScenario.TargetCost.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (this.isEditable && !params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            // console.log(params)
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.TargetCost.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.TargetCost.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overHeadNew = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'TargetCostMEK', 'PerSystem');

              total = overHeadNew + labor + mekTotal;
              params.node.data.TargetScenario.TargetCost.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.TargetCost.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.TargetCost.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'TargetCostMEK', 'PerSystem');
              params.node.data.TargetScenario.TargetCost.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.TargetScenario.TargetCost.PerSystem;
            }
            //Calculate the "DeltaBK" by subtracting the "TotalBK" to "BK"
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.TargetScenario.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.TargetScenario.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.TargetScenario.TargetCost.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });
              const scenarioValue = calcScenarioRow?.data?.TargetScenario?.TargetCost?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.TargetScenario.TargetCost.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.TargetScenario?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.TargetScenario?.TargetCost?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.TargetScenario?.TargetCost?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.TargetScenario?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.TargetScenario.TargetCost.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.TargetScenario.TargetCost.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "tc",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return {
              component: 'EditEqCalcComponent',
              params: {
                onOpened: () => { this.hasUnsavedChanges = true; }
              }
            }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                  getOverheadData: () => this.getOverheadData()
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "TargetScenario.Forecast.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal";
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (!params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.Forecast.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'PerSystem');
              total = overheadNew + labor + mekTotal;
              params.node.data.TargetScenario.Forecast.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.Forecast.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'PerSystem');
              params.node.data.TargetScenario.Forecast.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.TargetScenario.Forecast.PerSystem;
            }
            //Calculate the "DeltaBK" by subtracting the "TotalBK" to "BK"
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.TargetScenario.Forecast.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.TargetScenario.Forecast.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.TargetScenario.Forecast.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.TargetScenario?.Forecast?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.TargetScenario.Forecast.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.TargetScenario?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.TargetScenario?.Forecast?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.TargetScenario?.Forecast?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.TargetScenario?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.TargetScenario.Forecast.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.TargetScenario.Forecast.PerSystem);
          }
        }
      },
      {
        field: "fc",
        headerName: "",
        width: 130,
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return {
              component: 'EditEqCalcComponent',
              params: {
                onOpened: () => { this.hasUnsavedChanges = true; }
              }
            }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                  getOverheadData: () => this.getOverheadData()
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "TargetScenario.Forecast.ActualMEKs",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group && !["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            if (params.data.Name === "DeltaBK") {
              if (params.value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal";
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          if (!params.node.group && ["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            return true;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.ActualMEKs);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.Forecast.ActualMEKs;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'ActualsMEKPerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.TargetScenario.Forecast.ActualMEKs = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.TargetScenario.Forecast.ActualMEKs;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.ActualMEKs);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'ActualsMEKPerSystem');
              params.node.data.TargetScenario.Forecast.ActualMEKs = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.TargetScenario.Forecast.ActualMEKs;
            }
            // if (params.node.data.Name === "DeltaBK") {
            //   let value = 0;
            //   let bk = params.api.getRowNode(3).data.TargetScenario.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(3));
            //   let totalBk = params.api.getRowNode(7).data.TargetScenario.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(7));
            //   value = Number(totalBk) - Number(bk);
            //   params.node.data.TargetScenario.Forecast.ActualMEKs = value.toFixed(0);
            //   return value;
            //   // params.api.forEachNode((node) => { 
            //   //   // console.log(node);
            //   //   if(node.data.Name == "BK")
            //   //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
            //   //   if(node.data.Name == "TotalBK")
            //   //     console.log(node.data.TargetScenario.TargetCost.PerSystem);
            //   // });
            // }
            return (params.node.data.TargetScenario.Forecast.ActualMEKs);
          }
        }
      },
      {
        headerName: "",
        width: 50
      }
    ];

    this.getRowHeightTarSummary = 25

    this.tarDefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutTarSummary = "autoHeight";

    this.tarSummaryFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  getRefGridData(): any[] {
    if (!this.refGridApi || typeof this.refGridApi.forEachNode !== 'function') {
      return [];
    }
    const data: any[] = [];
    const allRefRows = this.getAllGridDataIncludingHidden(this.refGridApi, this.masterGridData);
    allRefRows.forEach((row) => {
      if (row) data.push(row);
    });
    return data;
  }

  //pass the SimulationData 
  getSimulationData(): any[] {
    this.IsSimulationDataModified = true;
    return this.TCSimulationData || [];
  }

  getOverheadData() {
    // let mekTotal = 0;
    // this.refGridApi.forEachNode(node => {
    //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
    //     mekTotal += Number(node.data.ReferencceScenario.MEKPerSystem)
    //   }
    // });

    let thereInLabour = this.refSummaryGridApi.getDisplayedRowAtIndex(9).data.ReferenceScenario.PerSystem;
    // this.refSummaryGridApi.forEachNode(node => {
    //   if(node.data.Name === "Labour" && node.data.Description === "therein Labour"){
    //   }
    // });

    // const updatedOverhead =
    //   mekTotal * (Number(this.bkFactorValue ?? 1) - 1) +
    //   Number(thereInLabour) * (Number(this.fkFactorValue ?? 1) - 1);

    const updatedOverhead = this.CalculateRefOverhead(Number(thereInLabour));

    return updatedOverhead;
  }

  onSimulationDataUpdate = (updatedSimulationData: any[]) => {
    this.TCSimulationData = updatedSimulationData;
    this.updateSummaryRowsInSimulationData();
    this.hasUnsavedChanges = true;
    this.IsSimulationDataModified = true;
    this.tarSummaryGridApi?.refreshCells({ force: true });
    // Any additional logic you want, e.g. refresh grid, mark as dirty, etc.
  };

  syncSimulationAssembliesWithReference() {
    if (this.TCSimulationData.length == 0) return;
    if (this.TCSimulationData.length > 0) {
      const simulationData = this.TCSimulationData || [];
      const referenceGridData = this.getRefGridData();

      // Get assemblies from reference grid
      const referenceAssemblies = Array.from(
        new Set(referenceGridData.map(row => row.Assembly))
      );

      // Get assemblies from simulation data
      const simulationAssemblies = simulationData
        .map(row => row.Name)
        .filter(a => !["Total", "Overhead", "Labour", "Assembly group"].includes(a));

      // console.log(referenceAssemblies, simulationAssemblies);

      // Detect which scenario types exist in simulation data
      const scenarioTypes = ["OptionA", "OptionB", "OptionC"].filter(
        scenario => simulationData.some(row => row.ScenarioType === scenario)
      );

      // 1. Update cost value for assemblies present in both
      referenceAssemblies.forEach(refAssembly => {
        const refCostValue = this.getTotalMEKPerSystemForAssembly(referenceGridData, refAssembly);

        simulationData.forEach(simRow => {
          if (simRow.Name === refAssembly && simRow.ScenarioType === "Reference" && simRow.TypeOfCost === "Actuals") {
            simRow.CostValue = refCostValue;
            simRow.IsActive = true;
          }
          if (simRow.Name === refAssembly && simRow.ScenarioType === "Target" && simRow.TypeOfCost === "Target") {
            // simRow.CostValue = refCostValue;
            simRow.PercentageChange = simRow.CostValue === 0 ? 0 : ((simRow.CostValue - refCostValue) / simRow.CostValue) * 100;
            simRow.PercentageChange = Number(simRow.PercentageChange).toFixed(2);
            simRow.IsActive = true;
          }

          // OptionA/B/C rows: update PercentageChange if needed
          scenarioTypes.forEach(scenario => {
            if (simRow.Name === refAssembly && simRow.ScenarioType === scenario && simRow.TypeOfCost === "Target") {
              simRow.PercentageChange = simRow.CostValue === 0 ? 0 : ((simRow.CostValue - refCostValue) / simRow.CostValue) * 100;
              simRow.PercentageChange = Number(simRow.PercentageChange).toFixed(2);
              simRow.IsActive = true;
            }
          });

        });
      });

      // 2. Add new assemblies from reference grid to simulationData
      referenceAssemblies.forEach(refAssembly => {
        if (!simulationAssemblies.includes(refAssembly)) {
          // Reference row
          const referenceCostValue = this.getTotalMEKPerSystemForAssembly(referenceGridData, refAssembly);
          simulationData.push({
            Id: 0,
            ConfigurationId: this.configurationId,
            Name: refAssembly,
            ScenarioType: "Reference",
            TypeOfCost: "Actuals",
            CostValue: referenceCostValue,
            PercentageChange: 0,
            IsActive: true,
            UserId: this.userInOrg.UserId,
            IsNewAndUnconfirmed: true,
          });

          // Helper to calculate percentage change
          const calcPercentageChange = (costValue: number) =>
            costValue !== 0
              ? Number((((costValue - referenceCostValue) / costValue) * 100).toFixed(2))
              : 0;

          // Target row
          const targetCostValue = this.getGroupedDataByAssemblyForScenario(referenceGridData, "TargetScenario", "TargetCostMEK")
            .find(t => t.Assembly === refAssembly)?.TotalMEKPerSystem || 0;
          simulationData.push({
            Id: 0,
            Name: refAssembly,
            ConfigurationId: this.configurationId,
            ScenarioType: "Target",
            TypeOfCost: "Target",
            CostValue: targetCostValue,
            PercentageChange: calcPercentageChange(targetCostValue),
            IsActive: true,
            UserId: this.userInOrg.UserId,
            IsNewAndUnconfirmed: true,
          });

          // Forecast row for Target scenario
          const forecastCostValue = this.getGroupedDataByAssemblyForScenario(referenceGridData, "TargetScenario", "ForecastMEK")
            .find(t => t.Assembly === refAssembly)?.TotalMEKPerSystem || 0;
          simulationData.push({
            Id: 0,
            Name: refAssembly,
            ConfigurationId: this.configurationId,
            ScenarioType: "Target",
            TypeOfCost: "Forecast",
            CostValue: forecastCostValue,
            PercentageChange: calcPercentageChange(forecastCostValue),
            IsActive: true,
            UserId: this.userInOrg.UserId,
            IsNewAndUnconfirmed: true,
          });

          // Add rows for all scenarioTypes (e.g. OptionA, OptionB, OptionC) for both Target and Forecast
          scenarioTypes.forEach(scenario => {
            // Target
            const optionTargetCostValue = this.getGroupedDataByAssemblyForScenario(referenceGridData, scenario, "TargetCostMEK")
              .find(t => t.Assembly === refAssembly)?.TotalMEKPerSystem || 0;
            simulationData.push({
              Id: 0,
              Name: refAssembly,
              ConfigurationId: this.configurationId,
              ScenarioType: scenario,
              TypeOfCost: "Target",
              CostValue: optionTargetCostValue,
              PercentageChange: calcPercentageChange(optionTargetCostValue),
              IsActive: true,
              UserId: this.userInOrg.UserId,
              IsNewAndUnconfirmed: true,
            });
            // Forecast
            const optionForecastCostValue = this.getGroupedDataByAssemblyForScenario(referenceGridData, scenario, "ForecastMEK")
              .find(t => t.Assembly === refAssembly)?.TotalMEKPerSystem || 0;
            simulationData.push({
              Id: 0,
              Name: refAssembly,
              ConfigurationId: this.configurationId,
              ScenarioType: scenario,
              TypeOfCost: "Forecast",
              CostValue: optionForecastCostValue,
              PercentageChange: calcPercentageChange(optionForecastCostValue),
              IsActive: true,
              UserId: this.userInOrg.UserId,
              IsNewAndUnconfirmed: true,
            });
          });
        }
      });
      // referenceAssemblies.forEach(refAssembly => {
      //   if (!simulationAssemblies.includes(refAssembly)) {
      //     // Add Reference row
      //     simulationData.push({
      //       Id: 0,
      //       ConfigurationId: this.configurationId,
      //       Name: refAssembly,
      //       ScenarioType: "Reference",
      //       TypeOfCost: "Actuals",
      //       CostValue: this.getTotalMEKPerSystemForAssembly(referenceGridData, refAssembly),
      //       PercentageChange: 0,
      //       IsActive: true,
      //       UserId: this.userInOrg.UserId,
      //       // ...add other fields as needed
      //     });
      //     // Add Target row
      //     simulationData.push({
      //       Id: 0,
      //       Name: refAssembly,
      //       ConfigurationId: this.configurationId,
      //       ScenarioType: "Target",
      //       TypeOfCost: "Target",
      //       CostValue: 0, // or your calculation
      //       PercentageChange: 0,
      //       IsActive: true,
      //       UserId: this.userInOrg.UserId,
      //       // ...add other fields as needed
      //     });

      //     // Add OptionA/B/C rows if present in simulation data
      //     scenarioTypes.forEach(scenario => {
      //       simulationData.push({
      //         Id: 0,
      //         Name: refAssembly,
      //         ConfigurationId: this.configurationId,
      //         ScenarioType: scenario,
      //         TypeOfCost: "Target",
      //         CostValue: 0,
      //         PercentageChange: 0,
      //         IsActive: true,
      //         UserId: this.userInOrg.UserId,
      //       });
      //     });
      //   }
      // });

      // 3. Set IsActive=false for assemblies in simulationData not present in reference grid
      simulationData.forEach(simRow => {
        if (
          !referenceAssemblies.includes(simRow.Name) &&
          !["Total", "Overhead", "Labour", "Assembly group"].includes(simRow.Name)
        ) {
          simRow.IsActive = false;
        }
      });

      // console.log(simulationData);

      // Optionally, sort assemblies alphabetically after the main types
      // const order = ["Total", "Overhead", "Labour", "Assembly group"];
      // const mainRows = [];
      // const assemblyRows = [];
      // simulationData.forEach(row => {
      //   if (order.includes(row.Name)) {
      //     mainRows[order.indexOf(row.Name)] = row;
      //   } else {
      //     assemblyRows.push(row);
      //   }
      // });
      // assemblyRows.sort((a, b) => a.Name.localeCompare(b.Name));
      // this.TCSimulationData = mainRows.filter(Boolean).concat(assemblyRows);
      // console.log(this.TCSimulationData);
      referenceAssemblies.forEach(assembly => {
        const refRows = referenceGridData.filter(row => row.Assembly === assembly);
        if (
          refRows.length > 0 &&
          refRows.every(row => row.IsActive === false)
        ) {
          // Set IsActive = false for all simulation rows for this assembly
          this.TCSimulationData.forEach(simRow => {
            if (simRow.Name === assembly) {
              simRow.IsActive = false;
            }
          });
        }
      });
    }
    // console.log(this.TCSimulationData);
  }

  onTarGridReadySummary(params: any) {
    this.tarSummaryGridApi = params.api;
    this.tarSummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshTarSummary = 1

    this.toggleRowVisibility(params.api);

    // this.toggleRowVisibilitymek(params.api);
  }

  onTarRowGroupOpenedSummary(params) {
    let refRow = this.refSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.refSummaryGridApi.setRowNodeExpanded(refRow, params.expanded);

    let configRow = this.configSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.configSummaryGridApi.setRowNodeExpanded(configRow, params.expanded);

    if (this.optAVisible) {
      let optA = this.optASummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optASummaryGridApi.setRowNodeExpanded(optA, params.expanded);
    }

    if (this.optAVisible) {
      let optB = this.optBSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optBSummaryGridApi.setRowNodeExpanded(optB, params.expanded);
    }

    if (this.optAVisible) {
      let optC = this.optCSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optCSummaryGridApi.setRowNodeExpanded(optC, params.expanded);
    }
  }

  onGridTarChangedSummary(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedTarSummary(params) {
    if (this.sizeToFitRefreshTarSummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onTarCellValueChangedSummary(params) {
    this.hasUnsavedChanges = true;
    // this.tarSummaryGridApi.refreshCells({ force: true });
  }

  loadOptAGridStructureSummary() {
    this.optAColumnDefsSummary = [
      {
        field: "rowGroup",
        //rowGroup: true,
        hide: true,
      },
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "",
        width: 180
      },
      {
        headerName: "Value",
        field: "OptionA.TargetCost.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (this.isEditable && !params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.TargetCost.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.TargetCost.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionA', 'TargetCostMEK', 'PerSystem');
              total = overheadNew + labor + mekTotal;
              params.node.data.OptionA.TargetCost.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.TargetCost.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.TargetCost.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionA', 'TargetCostMEK', 'PerSystem');
              params.node.data.OptionA.TargetCost.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionA.TargetCost.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionA.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.OptionA.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionA.TargetCost.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.OptionA.TargetCost.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.OptionA.TargetCost.PerSystem);
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionA?.TargetCost?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionA.TargetCost.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionA?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionA?.TargetCost?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionA?.TargetCost?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionA?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionA.TargetCost.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionA.TargetCost.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "tcOptA",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionA.Forecast.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal";
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (!params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.Forecast.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.Forecast.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'PerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionA.Forecast.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.Forecast.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.Forecast.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'PerSystem');
              params.node.data.OptionA.Forecast.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionA.Forecast.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionA.Forecast.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.OptionA.Forecast.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionA.Forecast.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.OptionA.Forecast.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.OptionA.Forecast.PerSystem);
              // });
            }
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionA?.Forecast?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionA.Forecast.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionA?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionA?.Forecast?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionA?.Forecast?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionA?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionA.Forecast.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionA.Forecast.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "fcOptA",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionA.Forecast.ActualMEKs",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group && !["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            if (params.data.Name === "DeltaBK") {
              if (params.value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal";
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          if (!params.node.group && ["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            return true;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.Forecast.ActualMEKs);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.Forecast.ActualMEKs;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'ActualsMEKPerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionA.Forecast.ActualMEKs = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionA.Forecast.ActualMEKs;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionA.Forecast.ActualMEKs);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'ActualsMEKPerSystem');
              params.node.data.OptionA.Forecast.ActualMEKs = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionA.Forecast.ActualMEKs;
            }
            // if (params.node.data.Name === "DeltaBK") {
            //   let value = 0;
            //   let bk = params.api.getRowNode(3).data.OptionA.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(3));
            //   let totalBk = params.api.getRowNode(7).data.OptionA.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(7));
            //   value = Number(totalBk) - Number(bk);
            //   params.node.data.OptionA.Forecast.ActualMEKs = value.toFixed(0);
            //   return value;
            //   // params.api.forEachNode((node) => { 
            //   //   // console.log(node);
            //   //   if(node.data.Name == "BK")
            //   //     console.log(node.data.OptionA.Forecast.PerSystem);
            //   //   if(node.data.Name == "TotalBK")
            //   //     console.log(node.data.OptionA.Forecast.PerSystem);
            //   // });
            // }
            return (params.node.data.OptionA.Forecast.ActualMEKs);
          }
        }
      },
      {
        headerName: "",
        width: 50
      }
    ];

    this.getRowHeightOptASummary = 25

    this.optADefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutOptASummary = "autoHeight";

    this.optASummaryFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptAGridReadySummary(params: any) {
    this.optASummaryGridApi = params.api;
    this.optASummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshOptASummary = 1

    this.toggleRowVisibility(params.api);
    //this.toggleRowVisibilitymek(params.api);
  }


  onOptARowGroupOpenedSummary(params) {
    let refRow = this.refSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.refSummaryGridApi.setRowNodeExpanded(refRow, params.expanded);

    let tarRow = this.tarSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.tarSummaryGridApi.setRowNodeExpanded(tarRow, params.expanded);

    let config = this.configSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.configSummaryGridApi.setRowNodeExpanded(config, params.expanded);

    if (this.optBVisible) {
      let optB = this.optBSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optBSummaryGridApi.setRowNodeExpanded(optB, params.expanded);
    }

    if (this.optCVisible) {
      let optC = this.optCSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optCSummaryGridApi.setRowNodeExpanded(optC, params.expanded);
    }
  }

  onGridOptAChangedSummary(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedOptASummary(params) {
    if (this.sizeToFitRefreshOptASummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onOptACellValueChangedSummary(params) {
    this.hasUnsavedChanges = true;
  }

  loadOptBGridStructureSummary() {
    this.optBColumnDefsSummary = [
      {
        field: "rowGroup",
        //rowGroup: true,
        hide: true,
      },
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "",
        width: 180
      },
      {
        headerName: "Value",
        field: "OptionB.TargetCost.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (!params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.TargetCost.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.TargetCost.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionB', 'TargetCostMEK', 'PerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionB.TargetCost.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.TargetCost.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.TargetCost.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionB', 'TargetCostMEK', 'PerSystem');
              params.node.data.OptionB.TargetCost.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionB.TargetCost.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionB.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.OptionB.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionB.TargetCost.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.OptionB.TargetCost.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.OptionB.TargetCost.PerSystem);
              // });
            }
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionB?.TargetCost?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionB.TargetCost.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionB?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionB?.TargetCost?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionB?.TargetCost?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionB?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionB.TargetCost.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionB.TargetCost.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "tcOptB",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionB.Forecast.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          // if (!params.node.group) {
          //   return true;
          // } else {
          //   return false;
          // }
          return false; // Make the column non-editable
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.Forecast.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.Forecast.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'PerSystem');
              total = overheadNew + labor + mekTotal;
              params.node.data.OptionB.Forecast.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.Forecast.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.Forecast.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'PerSystem');
              params.node.data.OptionB.Forecast.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionB.Forecast.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionB.Forecast.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.OptionB.Forecast.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionB.Forecast.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.OptionB.Forecast.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.OptionB.Forecast.PerSystem);
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionB?.Forecast?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionB.Forecast.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionB?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionB?.Forecast?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionB?.Forecast?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionB?.Forecast?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionB.Forecast.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionB.Forecast.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "fcOptB",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionB.Forecast.ActualMEKs",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group && !["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            if (params.data.Name === "DeltaBK") {
              if (params.value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          if (!params.node.group && ["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            return true;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.Forecast.ActualMEKs);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.Forecast.ActualMEKs;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'ActualsMEKPerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionB.Forecast.ActualMEKs = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionB.Forecast.ActualMEKs;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionB.Forecast.ActualMEKs);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'ActualsMEKPerSystem');
              params.node.data.OptionB.Forecast.ActualMEKs = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionB.Forecast.ActualMEKs;
            }
            // if (params.node.data.Name === "DeltaBK") {
            //   let value = 0;
            //   let bk = params.api.getRowNode(3).data.OptionB.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(3));
            //   let totalBk = params.api.getRowNode(7).data.OptionB.Forecast.ActualMEKs;
            //   // console.log(params.api.getRowNode(7));
            //   value = Number(totalBk) - Number(bk);
            //   params.node.data.OptionB.Forecast.ActualMEKs = value.toFixed(0);
            //   return value;
            //   // params.api.forEachNode((node) => { 
            //   //   // console.log(node);
            //   //   if(node.data.Name == "BK")
            //   //     console.log(node.data.OptionB.Forecast.PerSystem);
            //   //   if(node.data.Name == "TotalBK")
            //   //     console.log(node.data.OptionB.Forecast.PerSystem);
            //   // });
            // }
            return (params.node.data.OptionB.Forecast.ActualMEKs);
          }
        }
      },
      {
        headerName: "",
        width: 50
      }
    ];

    this.getRowHeightOptBSummary = 25

    this.optBDefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutOptBSummary = "autoHeight";

    this.optBSummaryFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptBGridReadySummary(params: any) {
    this.optBSummaryGridApi = params.api;
    this.optBSummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshOptBSummary = 1

    this.toggleRowVisibility(params.api);
    // this.toggleRowVisibilitymek(params.api);
  }

  onOptBRowGroupOpenedSummary(params) {
    let refRow = this.refSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.refSummaryGridApi.setRowNodeExpanded(refRow, params.expanded);

    let tarRow = this.tarSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.tarSummaryGridApi.setRowNodeExpanded(tarRow, params.expanded);

    let config = this.configSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.configSummaryGridApi.setRowNodeExpanded(config, params.expanded);

    if (this.optAVisible) {
      let optA = this.optASummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optASummaryGridApi.setRowNodeExpanded(optA, params.expanded);
    }

    if (this.optCVisible) {
      let optC = this.optCSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optCSummaryGridApi.setRowNodeExpanded(optC, params.expanded);
    }
  }

  onGridOptBChangedSummary(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedOptBSummary(params) {
    if (this.sizeToFitRefreshOptBSummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onOptBCellValueChangedSummary(params) {
    this.hasUnsavedChanges = true;
  }

  loadOptCGridStructureSummary() {
    this.optCColumnDefsSummary = [
      {
        field: "rowGroup",
        //rowGroup: true,
        hide: true,
      },
      {
        field: "Name",
        hide: true
      },
      {
        headerName: "",
        width: 180
      },
      {
        headerName: "Value",
        field: "OptionC.TargetCost.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: false, // Make the column non-editable
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.TargetCost.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.TargetCost.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionC', 'TargetCostMEK', 'PerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionC.TargetCost.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.TargetCost.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.TargetCost.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionC', 'TargetCostMEK', 'PerSystem');
              params.node.data.OptionC.TargetCost.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionC.TargetCost.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionC.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(3));
              let totalBk = params.api.getRowNode(8).data.OptionC.TargetCost.PerSystem;
              // console.log(params.api.getRowNode(7));
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionC.TargetCost.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   // console.log(node);
              //   if(node.data.Name == "BK")
              //     console.log(node.data.OptionB.TargetCost.PerSystem);
              //   if(node.data.Name == "TotalBK")
              //     console.log(node.data.OptionB.TargetCost.PerSystem);
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionC?.TargetCost?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionC.TargetCost.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionC?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(3));
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionC?.TargetCost?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionC?.TargetCost?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionC?.TargetCost?.PerSystem ?? 0;
              // console.log(params.api.getRowNode(7));
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionC.TargetCost.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionC.TargetCost.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "tcOptC",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionC.Forecast.PerSystem",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.data.Name === "DeltaBK" || params.data.Name === "MEKMEKDelta") {
              const value = typeof params.value === 'number' ? params.value : Number(params.value);
              if (value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: false, // Make the column non-editable
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.Forecast.PerSystem);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.Forecast.PerSystem;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'PerSystem');

              total = overheadNew + labor + mekTotal;
              params.node.data.OptionC.Forecast.PerSystem = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.Forecast.PerSystem;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.Forecast.PerSystem);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'PerSystem');
              params.node.data.OptionC.Forecast.PerSystem = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionC.Forecast.PerSystem;
            }
            if (params.node.data.Name === "DeltaBK") {
              let value = 0;
              let bk = params.api.getRowNode(3).data.OptionC.Forecast.PerSystem;
              let totalBk = params.api.getRowNode(8).data.OptionC.Forecast.PerSystem;
              value = Number(totalBk) - Number(bk);
              params.node.data.OptionC.Forecast.PerSystem = value.toFixed(0);
              return value;
              // params.api.forEachNode((node) => { 
              //   if(node.data.Name == "BK")
              //   if(node.data.Name == "TotalBK")
              // });
            }
            //Calculate the "Delta to Price" by subtracting the "thereinMEK" to "Price"
            if (params.node.data.Name === "MEKMEKDelta") {
              // Find the row where Description === "calculateScenario"
              let calcScenarioRow = null;
              params.api.forEachNode((node) => {
                if (node.data && node.data.Description === "CalculationScenario" && node.data.Name === "CalculationScenario") {
                  calcScenarioRow = node;
                }
              });

              const scenarioValue = calcScenarioRow?.data?.OptionC?.Forecast?.PerSystem ?? 0;

              // If scenarioValue is 0 or null, do not calculate
              if (!scenarioValue || scenarioValue === 0) {
                params.node.data.OptionC.Forecast.PerSystem = 0;
                return 0;
              }

              let value = 0;
              let bkTarget = params.api.getRowNode(3)?.data?.OptionC?.Forecast?.PerSystem ?? 0;
              let thereinOverhead = params.api.getRowNode(4)?.data?.OptionC?.Forecast?.PerSystem ?? 0;
              let thereinLabour = params.api.getRowNode(5)?.data?.OptionC?.Forecast?.PerSystem ?? 0;
              let thereinMEK = params.api.getRowNode(6)?.data?.OptionC?.Forecast?.PerSystem ?? 0;
              value = (Number(thereinMEK) + Number(thereinOverhead) + Number(thereinLabour)) - Number(bkTarget);
              params.node.data.OptionC.Forecast.PerSystem = value.toFixed(0);
              return value;
            }
            return (params.node.data.OptionC.Forecast.PerSystem);
          }
        }
      },
      {
        headerName: "",
        width: 130,
        field: "fcOptC",
        // cellRendererFramework: EditEqCalcComponent,
        cellRendererSelector: (params) => {
          if (params.data.Description === "Price" && params.data.Name === "CRP") {
            return { component: 'EditEqCalcComponent' }; // string key
          } else if (params.data.Description === "BK Target" && params.data.Name === "BK") {
            return {
              component: 'EditEqBkCalcComponent',
              params: {
                customInput: {
                  ConfigurationId: this.configurationId,
                  UserId: this.userInOrg.UserId,
                  HasMinorAccess: () => { return this.HasMinorAccess },
                  getLatestConfigData: () => this.getRefGridData(),
                  getLatestSimulationData: () => this.getSimulationData(),
                }
              }
            };
          }
          else {
            return null;
          }
        }
      },
      {
        headerName: "Value",
        field: "OptionC.Forecast.ActualMEKs",
        width: 80,
        cellClass: (params) => {
          if (!params.node.group && !["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            if (params.data.Name === "DeltaBK") {
              if (params.value > 0) {
                return "colorTotal positive-num-color-eq"
              } else {
                return "colorTotal negative-num-color-eq"
              }
            }
            return "colorTotal"
          }
        },
        headerTooltip: "Value",
        editable: (params) => {
          if (!params.node.group && ["CRP", "Margin", "BK"].includes(params.node.data.Name)) {
            return true;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            //Calculation for Total BK (Bottom-up)
            if (params.node.data.Name == "TotalBK") {
              let total = 0;

              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.Forecast.ActualMEKs);
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.Forecast.ActualMEKs;
              // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              let overheadNew = this.CalculateScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'ActualsMEKPerSystem');
              total = overheadNew + labor + mekTotal;
              params.node.data.OptionC.Forecast.ActualMEKs = total;

            }
            //Calcution for therein overhead
            if (params.node.data.Name == "Overhead") {
              let value = 0;
              let mekTotal = params.api.getDisplayedRowAtIndex(10).data.OptionC.Forecast.ActualMEKs;
              let labor = Number(params.api.getDisplayedRowAtIndex(9).data.OptionC.Forecast.ActualMEKs);

              // value = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)
              value = this.CalculateScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'ActualsMEKPerSystem');
              params.node.data.OptionC.Forecast.ActualMEKs = value;
              return value;
            }
            //Calculation for therein MEKs total
            if (params.node.data.Name == "MEKTotal") {
              return params.node.data.OptionC.Forecast.ActualMEKs;
            }
            // if (params.node.data.Name === "DeltaBK") {
            //   let value = 0;
            //   let bk = params.api.getRowNode(3).data.OptionC.Forecast.PerSystem;
            //   let totalBk = params.api.getRowNode(7).data.OptionC.Forecast.ActualMEKs;
            //   value = Number(totalBk) - Number(bk);
            //   params.node.data.OptionC.Forecast.ActualMEKs = value.toFixed(0);
            //   return value;
            //   // params.api.forEachNode((node) => { 
            //   //   if(node.data.Name == "BK")
            //   //   if(node.data.Name == "TotalBK")
            //   // });
            // }
            return (params.node.data.OptionC.Forecast.ActualMEKs);
          }
        }
      },
      {
        headerName: "",
        width: 50
      }
    ];

    this.getRowHeightOptCSummary = 25

    this.optCDefaultColDefSummary = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }

    this.domLayoutOptCSummary = "autoHeight";

    this.optCSummaryFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptCGridReadySummary(params: any) {
    this.optCSummaryGridApi = params.api;
    this.optCSummaryGridApi.setHeaderHeight(20);
    this.sizeToFitRefreshOptCSummary = 1

    this.toggleRowVisibility(params.api);
    //this.toggleRowVisibilitymek(params.api);
  }

  onOptCRowGroupOpenedSummary(params) {
    let refRow = this.refSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.refSummaryGridApi.setRowNodeExpanded(refRow, params.expanded);

    let tarRow = this.tarSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.tarSummaryGridApi.setRowNodeExpanded(tarRow, params.expanded);

    let config = this.configSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
    this.configSummaryGridApi.setRowNodeExpanded(config, params.expanded);

    if (this.optBVisible) {
      let optB = this.optBSummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optBSummaryGridApi.setRowNodeExpanded(optB, params.expanded);
    }

    if (this.optAVisible) {
      let optA = this.optASummaryGridApi.getDisplayedRowAtIndex(params.rowIndex);
      this.optASummaryGridApi.setRowNodeExpanded(optA, params.expanded);
    }
  }

  onGridOptCChangedSummary(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedOptCSummary(params) {
    if (this.sizeToFitRefreshOptCSummary != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onOptCCellValueChangedSummary(params) {
    this.hasUnsavedChanges = true;
  }

  loadConfigurationGridStructure() {
    this.rowClassRules = {
      'subTotal': function (params) {
        if (!params.node.group) {
          if (params.data.HasChild) return true
        } else {
          return true;
        }
      },
      'newAddedMaterial': function (params) {
        let flag = 0, createdOn = new Date();
        if (!params.node.group) {
          params.api.forEachNode(n => {
            if (!n.group && n.data.EQId > 0) flag = 1;
            if (!n.group) {
              if (n.data.CreatedOn != null && new Date(n.data.CreatedOn) <= createdOn) {
                createdOn = new Date(n.data.CreatedOn);
              }
            }
          })
          if (flag == 1 && params.data.EQId == 0) {
            return true;
          }
          // else if (params.data.CreatedOn != null && new Date(params.data.CreatedOn) > createdOn) {
          //   return true;
          // }
        }
      },
      'inactiveRow': function (params) {
        if (!params.node.group && params.node.data.IsActive != null && !params.node.data.IsActive) return true;
      },
    }

    this.configColumnDefs = [
      {
        headerName: '', headerTooltip: "Action", width: 20, field: 'del', editable: false, cellRendererFramework: DeleteiconComponent,
      },
      {
        field: "Assembly",
        enableRowGroup: true,
        tooltipField: "Assembly",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Assembly",
      },
      {
        headerName: "KMAT",
        enableRowGroup: true,
        field: "KMAT",
        tooltipField: "KMAT",
        width: 60,
        headerClass: "right-border",
        cellStyle: (params) => (!params.node.group && params.node.data.KMAT == "Please Select") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        cellClass: "right-border",
        headerTooltip: "KMAT",
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual") && !this.groupedColumns.includes("KMAT") && !this.groupedColumns.includes("KMATText"));
        },
        cellEditor: 'agRichSelectCellEditor',
        singleClickEdit: true,
        cellEditorParams: {
          values: this.kmatDropdown
        },
        // resizable:true
      },
      {
        headerName: "KMAT Description",
        field: "KMATText",
        tooltipField: "KMAT Description",
        width: 90,
        headerClass: "right-border",
        cellStyle: (params) => (!params.node.group && params.node.data.KMATText == "Add Description") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        editable: (params) => {
          return (!params.node.group && params.node.data.KMAT == "")
        },
        singleClickEdit: true,
        cellClass: "right-border",
        headerTooltip: "KMAT Description",
        enableRowGroup: true,
      },
      {
        headerName: "VBLO",
        enableRowGroup: true,
        field: "VBLO",
        tooltipField: "VBLO",
        width: 60,
        headerClass: "right-border",
        cellStyle: (params) => (!params.node.group && params.node.data.VBLO == "Please Select") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        cellClass: "right-border",
        headerTooltip: "VBLO",
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual") && !this.groupedColumns.includes("VBLO") && !this.groupedColumns.includes("VBLODescription"));
        },
        cellEditor: 'agRichSelectCellEditor',
        singleClickEdit: true,
        cellEditorParams: {
          values: this.vbloDropdown
        },
        // resizable:true
      },
      {
        headerName: "VBLO Description",
        field: "VBLODescription",
        tooltipField: "VBLO Description",
        width: 160,
        headerClass: "right-border",
        cellStyle: (params) => (!params.node.group && params.node.data.VBLODescription == "Add Description" || params.node.data.VBLODescription == "") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        editable: (params) => {
          return (!params.node.group && params.node.data.VBLO == "")
        },
        singleClickEdit: true,
        cellClass: "right-border",
        headerTooltip: "VBLO Description",
        enableRowGroup: true,
      },
      {
        headerName: "Eco-ID",
        field: "EcoId",
        tooltipField: "EcoId",
        width: 30,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Eco-ID",
        singleClickEdit: true,
        //enableRowGroup: true,
        editable: (params) => {
          if (!params.node.group) {
            return params.node.data.IsEditable;
          }
        },
      },
      {
        headerName: "GMK Group",
        field: "GMKGroup",
        tooltipField: "GMKGroup",
        width: 30,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "GMKGroup",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual"));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Plant",
        field: "Plant",
        tooltipField: "Plant",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Plant",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual"));
        },
        singleClickEdit: true,
      },

      {
        headerName: "Procurement Type",
        field: "ProcurementType",
        tooltipField: "ProcurementType",
        width: 30,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Procurement Type",
        enableRowGroup: true,
        cellStyle: (params) => (!params.node.group && params.node.data.ProcurementType == "" || params.node.data.ProcurementType == undefined) ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },

        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },

      {
        headerName: "Supplier No",
        field: "SupplierNo",
        tooltipField: "Supplier No",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Supplier No",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Supplier Name1",
        field: "SupplierName1",
        tooltipField: "Supplier Name1",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Supplier Name1",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Supplier Name2",
        field: "SupplierName2",
        tooltipField: "Supplier Name2",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Supplier Name2",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Supplier Country",
        field: "SupplierCountry",
        tooltipField: "Supplier Country",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Supplier Country",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Purchase Currency",
        field: "PurchaseCurrencyPUC",
        tooltipField: "Purchase Currency",
        width: 40,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Purchase Currency",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")));
        },
        singleClickEdit: true,
      },
      {
        headerName: "Component",
        field: "Component",
        tooltipField: "Component",
        headerClass: "right-border",
        cellClass: "right-border",
        width: 60,
        headerTooltip: "Component",
        enableRowGroup: true,
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual") && !this.groupedColumns.includes("Component") && !this.groupedColumns.includes("ComponentDescription"));
        },
        cellEditor: 'agRichSelectCellEditor',
        singleClickEdit: true,
        cellEditorParams: {
          values: this.componentDropdown
        },
        cellStyle: (params) => (!params.node.group && params.node.data.Component == "Please Select") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
      },
      {
        headerName: "Component Description",
        field: "ComponentDescription",
        tooltipField: "Component Description",
        width: 160,
        headerTooltip: "Component Description",
        headerClass: "right-border",
        enableRowGroup: true,
        cellClass: "right-border",
        // editable: false,
        cellStyle: (params) => (!params.node.group && params.node.data.ComponentDescription == "Add Description" || params.node.data.ComponentDescription == "") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        editable: (params) => {
          return (!params.node.group && params.node.data.Component == "")
        },
      },
      {
        headerName: "Material",
        field: "Material",
        tooltipField: "Material",
        headerClass: "right-border",
        cellClass: "right-border",
        width: 60,
        enableRowGroup: true,
        headerTooltip: "Material",
        editable: false,
      },
      {
        headerName: "Material Description",
        field: "MaterialDescription",
        tooltipField: "MaterialDescription",
        width: 160,
        flex: 1,
        headerTooltip: "Material Description",
        enableRowGroup: true,
        cellStyle: (params) => (!params.node.group && params.node.data.MaterialDescription == "Add Description" || params.node.data.MaterialDescription == "") ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" },
        editable: (params) => {
          return (!params.node.group && params.node.data.hasOwnProperty("IsManual"))
        },
        singleClickEdit: true,
      },
      {
        headerName: "BKs per piece",
        headerClass: "right-border left-border",
        aggFunc: params => {
          let result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(child => {
            if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
              result += Number(child.data.BKsPerPiece);
            }
          });
          return result;
        },
        cellClass: "left-border right-border colorTotal",
        field: "BKsPerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "BKs per piece",
        headerTooltip: "BKs per piece",
        width: 88,
        editable: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("IsManual")) {
            return params.node.data.IsEditable;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
      },
      {
        headerName: "MEKs per piece",
        headerClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKsPerPiece;
            }
          });
          return result;
        },
        cellClass: "right-border colorTotal",
        field: "ReferencceScenario.MEKsPerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "MEKs per piece",
        headerTooltip: "MEKs per piece",
        width: 88,
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.hasOwnProperty("IsManual")) {
              let bk = params.node.data.BKsPerPiece;
              let type = params.node.data.ProcurementType;
              if (type == "E" || type == "" || type == "X") {
                let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
              } else {
                return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
              }
            } else {
              return (params.node.data.ReferencceScenario.MEKsPerPiece);
            }
          }
        },
      },
      {
        headerName: "Qty",
        field: "ReferencceScenario.Quantity",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        headerTooltip: "Quantity",
        singleClickEdit: true,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "W",
        field: "ReferencceScenario.Weight",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Weight",
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
              return false;
            }
            else {
              return params.node.data.IsEditable;
            }
          }
        },
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "MEK per system",
        field: "ReferencceScenario.MEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          return result;
        },
        tooltipField: "MEK per system",
        width: 88,
        cellClass: "colorTotal right-border",
        headerTooltip: "MEK per system",
        headerClass: "right-border",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + node.data.ReferencceScenario.MEKPerSystem;
                }
              })
              if (count == 0) {
                total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              }
              params.node.data.ReferencceScenario.MEKPerSystem = total;
              return total;


            } else {
              params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              return params.node.data.ReferencceScenario.MEKPerSystem
            }
          }
        },
      },
      {
        headerName: "Qty",
        field: "TargetScenario.TargetCostMEK.Quantity",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "W",
        field: "TargetScenario.TargetCostMEK.Weight",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "TargetScenario.TargetCostMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.TargetCostMEK.PerSystem
            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
            if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
              return 0;
            } else {
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 0 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
              return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
            }
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.PerSystem
            }
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
          // result = ((target - ref) / ref) * 100;
          // return result;
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 0 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
              }
            }
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "TargetScenario.ForecastMEK.ActualsMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per piece",
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          }
        },
      },
      // {
      //   headerName: "Actuals (MEK)",
      //   field: "TargetScenario.ForecastMEK.ActualsMEK",
      //   suppressColumnsToolPanel: true,
      //   hide: true,
      //   tooltipField: "Actuals (MEK)",
      //   width: 80,
      //   headerClass: "right-border",
      //   cellClass: "right-border colorTotal",
      //   aggFunc: params => {
      //     var result = 0;
      //     const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
      //     displayedLeafChildren.forEach(node => {
      //       if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //         result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
      //       }
      //     });
      //     return result;
      //   },
      //   headerTooltip: "Actuals (MEK)",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRendererReadOnly,
      //   cellRenderer: CurrencyCellRendererReadOnly,
      // },
      {
        headerName: "Δ TC",
        field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta TC vs. ACT",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
              ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 0 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
              }
            }
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionA.TargetCostMEK.Quantity",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "W",
        field: "OptionA.TargetCostMEK.Weight",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionA.TargetCostMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data?.Component === data?.Material) {
            let total = 0;
            let count = 0;

            params.api.forEachNode((node) => {
              const nodeData = node.data;
              if (
                !node.group &&
                nodeData?.Assembly === data?.Assembly &&
                nodeData?.KMAT === data?.KMAT &&
                nodeData?.VBLO === data?.VBLO &&
                nodeData?.Component === data?.Component &&
                nodeData?.Component !== nodeData?.Material
              ) {
                count++;
                total +=
                  Number(nodeData?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
            });

            if (count === 0) {
              total =
                Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            }

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
              return total;

            }


          } else if (!params.node.group) {
            const perPiece = Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0);
            const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
            const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            const total = perPiece * quantity * weight;

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
            }


          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (data && !data.HasChild && (data.IsActive == null || data.IsActive === true)) {
              target += Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }

          // if (ref === 0) return 0;
          // return ((target - ref) / ref) * 100;
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
            }
            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
                return total;

              }

            } else {
              const perPiece = Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
              }

            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);

          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (
              data &&
              !data.HasChild &&
              (data.IsActive == null || data.IsActive === true)
            ) {
              target += Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 0; // Avoid division by zero

          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (!data.hasOwnProperty("Pinned")) {
              const perSystem = Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

              let delta = perSystem - refMEK;
              if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
                delta = 0;
              } else {
                delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
              }
              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.DeltaFCVsRefMEK = delta;
              }

              return delta;
            }
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionA.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        hide: true,
        suppressColumnsToolPanel: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (
                  !node.group &&
                  node.data?.Assembly == params.node.data?.Assembly &&
                  node.data?.KMAT == params.node.data?.KMAT &&
                  node.data?.VBLO == params.node.data?.VBLO &&
                  node.data?.Component == params.node.data?.Component &&
                  node.data?.Component != node.data?.Material
                ) {
                  count++;
                  total +=
                    Number(node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });
              if (count == 0) {
                total =
                  Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionA.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionA?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionA.TargetCostMEK.PerSystem);
            }
          });
          // ...existing code...
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            // Only proceed if OptionA and its subfields exist
            const actualsMEKPerSystem = Number(data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem ?? 0);
            const targetPerSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);

            if (!data?.hasOwnProperty("Pinned")) {
              if ((actualsMEKPerSystem === 0 || data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem == null) &&
                (targetPerSystem === 0 || data?.OptionA?.TargetCostMEK?.PerSystem == null)) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (data?.OptionA?.ForecastMEK) {
                  data.OptionA.ForecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionB.TargetCostMEK.Quantity",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "W",
        field: "OptionB.TargetCostMEK.Weight",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionB.TargetCostMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
              }


            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
            }

            if (data?.OptionB?.TargetCostMEK) {
              data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
              }


            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.ForecastMEK) {
              data.OptionB.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionB.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionB = nodeData?.OptionB;
                const nodeForecastMEK = nodeOptionB?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionB?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionB.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionB?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionB.TargetCostMEK.PerSystem);
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionC.TargetCostMEK.Quantity",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "W",
        field: "OptionC.TargetCostMEK.Weight",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionC.TargetCostMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
              }


            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
          // result = ((target - ref) / ref) * 100;
          // return result;
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.TargetCostMEK) {
              data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerPiece",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
              }


            }
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 0 : (delta / refMEK) * 100;
            }

            if (data?.OptionC?.ForecastMEK) {
              data.OptionC.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionC.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionC = nodeData?.OptionC;
                const nodeForecastMEK = nodeOptionC?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionC?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionC.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true)
            ) {
              // Add full nullable checks before accessing properties
              if (
                node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
              ) {
                target += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
              }
              if (
                node.data.OptionC?.TargetCostMEK?.PerSystem != null
              ) {
                ref += Number(node.data.OptionC.TargetCostMEK.PerSystem);
              }
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        }
      },
    ];

    // this.refColumnDefs.forEach(obj => {
    //   if (!obj.hasOwnProperty("hide")) {
    //     if (obj.children) {

    //         let newObj1= {
    //           hide:true,
    //           field: obj.children[0].field,
    //         };
    //         let newObj2= {
    //           hide:true,
    //           field: obj.children[1].field,
    //           valueGetter: obj.children[1].valueGetter
    //         };
    //         this.configColumnDefs.push(newObj1);
    //         this.configColumnDefs.push(newObj2);
    //     }
    //     else {
    //       let newObj = {hide: true, field: obj.field, valueGetter: obj.valueGetter };
    //       this.configColumnDefs.push(newObj)
    //     }

    //   }
    // })

    this.getRowHeightConfig = 25

    this.configDefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params.colDef.editable === 'function'
            ? !params.colDef.editable(params)
            : params.colDef.editable === false
      },
      //  flex: 1,
      // minWidth: 40,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      // wrapText: true,
      filter: true,
    }

    this.rowGroupPanelShow = 'always';

    this.domLayoutConfig = "normal";
    this.configFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onColumnResized(event: ColumnResizedEvent) {
    // Only run after the user has finished dragging
    if (event.finished && event.source !== 'gridOptionsChanged' && event.source !== 'flex') {
      // this.configGridApi.sizeColumnsToFit();
      this.saveColumnState();
      const currentState = this.configGridColumnApi.getColumnState();
      // const savedResizedState = this.configGridColumnApi.getColumnState();
      // this.localStorageService.set('savedResizedState', JSON.stringify(savedResizedState));

    }
  }

  onFirstDataRenderedConfig(params) {
    // const savedGroupedColumns = this.localStorageService.get('savedGroupedColumns');
    // if (savedGroupedColumns) {
    //   const groupedColumns = JSON.parse(savedGroupedColumns);
    //   this.configGridColumnApi.setRowGroupColumns(groupedColumns);
    // } else {
    //   //this.configGridColumnApi.setRowGroupColumns(['Assembly']);
    // }
  }

  // onFirstDataRendered(params: FirstDataRenderedEvent, gridId: string) {

  //   if (this.expandedGroupKeys.length == 0 && this.firstLoadMap[gridId]) {
  //     this.firstLoadMap[gridId] = false;
  //     params.api.forEachNode((node) => {
  //       if (node.group) {
  //         node.setExpanded(false);
  //       }
  //     });

  //   }
  //   else if (this.expandedGroupKeys.length > 0) {
  //     params.api.forEachNode((node) => {
  //       if (node.group && this.expandedGroupKeys.includes(node.key)) {
  //         node.setExpanded(true);
  //       }
  //     });
  //   }
  //   else {
  //     if (!this.isExpanded) {
  //       this.expandCollapse = "Expand Groups"
  //     }
  //     else {
  //       this.expandCollapse = "Collapse Groups"
  //     }
  //     params.api.forEachNode((node) => {
  //       if (node.group) {
  //         node.setExpanded(this.isExpanded);
  //       }
  //     });
  //   }
  // }
  onFirstDataRendered(params: FirstDataRenderedEvent, gridId: string) {

    if (!this.localStorageService.get('initialColState')) {
      const initialColState = this.configGridColumnApi.getColumnState();
      this.localStorageService.set('initialColState', JSON.stringify(initialColState));
    }

    const savedColumnState = this.localStorageService.get('savedColumnState');
    const savedFilter = this.localStorageService.get('savedFilter');

    const applyGridSettings = () => {
      // Step 1: Apply column state and set row groups
      if (savedColumnState) {
        const columnState = JSON.parse(savedColumnState);
        const hasGrouping = columnState.some(col => col.rowGroup === true);

        if (!hasGrouping) {
          this.configGridColumnApi.setRowGroupColumns(["Assembly"]);
        }

        // this.configGridApi.setColumnState(columnState);
        this.configGridColumnApi.applyColumnState({
          state: columnState,
          applyOrder: true
        });


      } else {
        this.configGridColumnApi.setRowGroupColumns(["Assembly"]);


      }

      // Step 2: Apply filters
      if (savedFilter) {
        this.configGridApi.setFilterModel(JSON.parse(savedFilter));
      }

      // Step 3: Wait for regrouping and row rendering, then expand groups
      requestAnimationFrame(() => {
        this.expandGroups(params, gridId);
        this.summaryTrigger.next();
      }); // Adjust delay if needed
    };

    applyGridSettings();
    if (gridId === 'refGrid') {
      this.syncSimulationAssembliesWithReference();
    }
    // this.saveColumnState();
    // if (gridId === 'configGrid') {
    //   this.setRowHeightsForDisplayAssembly(params.api);
    // }
  }

  // expandGroups(params: FirstDataRenderedEvent, gridId: string) {
  //   if (this.expandedGroupKeys.length === 0 && this.firstLoadMap[gridId]) {
  //     this.firstLoadMap[gridId] = false;
  //     params.api.forEachNode((node) => {
  //       if (node.group) {
  //         node.setExpanded(false);
  //       }
  //     });
  //   } else if (this.expandedGroupKeys.length > 0) {
  //     params.api.forEachNode((node) => {
  //       if (node.group && this.expandedGroupKeys.includes(node.key)) {
  //         node.setExpanded(true);
  //       }
  //     });
  //   } else {
  //     this.expandCollapse = this.isExpanded ? "Collapse Groups" : "Expand Groups";
  //     params.api.forEachNode((node) => {
  //       if (node.group) {
  //         node.setExpanded(this.isExpanded);
  //       }
  //     });
  //   }
  // }

  expandGroups(params: FirstDataRenderedEvent, gridId: string) {
    const api = params.api;

    if (this.expandedGroupKeys.length === 0 && this.firstLoadMap[gridId]) {
      this.firstLoadMap[gridId] = false;
      api.forEachNode((node) => {
        if (node.group) node.setExpanded(false);
      });
    } else if (this.expandedGroupKeys.length > 0) {
      api.forEachNode((node) => {
        if (node.group) {
          const path = this.getGroupPath(node);
          if (this.expandedGroupKeys.includes(path)) {
            node.setExpanded(true);
          }
        }
      });
    } else {
      api.forEachNode((node) => {
        if (node.group) {
          node.setExpanded(this.isExpanded);
        }
      });
    }
  }

  getMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    defaultItems.push({
      name: 'Reset Columns (Custom)',
      action: () => this.resetCustomColumnSettings()
    });

    return defaultItems;
  }

  resetCustomColumnSettings() {
    this.localStorageService.remove('savedColumnState');
    this.localStorageService.remove('savedFilter');

    const grids = [
      this.refGridApi,
      this.tarGridApi,
      this.optAVisible ? this.optAGridApi : null,
      this.optBVisible ? this.optBGridApi : null,
      this.optCVisible ? this.optCGridApi : null
    ].filter(Boolean);

    // const defaultColState = this.configGridColumnApi.getColumnState()
    //   .map(col => ({ colId: col.colId, hide: false, pinned: null, width: 100 }));

    // this.configGridColumnApi.setColumnState(defaultColState);
    // this.configGridApi.setColumnDefs(this.originalColumnDefs);

    this.configGridColumnApi.setRowGroupColumns([]);
    // this.configGridColumnApi.resetColumnState();
    const initialState = this.localStorageService.get('initialColState');
    if (initialState) {
      this.configGridColumnApi.applyColumnState({
        state: JSON.parse(initialState),
        applyOrder: true,
      });
    }
    this.configGridApi.setFilterModel(null);
    this.configGridApi.setSortModel(null);

    // Also clear and refresh other synced grids if needed
    grids.forEach(api => {
      api.setFilterModel(null);
      api.setSortModel(null);
    });

    this.localStorageService.remove('initialColState');
    if (!this.localStorageService.get('initialColState')) {
      const initialColState = this.configGridColumnApi.getColumnState();
      this.localStorageService.set('initialColState', JSON.stringify(initialColState));
    }
    // Optionally trigger a grid redraw
    this.configGridApi.redrawRows();
  }
  //   resetCustomColumnSettings() {
  //     this.localStorageService.remove('savedColumnState');
  //     this.localStorageService.remove('savedFilter');

  //     const grids = [
  //       this.refGridColumnApi,
  //       this.tarGridColumnApi,
  //       this.optAVisible ? this.optAGridColumnApi : null,
  //       this.optBVisible ? this.optBGridColumnApi : null,
  //       this.optCVisible ? this.optCGridColumnApi : null
  //     ].filter(Boolean);

  //     // Load the initial column state from localStorage if it exists
  //     const initialState = this.localStorageService.get('initialColState');
  //     if (initialState) {
  //       const columnState = JSON.parse(initialState);

  //       // Apply the column state (including sorting, filtering, and column visibility)
  //       this.configGridColumnApi.applyColumnState({
  //         state: columnState,
  //         applyOrder: true, // Optionally, apply column order as well
  //       });
  //     }

  //     // Now, apply column state (including sorting, filtering) for all synced grids
  //     grids.forEach(api => {
  //       if (api) {
  //         // Apply column state for each grid
  //         const initialState = this.localStorageService.get('initialColState');
  //         if (initialState) {
  //           const columnState = JSON.parse(initialState);
  //           api.applyColumnState({
  //             state: columnState,
  //             applyOrder: true, // Optionally, apply column order as well
  //           });
  //         }

  //         // Optionally, reset filter and sort model for each grid
  //         // api.setFilterModel(null);
  //         // api.setSortModel(null);
  //       }
  //     });

  //     // Optionally trigger a grid redraw
  //     this.configGridApi.redrawRows();
  // }


  getRefMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    // defaultItems.push({
    //   name: 'Reset Columns (Custom)',
    //   action: () => this.resetCustomColumnSettings()
    // });

    return defaultItems;
  }

  getTarMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    // defaultItems.push({
    //   name: 'Reset Columns (Custom)',
    //   action: () => this.resetCustomColumnSettings()
    // });

    return defaultItems;
  }

  getOptAMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    // defaultItems.push({
    //   name: 'Reset Columns (Custom)',
    //   action: () => this.resetCustomColumnSettings()
    // });

    return defaultItems;
  }

  getOptBMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    // defaultItems.push({
    //   name: 'Reset Columns (Custom)',
    //   action: () => this.resetCustomColumnSettings()
    // });

    return defaultItems;
  }

  getOptCMainMenuItems(params) {
    const defaultItems = params.defaultItems.filter(item => item !== 'resetColumns');

    // defaultItems.push({
    //   name: 'Reset Columns (Custom)',
    //   action: () => this.resetCustomColumnSettings()
    // });

    return defaultItems;
  }

  //   applySavedGridState() {
  //   const savedColumnState = this.localStorageService.get('savedColumnState');
  //   const savedFilter = this.localStorageService.get('savedFilter');

  //   if (!this.configGridApi || !this.configGridColumnApi) return;

  //   if (savedColumnState) {
  //     const columnState = JSON.parse(savedColumnState);
  //     const hasGrouping = columnState.some(col => col.rowGroup === true);

  //     if (!hasGrouping) {
  //       this.configGridColumnApi.setRowGroupColumns(["Assembly"]);
  //     }

  //     this.configGridColumnApi.applyColumnState({
  //       state: columnState,
  //       applyOrder: true
  //     });
  //   } else {
  //     this.configGridColumnApi.setRowGroupColumns(["Assembly"]);
  //   }

  //   if (savedFilter) {
  //     setTimeout(() => {
  //       this.configGridApi.setFilterModel(JSON.parse(savedFilter));
  //     }, 50); // filters should come *after* column state
  //   }

  //   requestAnimationFrame(() => {
  //     this.expandGroups({ api: this.configGridApi } as FirstDataRenderedEvent, 'configGrid');
  //   });
  // }



  saveColumnState() {
    if (this.configGridColumnApi != undefined) {
      const savedColumnState = this.configGridColumnApi.getColumnState();
      this.localStorageService.set('savedColumnState', JSON.stringify(savedColumnState));
    }
  }

  onColumnRowGroupChanged(params) {
    this.groupedColumns = params.columns.map(col => col.colId);
    this.isGrouped = this.groupedColumns.length > 0;
    this.saveColumnState();

    this.refGridColumnApi.setRowGroupColumns(this.groupedColumns);
    this.tarGridColumnApi.setRowGroupColumns(this.groupedColumns);
    if (this.optAVisible)
      this.optAGridColumnApi.setRowGroupColumns(this.groupedColumns);
    if (this.optBVisible)
      this.optBGridColumnApi.setRowGroupColumns(this.groupedColumns);
    if (this.optCVisible)
      this.optCGridColumnApi.setRowGroupColumns(this.groupedColumns);

    this.isExpanded = false;
    this.expandCollapse = "Expand Groups";
  }

  onFilterChanged(params) {
    if (this.filterSource && this.filterSource !== 'config') return;

    this.filterSource = 'config';

    let model = params.api.getFilterModel();
    const filterState = params.api.getFilterModel();
    // Logs the current filter state
    this.localStorageService.set('savedFilter', JSON.stringify(filterState));

    if (this.refGridApi) this.refGridApi.setFilterModel(model);
    // this.calculateSummaryMekTotalRef();

    if (this.tarGridApi) this.tarGridApi.setFilterModel(model);
    // this.calculateSummaryMekTotalTarget();

    if (this.optAVisible && this.optAGridApi) {
      this.optAGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionA();
    }

    if (this.optBVisible && this.optBGridApi) {
      this.optBGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionB();
    }

    if (this.optCVisible && this.optCGridApi) {
      this.optCGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionC();
    }

    this.summaryTrigger.next();

    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }


  onRefTitleRawChange(title: string) {
    if (title != null) {
      // this.refTitle = title;
      this.hasUnsavedChanges = true;
    }
  }
  onTarTitleRawChange(title: string) {
    if (title != null) {
      //  this.tarTitle = title;
      this.hasUnsavedChanges = true;
    }
  }
  onOptATitleRawChange(title: string) {
    if (title != null) {
      //     this.optATitle = title;
      this.hasUnsavedChanges = true;
    }
  }
  onOptBTitleRawChange(title: string) {
    if (title != null) {
      // this.optBTitle = title;
      this.hasUnsavedChanges = true;
    }
  }
  onOptCTitleRawChange(title: string) {
    if (title != null) {
      // this.optCTitle = title;
      this.hasUnsavedChanges = true;
    }
  }


  onRefFilterChanged(params) {
    if (this.filterSource && this.filterSource !== 'ref') return;

    this.filterSource = 'ref';

    let model = params.api.getFilterModel();

    if (this.configGridApi) this.configGridApi.setFilterModel(model);

    // if (this.refGridApi) this.refGridApi.setFilterModel(model);
    // this.calculateSummaryMekTotalRef();

    if (this.tarGridApi) this.tarGridApi.setFilterModel(model);
    // this.calculateSummaryMekTotalTarget();

    if (this.optAVisible && this.optAGridApi) {
      this.optAGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionA();
    }

    if (this.optBVisible && this.optBGridApi) {
      this.optBGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionB();
    }

    if (this.optCVisible && this.optCGridApi) {
      this.optCGridApi.setFilterModel(model);
      // this.calculateSummaryMekTotalOptionC();
    }

    this.summaryTrigger.next();
    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }



  onTarFilterChanged(params) {
    if (this.filterSource && this.filterSource !== 'tar') return;

    this.filterSource = 'tar';

    let model = params.api.getFilterModel();
    // localStorage.setItem('savedFilter', JSON.stringify(model));

    this.configGridApi.setFilterModel(model);

    this.refGridApi.setFilterModel(model);
    // this.refGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalRef();

    // this.tarGridApi.setFilterModel(model);
    // this.tarGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalTarget();

    if (this.optAVisible) {
      this.optAGridApi.setFilterModel(model);
      // this.optAGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionA();
    }

    if (this.optBVisible) {
      this.optBGridApi.setFilterModel(model);
      // this.optBGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionB();
    }

    if (this.optCVisible) {
      this.optCGridApi.setFilterModel(model);
      // this.optCGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionC();
    }

    this.summaryTrigger.next();
    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }

  onOptAFilterChanged(params) {

    if (this.filterSource && this.filterSource !== 'optA') return;

    this.filterSource = 'optA';

    let model = params.api.getFilterModel();

    this.configGridApi.setFilterModel(model);

    this.refGridApi.setFilterModel(model);
    // this.refGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalRef();

    this.tarGridApi.setFilterModel(model);
    // this.tarGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalTarget();

    // if (this.optAVisible) {
    //   this.optAGridApi.setFilterModel(model);
    //   this.optAGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalOptionA();
    // }

    if (this.optBVisible) {
      this.optBGridApi.setFilterModel(model);
      // this.optBGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionB();
    }

    if (this.optCVisible) {
      this.optCGridApi.setFilterModel(model);
      // this.optCGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionC();
    }

    this.summaryTrigger.next();

    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }

  onOptBFilterChanged(params) {
    if (this.filterSource && this.filterSource !== 'optB') return;

    this.filterSource = 'optB';

    let model = params.api.getFilterModel();

    this.configGridApi.setFilterModel(model);

    this.refGridApi.setFilterModel(model);
    // this.refGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalRef();

    this.tarGridApi.setFilterModel(model);
    // this.tarGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalTarget();

    if (this.optAVisible) {
      this.optAGridApi.setFilterModel(model);
      // this.optAGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionA();
    }

    // if (this.optBVisible) {
    //   this.optBGridApi.setFilterModel(model);
    //   this.optBGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalOptionB();
    // }

    if (this.optCVisible) {
      this.optCGridApi.setFilterModel(model);
      // this.optCGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionC();
    }

    this.summaryTrigger.next();

    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }

  onOptCFilterChanged(params) {
    if (this.filterSource && this.filterSource !== 'optC') return;

    this.filterSource = 'optC';

    let model = params.api.getFilterModel();

    this.configGridApi.setFilterModel(model);

    this.refGridApi.setFilterModel(model);
    // this.refGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalRef();

    this.tarGridApi.setFilterModel(model);
    // this.tarGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalTarget();

    if (this.optAVisible) {
      this.optAGridApi.setFilterModel(model);
      // this.optAGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionA();
    }

    if (this.optBVisible) {
      this.optBGridApi.setFilterModel(model);
      // this.optBGridApi.onFilterChanged();
      // this.calculateSummaryMekTotalOptionB();
    }

    // if (this.optCVisible) {
    //   this.optCGridApi.setFilterModel(model);
    //   this.optCGridApi.onFilterChanged();
    // this.calculateSummaryMekTotalOptionC();
    // }

    this.summaryTrigger.next();

    setTimeout(() => {
      this.filterSource = null;
    }, 0);
  }

  onSortChanged(params: any) {
    let columnState = params.columnApi.getColumnState();
    this.sortingState = columnState.map(({ colId, sort, sortIndex }) => ({
      colId,
      sort: sort ?? null,
      sortIndex: sortIndex ?? null
    }));

    this.configGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false
    })

    this.refGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false,
    })

    this.tarGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false,
    })

    if (this.optAVisible) {
      this.optAGridColumnApi.applyColumnState({
        state: this.sortingState,
        applyOrder: false,
      })
    }

    if (this.optBVisible) {
      this.optBGridColumnApi.applyColumnState({
        state: this.sortingState,
        applyOrder: false,
      })
    }

    if (this.optCVisible) {
      this.optCGridColumnApi.applyColumnState({
        state: this.sortingState,
        applyOrder: false,
      })
    }

    // params.api.refreshHeader();
    // // Workaround: destroy and re-create the filter instance for the column
    // setTimeout(() => {
    //   params.api.onFilterChanged();
    // }, 0);
  }

  onConfigGridReady(params: any) {
    this.configGridApi = params.api;
    this.configGridColumnApi = params.columnApi;

    this.configGridApi.setHeaderHeight(53);
    this.sizeToFitRefreshConfig = 1;
    // let configData = [];
    // this.configGridApi.forEachNode((node) => {
    //   configData.push(node.data);
    // });
    // this.setRowHeightsForDisplayAssembly(this.configGridApi);
    // this.configGridApi.addEventListener('firstDataRendered', () => {
    //   this.setRowHeightsForDisplayAssembly(this.configGridApi);
    // });
    // if (!this.localStorageService.get('initialColState')) {
    //   const initialColState = this.configGridColumnApi.getColumnState();
    //   this.localStorageService.set('initialColState', JSON.stringify(initialColState));
    // }
    // this.applySavedGridState();
    // const savedColumnState = this.localStorageService.get('savedColumnState');
    // if (savedColumnState) {

    //   const columnState = JSON.parse(savedColumnState);
    //   const hasGrouping = columnState.some(col => col.rowGroup === true);
    //   if (!hasGrouping) {
    //     this.configGridColumnApi.setRowGroupColumns(["Assembly"]);
    //   }
    //   setTimeout(() => {
    //     this.configGridColumnApi.setColumnState(columnState);
    //   }, 1000);
    //   const savedFilter = JSON.parse(this.localStorageService.get('savedFilter'));
    //   if (savedFilter) {
    //     setTimeout(() => {
    //       this.configGridApi.setFilterModel(savedFilter);
    //     }, 1000);
    //   }
    // } else {
    //   this.configGridColumnApi.setRowGroupColumns(["Assembly"]);
    // }

    //this.configGridApi.sizeColumnsToFit();
    // window.addEventListener('resize', () => {
    //   this.configGridApi.sizeColumnsToFit();
    // });
  }

  // onConfigRowGroupOpened(params) {
  //   if (this.isProgrammaticToggle) return;

  //   const toggledNode = params.node;
  //   const level = toggledNode.level;
  //   const isExpanded = toggledNode.expanded;

  //   this.isProgrammaticToggle = true;

  //   this.configGridApi.forEachNode(node => {
  //     if (node.group && node.level == level && node !== toggledNode) {
  //       node.setExpanded(isExpanded);
  //     }
  //   });

  //   this.refGridApi.forEachNode(node => {
  //     if (node.group && node.level == level && node !== toggledNode) {
  //       node.setExpanded(isExpanded);
  //     }
  //   });

  //   this.tarGridApi.forEachNode(node => {
  //     if (node.group && node.level == level && node !== toggledNode) {
  //       node.setExpanded(isExpanded);
  //     }
  //   });

  //   this.isProgrammaticToggle = false;
  // }
  getGroupPath(node: RowNode): string {
    const path = [];
    let current = node;
    while (current && current.level >= 0) {
      path.unshift(current.key);
      current = current.parent;
    }
    return path.join('||'); // use || or any separator to join group keys
  }

  onConfigRowGroupOpened(params) {
    const groupPath = this.getGroupPath(params.node);

    // Save it or remove it from expanded group keys
    if (params.expanded) {
      if (!this.expandedGroupKeys.includes(groupPath)) {
        this.expandedGroupKeys.push(groupPath);
      }
    } else {
      this.expandedGroupKeys = this.expandedGroupKeys.filter(k => k !== groupPath);
    }

    // Now propagate to all other grids
    this.expandGroupInAllGrids(groupPath, params.expanded);
  }

  expandGroupInAllGrids(groupPath: string, expanded: boolean) {
    const grids = [
      this.refGridApi,
      this.tarGridApi,
      this.optAVisible ? this.optAGridApi : null,
      this.optBVisible ? this.optBGridApi : null,
      this.optCVisible ? this.optCGridApi : null
    ].filter(Boolean);

    for (const api of grids) {
      api.forEachNode((node) => {
        if (node.group && this.getGroupPath(node) === groupPath) {
          node.setExpanded(expanded);

          setTimeout(() => {
            api.sizeColumnsToFit();
          }, 100);
        }
      });
    }
  }
  // onConfigRowGroupOpened(params) {
  //   let refRow = this.refGridApi.getDisplayedRowAtIndex(params.rowIndex);
  //   setTimeout(() => {
  //     this.refGridApi.sizeColumnsToFit();
  //   }, 100);
  //   this.refGridApi.setRowNodeExpanded(refRow, params.expanded);

  //   let tarRow = this.tarGridApi.getDisplayedRowAtIndex(params.rowIndex);
  //   setTimeout(() => {
  //     this.tarGridApi.sizeColumnsToFit();
  //   }, 100);
  //   this.tarGridApi.setRowNodeExpanded(tarRow, params.expanded);

  //   if (this.optAVisible) {
  //     let optARow = this.optAGridApi.getDisplayedRowAtIndex(params.rowIndex);
  //     setTimeout(() => {
  //       this.optAGridApi.sizeColumnsToFit();
  //     }, 100);
  //     this.optAGridApi.setRowNodeExpanded(optARow, params.expanded);
  //   }

  //   if (this.optBVisible) {
  //     let optBRow = this.optBGridApi.getDisplayedRowAtIndex(params.rowIndex);
  //     setTimeout(() => {
  //       this.optBGridApi.sizeColumnsToFit();
  //     }, 100);
  //     this.optBGridApi.setRowNodeExpanded(optBRow, params.expanded);
  //   }

  //   if (this.optCVisible) {
  //     let optCRow = this.optCGridApi.getDisplayedRowAtIndex(params.rowIndex);
  //     setTimeout(() => {
  //       this.optCGridApi.sizeColumnsToFit();
  //     }, 100);
  //     this.optCGridApi.setRowNodeExpanded(optCRow, params.expanded);
  //   }
  //   this.expandedGroupKeys = [];
  //   params.api.forEachNode((node) => {
  //     if (node.group && node.expanded) {
  //       this.expandedGroupKeys.push(node.key);
  //     }
  //   });
  // }


  onExpandCollapse() {
    setTimeout(() => {
      this.refGridApi.sizeColumnsToFit();
      this.tarGridApi.sizeColumnsToFit();
      if (this.optAVisible)
        this.optAGridApi.sizeColumnsToFit();
      if (this.optBVisible)
        this.optBGridApi.sizeColumnsToFit();
      if (this.optCVisible)
        this.optCGridApi.sizeColumnsToFit();
    }, 100);

    if (this.isExpanded) {
      this.configGridApi.collapseAll();
      this.refGridApi.collapseAll();
      this.tarGridApi.collapseAll();

      if (this.optAVisible) {
        this.optAGridApi.collapseAll();
      }

      if (this.optBVisible) {
        this.optBGridApi.collapseAll();
      }

      if (this.optCVisible) {
        this.optCGridApi.collapseAll();
      }

      this.expandCollapse = "Expand Groups"
    } else {
      this.configGridApi.expandAll();
      this.refGridApi.expandAll();
      this.tarGridApi.expandAll();

      if (this.optAVisible) {
        this.optAGridApi.expandAll();
      }

      if (this.optBVisible) {
        this.optBGridApi.expandAll();
      }

      if (this.optCVisible) {
        this.optCGridApi.expandAll();
      }

      this.expandCollapse = "Collapse Groups"
    }

    this.isExpanded = !this.isExpanded;
  }

  onCollapse() {
    this.configGridApi.collapseAll();
    this.refGridApi.collapseAll();
    this.tarGridApi.collapseAll();
  }

  onColumnVisibleChanged(params) {
    this.saveColumnState();
    this.adjustGridWidth();
  }

  adjustGridWidth(): void {
    if (this.configGridColumnApi != undefined) {
      const visibleColumns = this.configGridColumnApi.getAllDisplayedColumns();
      // Sum the width of the visible columns
      if (visibleColumns.length > 4) {
        let totalWidth = 0;
        visibleColumns.forEach((col) => {
          totalWidth += col.getActualWidth();
        });

        // Adjust the width of the grid container dynamically
        const gridElement = document.querySelectorAll('.dynamicConfigGrid') as NodeListOf<HTMLElement>; // Using the class of the grid container
        if (gridElement) {
          // Adjust the width of the grid container dynamically based on the total width of visible columns
          gridElement.forEach((x) => {
            x.style.width = `${totalWidth}px`
          });
        }
      }
    }
  }

  onConfigCellValueChanged(params) {
    if (params.column.colId == "KMAT") {
      let data = this.gridData.find(x => x.KMAT == params.value);
      if (data == undefined) {
        params.data.KMAT = "";
        params.data.KMATText = "Add Description";
        params.data.KMATId = 0;
      } else {
        params.data.KMATId = data.KMATId;
        params.data.KMATText = data.KMATText;
      }
    }
    if (params.column.colId == "VBLO") {
      let data = this.gridData.find(x => x.VBLO == params.value);
      if (data == undefined) {
        params.data.VBLO = "";
        params.data.VBLODescription = "Add Description";
        params.data.VBLOId = 0;
        params.data.KMATVBLOId = 0;
        // params.data.KMATId = data.KMATId;
      } else {
        params.data.VBLOId = data.VBLOId;
        params.data.VBLODescription = data.VBLODescription;
        params.data.KMATVBLOId = data.KMATVBLOId;
        params.data.KMATId = data.KMATId;
      }
    }
    if (params.column.colId == "Component") {
      if (params.value == "Create new Component") {
        params.data.Component = "";
        params.data.ComponentDescription = "";
      }
      else {
        let data = this.gridData.find(x => x.Component == params.value);
        params.data.ComponentDescription = data.ComponentDescription;
      }
    }
    if (params.column.colId == "EcoId" || params.column.colId == "ProcurementType" || params.column.colId == "SupplierNo" || params.column.colId == "SupplierName1" ||
      params.column.colId == "SupplierName2" || params.column.colId == "SupplierCountry" || params.column.colId == "PurchaseCurrencyPUC"
    ) {
      this.hasUnsavedChanges = true;
      if (params.node.data.EQId != 0) {
        let isPushed = false;
        if (this.modifiedGridData.length == 0) {
          this.modifiedGridData.push(params.node.data);
          isPushed = true;
        }
        else {
          this.modifiedGridData.forEach(row => {
            if (params.node.data.EQId == row.EQId) {
              isPushed = true;
            }
          })
        }
        if (!isPushed) {
          this.modifiedGridData.push(params.node.data);
        }
      }
    }

    this.configGridApi.refreshCells();
    this.refGridApi.redrawRows();
  }

  onGridConfigChanged(params) {
    // params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedConfig(params) {
    // if (this.sizeToFitRefreshConfig != 0) {
    //   params.api.sizeColumnsToFit()
    // }
  }

  getDisplayedLeafChildren(node) {
    const result = [];
    function recurse(currentNode) {
      if (currentNode.childrenAfterFilter) {
        currentNode.childrenAfterFilter.forEach(child => recurse(child));
      } else if (currentNode.data) {
        result.push(currentNode);
      }
    }
    recurse(node);
    return result;
  }

  loadRefGridStructure() {
    this.refColumnDefs = [
      {
        field: "Assembly",
        hide: true,
      },
      {
        field: "KMAT",
        hide: true,
      },
      {
        field: "KMATText",
        hide: true,
      },
      {
        field: "VBLO",
        hide: true,
      },
      {
        field: "VBLODescription",
        hide: true,
      },
      {
        field: "EcoId",
        hide: true,
      },
      {
        field: "GMKGroup",
        hide: true,
      },
      {
        field: "Plant",
        hide: true,
      },
      {
        field: "ProcurementType",
        hide: true,
      },
      {
        field: "SupplierNo",
        hide: true,
      },
      {
        field: "SupplierName1",
        hide: true,
      },
      {
        field: "SupplierName2",
        hide: true,
      },
      {
        field: "SupplierCountry",
        hide: true,
      },
      {
        field: "PurchaseCurrencyPUC",
        hide: true,
      },
      {
        field: "Component",
        hide: true,
      },
      {
        field: "ComponentDescription",
        hide: true,
      },
      {
        field: "Material",
        hide: true,
      },
      {
        field: "MaterialDescription",
        hide: true,
      },
      {
        headerName: "Actuals at Creation Date",
        headerTooltip: "Actuals at Creation Date",
        headerClass: "right-border left-border",
        children: [
          {
            headerName: "BKs per piece",
            headerClass: "right-border left-border",
            aggFunc: params => {
              let result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(child => {
                if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
                  result += Number(child.data.BKsPerPiece);
                }
              });
              return result;
            },
            cellClass: "left-border right-border colorTotal",
            field: "BKsPerPiece",
            tooltipField: "BKs per piece",
            headerTooltip: "BKs per piece",
            width: 88,
            editable: (params) => {
              if (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M"))) {
                return params.node.data.IsEditable;
              } else {
                return false;
              }
            },
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "MEKs per piece",
            headerClass: "right-border",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.ReferencceScenario.MEKsPerPiece;
                }
              });
              return result;
            },
            cellClass: "right-border colorTotal",
            field: "ReferencceScenario.MEKsPerPiece",
            tooltipField: "MEKs per piece",
            headerTooltip: "MEKs per piece",
            width: 88,
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")) {
                  let bk = params.node.data.BKsPerPiece;
                  let type = params.node.data.ProcurementType;
                  if (type == "E" || type == "" || type == "X") {
                    let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                    let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                    return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
                  } else {
                    return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
                  }
                } else {
                  return (params.node.data.ReferencceScenario.MEKsPerPiece);
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Qty",
            field: "ReferencceScenario.Quantity",
            tooltipField: "Quantity",
            width: 50,
            headerClass: "right-border",
            cellClass: (params) => {
              //if (!params.node.group) {
              return "right-border"
              //}
            },
            headerTooltip: "Quantity",
            singleClickEdit: true,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable;
              }
            },
            cellEditor: 'doublingEditor',
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "W",
            field: "ReferencceScenario.Weight",
            tooltipField: "Weight",
            width: 50,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Weight",
            singleClickEdit: true,
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
                  return false;
                }
                else {
                  return params.node.data.IsEditable;
                }
              }
            },
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "MEK per system",
            field: "ReferencceScenario.MEKPerSystem",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              return result;
            },
            tooltipField: "MEK per system",
            width: 88,
            cellClass: "colorTotal right-border",
            headerTooltip: "MEK per system",
            headerClass: "right-border",
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + node.data.ReferencceScenario.MEKPerSystem;
                    }

                  })

                  if (count == 0) {
                    total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
                  }
                  return params.node.data.ReferencceScenario.MEKPerSystem = total;
                  return total;


                } else {
                  params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
                  return params.node.data.ReferencceScenario.MEKPerSystem;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },

      {
        headerName: "Qty",
        field: "TargetScenario.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "TargetScenario.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "TargetScenario.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.TargetCostMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });

          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
            if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
              return 0;
            } else {
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
              return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      // {
      //   headerName: "Actuals (MEK)",
      //   field: "TargetScenario.ForecastMEK.ActualsMEK",
      //   hide: true,
      //   tooltipField: "Actuals (MEK)",
      //   width: 80,
      //   headerClass: "right-border",
      //   cellClass: "right-border colorTotal",
      //   aggFunc: params => {
      //     var result = 0;
      //     const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
      //     displayedLeafChildren.forEach(node => {
      //       if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //         result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
      //       }
      //     });
      //     return result;
      //   },
      //   headerTooltip: "Actuals (MEK)",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRendererReadOnly,
      //   cellRenderer: CurrencyCellRendererReadOnly,
      // },
      {
        headerName: "Actuals (MEK) per piece",
        field: "TargetScenario.ForecastMEK.ActualsMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per piece",
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
        hide: true,
        tooltipField: "Delta TC vs. ACT",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
              ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionA.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionA.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionA.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data?.Component === data?.Material) {
            let total = 0;
            let count = 0;

            params.api.forEachNode((node) => {
              const nodeData = node.data;
              if (
                !node.group &&
                nodeData?.Assembly === data?.Assembly &&
                nodeData?.KMAT === data?.KMAT &&
                nodeData?.VBLO === data?.VBLO &&
                nodeData?.Component === data?.Component &&
                nodeData?.Component !== nodeData?.Material
              ) {
                count++;
                total +=
                  Number(nodeData?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
            });

            if (count === 0) {
              total =
                Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            }

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
              return total;

            }


          } else if (!params.node.group) {
            const perPiece = Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0);
            const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
            const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            const total = perPiece * quantity * weight;

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
            }


          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (data && !data.HasChild && (data.IsActive == null || data.IsActive === true)) {
              target += Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100;
          // return ((target - ref) / ref) * 100;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
                return total;

              }

            } else {
              const perPiece = Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
              }

            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);

          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (
              data &&
              !data.HasChild &&
              (data.IsActive == null || data.IsActive === true)
            ) {
              target += Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (!data.hasOwnProperty("Pinned")) {
              const perSystem = Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

              let delta = perSystem - refMEK;
              if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
                delta = 0;
              } else {
                delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
              }
              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.DeltaFCVsRefMEK = delta;
              }

              return delta;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionA.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        hide: true,
        suppressColumnsToolPanel: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (
                  !node.group &&
                  node.data?.Assembly == params.node.data?.Assembly &&
                  node.data?.KMAT == params.node.data?.KMAT &&
                  node.data?.VBLO == params.node.data?.VBLO &&
                  node.data?.Component == params.node.data?.Component &&
                  node.data?.Component != node.data?.Material
                ) {
                  count++;
                  total +=
                    Number(node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });
              if (count == 0) {
                total =
                  Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionA.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionA?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionA.TargetCostMEK.PerSystem);
            }
          });
          // ...existing code...
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            // Only proceed if OptionA and its subfields exist
            const actualsMEKPerSystem = Number(data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem ?? 0);
            const targetPerSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);

            if (!data?.hasOwnProperty("Pinned")) {
              if ((actualsMEKPerSystem === 0 || data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem == null) &&
                (targetPerSystem === 0 || data?.OptionA?.TargetCostMEK?.PerSystem == null)) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (data?.OptionA?.ForecastMEK) {
                  data.OptionA.ForecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionB.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionB.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionB.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }

            if (data?.OptionB?.TargetCostMEK) {
              data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.ForecastMEK) {
              data.OptionB.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionB.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionB = nodeData?.OptionB;
                const nodeForecastMEK = nodeOptionB?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionB?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionB.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionB?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionB.TargetCostMEK.PerSystem);
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionC.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionC.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionC.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.TargetCostMEK) {
              data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.ForecastMEK) {
              data.OptionC.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionC.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionC = nodeData?.OptionC;
                const nodeForecastMEK = nodeOptionC?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionC?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionC.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true)
            ) {
              // Add full nullable checks before accessing properties
              if (
                node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
              ) {
                target += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
              }
              if (
                node.data.OptionC?.TargetCostMEK?.PerSystem != null
              ) {
                ref += Number(node.data.OptionC.TargetCostMEK.PerSystem);
              }
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
    ];

    this.getRowHeightRef = 25

    this.refDefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params.colDef.editable === 'function'
            ? !params.colDef.editable(params)
            : params.colDef.editable === false
      },
      // minWidth: 10,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
      filter: true
    }

    this.domLayoutRef = "autoHeight";

    this.refFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onRefGridReady(params: any) {
    this.refGridApi = params.api;
    this.refGridColumnApi = params.columnApi;
    this.refGridApi.setGroupHeaderHeight(20);
    this.refPinnedTopData = createDataRef(this.TCEQTargetCostSummaries, this.isEditable);
    this.sizeToFitRefreshRef = 1;

    setTimeout(() => {
      if (this.refSummaryGridApi != undefined) {
        let total = 0;
        this.refGridApi.forEachNodeAfterFilter(node => {
          if (
            !node.group &&
            node.data &&
            !node.data.HasChild &&
            (node.data.IsActive == null || node.data.IsActive == true)
          ) {
            total += Number(node.data.ReferencceScenario?.MEKPerSystem ?? 0);
          }
        });
        // Add a null check for gridDataSummary before using .find
        if (this.gridDataSummary && Array.isArray(this.gridDataSummary)) {
          const mekTotalObj = this.gridDataSummary.find(x => x.Name == "MEKTotal");
          if (mekTotalObj && mekTotalObj.ReferenceScenario) {
            mekTotalObj.ReferenceScenario.PerSystem = total;
          }
        }
        this.refSummaryGridApi.redrawRows();
      }

      if (this.tarSummaryGridApi != undefined) {
        let actualMekTotal = 0;
        this.tarGridApi.forEachNodeAfterFilter(node => {
          if (
            !node.group &&
            node.data &&
            !node.data.HasChild &&
            (node.data.IsActive == null || node.data.IsActive == true) &&
            node.data.TargetScenario?.ForecastMEK?.ActualsMEK != null
          ) {
            actualMekTotal += Number(node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem);
          }
        });

        if (this.gridDataSummary && Array.isArray(this.gridDataSummary)) {
          const data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
          if (data?.TargetScenario?.Forecast) {
            data.TargetScenario.Forecast.ActualMEKs = actualMekTotal;
          }
        }
        this.tarSummaryGridApi.redrawRows();
      }

      if (this.optASummaryGridApi != undefined) {
        let actualMekTotal = 0;
        this.optAGridApi.forEachNodeAfterFilter(node => {
          if (
            !node.group &&
            node.data &&
            !node.data.HasChild &&
            (node.data.IsActive == null || node.data.IsActive == true) &&
            node.data.OptionA?.ForecastMEK?.ActualsMEK != null
          ) {
            actualMekTotal += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
          }
        });

        if (this.gridDataSummary && Array.isArray(this.gridDataSummary)) {
          const data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
          if (data?.OptionA?.Forecast) {
            data.OptionA.Forecast.ActualMEKs = actualMekTotal;
          }
        }
        this.optASummaryGridApi.redrawRows();
      }

      if (this.optBSummaryGridApi != undefined) {
        let actualMekTotal = 0;
        this.optBGridApi.forEachNodeAfterFilter(node => {
          if (
            !node.group &&
            node.data &&
            !node.data.HasChild &&
            (node.data.IsActive == null || node.data.IsActive == true) &&
            node.data.OptionB?.ForecastMEK?.ActualsMEK != null
          ) {
            actualMekTotal += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
          }
        });

        if (this.gridDataSummary && Array.isArray(this.gridDataSummary)) {
          const data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
          if (data?.OptionB?.Forecast) {
            data.OptionB.Forecast.ActualMEKs = actualMekTotal;
          }
        }
        this.optBSummaryGridApi.redrawRows();
      }

      if (this.optCSummaryGridApi != undefined) {
        let actualMekTotal = 0;
        this.optCGridApi.forEachNodeAfterFilter(node => {
          if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
            actualMekTotal += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem)
          }
        })

        let data = this.gridDataSummary.find(x => x.Name === "MEKTotal");

        if (data?.OptionC?.Forecast) {
          data.OptionC.Forecast.ActualMEKs = actualMekTotal;
          this.optCSummaryGridApi.redrawRows();
        }

      }
    }, 1000);

    // this.setRowHeightsForDisplayAssembly(this.refGridApi);
  }

  onGridRefChanged(params) {
    this.refGridApi = params.api;
    this.refGridApi.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedRef(params) {
    if (this.sizeToFitRefreshRef != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onRefCellValueChanged(params) {
    if (params.column.colId == "VBLO") {
      let data = this.gridData.find(x => x.VBLO == params.value);
      if (data == undefined) {
        params.data.VBLO = "";
        params.data.VBLODescription = "Add Description";
        params.data.VBLOId = 0;
        params.data.KMATVBLOId = 0;
        params.data.KMATId = data.KMATId;
      } else {
        params.data.VBLOId = data.VBLOId;
        params.data.VBLODescription = data.VBLODescription;
        params.data.KMATVBLOId = data.KMATVBLOId;
        params.data.KMATId = data.KMATId;
      }
    }
    if (params.column.colId == "Component") {
      if (params.value == "Create new Component") params.data.Component = "";
    }

    this.refGridApi.refreshCells();
    this.tarGridApi.redrawRows();
    this.refGridApi.refreshClientSideRowModel('aggregate');

    let total = 0;
    this.refGridApi.forEachNodeAfterFilter(node => {
      if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        total += Number(node.data.ReferencceScenario.MEKPerSystem)
      }
    })
    this.gridDataSummary.find(x => x.Name == "MEKTotal").ReferenceScenario.PerSystem = total;
    this.refSummaryGridApi.redrawRows();

    if (this.optAGridApi != undefined) this.optAGridApi.redrawRows();
    if (this.optBGridApi != undefined) this.optBGridApi.redrawRows();
    if (this.optCGridApi != undefined) this.optCGridApi.redrawRows();

    this.hasUnsavedChanges = true;
    if (params.node.data.EQId != 0) {
      let isPushed = false;
      if (this.modifiedGridData.length == 0) {
        this.modifiedGridData.push(params.node.data);
        isPushed = true;
      }
      else {
        this.modifiedGridData.forEach(row => {
          if (params.node.data.EQId == row.EQId) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedGridData.push(params.node.data);
      }
    }

    if (this.TCSimulationData) {
      this.IsSimulationDataModified = true;
      const changedAssembly = params.data.Assembly;

      // 1. Calculate the total MEKPerSystem for the entire assembly group in the Ref grid
      let totalMEKPerSystem = this.getTotalMEKPerSystemForAssembly(this.getRefGridData(), changedAssembly);
      // this.refGridApi.forEachNode((node) => {
      //   if (
      //     !node.group &&
      //     node.data.Assembly === changedAssembly &&
      //     (node.data.IsActive == null || node.data.IsActive === true)
      //   ) {
      //     totalMEKPerSystem += Number(node.data.ReferencceScenario.MEKPerSystem) || 0;
      //   }
      // });

      // Find the corresponding simulation data for this assembly
      this.TCSimulationData.forEach(simulation => {
        if (simulation.Name === changedAssembly && simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
          simulation.CostValue = Number(totalMEKPerSystem).toFixed(0);
          simulation.UserId = this.userInOrg.UserId;
        }
        // Generalized for all non-Reference scenarios for this assembly
        if (
          simulation.Name === changedAssembly &&
          simulation.ScenarioType !== "Reference"
        ) {
          simulation.PercentageChange =
            simulation.CostValue == 0
              ? 0
              : (((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100).toFixed(2);
          simulation.UserId = this.userInOrg.UserId;
        }
        // if (simulation.Name === changedAssembly && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === changedAssembly && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Forecast") {
        //   simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === changedAssembly && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === changedAssembly && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === changedAssembly && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - totalMEKPerSystem) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
      });

      // let mekTotal = 0;
      // this.refGridApi.forEachNode(node => {
      //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //     mekTotal += Number(node.data.ReferencceScenario.MEKPerSystem)
      //   }
      // });

      // const updatedOverhead =
      //   mekTotal * (Number(this.bkFactorValue ?? 1) - 1) +
      //   Number(params.data.ReferenceScenario.PerSystem) * (Number(this.fkFactorValue ?? 1) - 1);
      const updatedOverhead = this.getOverheadData();

      // const updatedOverhead = this.refSummaryGridApi.getDisplayedRowAtIndex(7).data.ReferenceScenario.PerSystem;
      this.TCSimulationData.forEach(simulation => {
        if (simulation.Name === 'Overhead' && simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
          simulation.CostValue = Number(updatedOverhead).toFixed(0);
          simulation.UserId = this.userInOrg.UserId;
        }
        // Generalized for all non-Reference scenarios for this assembly
        if (
          simulation.Name === 'Overhead' &&
          simulation.ScenarioType !== "Reference"
        ) {
          simulation.PercentageChange =
            simulation.CostValue === 0
              ? 0
              : (((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100).toFixed(2);
          simulation.UserId = this.userInOrg.UserId;
        }
        // if (simulation.Name === 'Overhead' && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
        // if (simulation.Name === 'Overhead' && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
        //   simulation.PercentageChange = simulation.CostValue === 0 ? 0 : ((simulation.CostValue - updatedOverhead) / simulation.CostValue) * 100;
        //   simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        //   simulation.UserId = this.userInOrg.UserId;
        // }
      });
      //call the updateSummaryRowsInSimulationData function
      this.updateSummaryRowsInSimulationData();
    }
    // this.refGridApi.refreshClientSideRowModel('aggregate');
    this.tarGridApi.refreshClientSideRowModel('aggregate');
    if (this.optAVisible) this.optAGridApi.refreshClientSideRowModel('aggregate');
    if (this.optBVisible) this.optBGridApi.refreshClientSideRowModel('aggregate');
    if (this.optCVisible) this.optCGridApi.refreshClientSideRowModel('aggregate');
    // etc.
  }

  getTotalMEKPerSystemForAssembly(gridData: any[], assembly: string): number {
    let totalMEKPerSystem = 0;

    gridData.forEach((data: any) => {
      if (!data || !data.ReferencceScenario) return;

      // Handle IsActive as nullable: if null or true, it's active
      const isActive = data.IsActive == null || data.IsActive === true;
      if (!isActive || data.HasChild) return;

      if (data.Assembly !== assembly) return;

      let mekPerSystem = 0;

      if (data.Component === data.Material) {
        let total = 0;
        let count = 0;

        gridData.forEach(innerData => {
          if (!innerData || !innerData.ReferencceScenario) return;

          if (
            innerData.Assembly === data.Assembly &&
            innerData.KMAT === data.KMAT &&
            innerData.VBLO === data.VBLO &&
            innerData.Component === data.Component &&
            innerData.Component !== innerData.Material
          ) {
            count++;
            total += innerData.ReferencceScenario.MEKPerSystem || 0;
          }
        });

        mekPerSystem =
          count === 0
            ? (data.ReferencceScenario.MEKsPerPiece || 0) *
            (data.ReferencceScenario.Quantity || 0) *
            (data.ReferencceScenario.Weight || 0)
            : total;
      } else {
        mekPerSystem =
          (data.ReferencceScenario.MEKsPerPiece || 0) *
          (data.ReferencceScenario.Quantity || 0) *
          (data.ReferencceScenario.Weight || 0);
      }

      totalMEKPerSystem += mekPerSystem;
    });

    return Number(totalMEKPerSystem);
  }

  getGroupedDataByAssemblyForScenario(
    gridData: any[],
    scenarioKey: string,
    typeOfCost: string
  ): any[] {
    const groupedDataMap = new Map<string, any>();

    gridData.forEach((data: any) => {
      const scenarioObj = data?.[scenarioKey]?.[typeOfCost];
      const targetCostObj = data?.[scenarioKey]?.['TargetCostMEK'];
      if (!data || !scenarioObj || !targetCostObj) return;

      // Handle IsActive as nullable: if null or true, it's active
      const isActive = data.IsActive == null || data.IsActive === true;
      if (!isActive || data.HasChild) return;

      const assemblyKey = data.Assembly || '';
      let mekPerSystem = 0;

      // Always use Quantity and Weight from TargetCostMEK
      const quantity = Number(targetCostObj.Quantity) || 0;
      const weight = Number(targetCostObj.Weight) || 0;
      const perPiece = Number(scenarioObj.PerPiece) || Number(scenarioObj.MEKsPerPiece) || 0;
      const perSystem = Number(scenarioObj.PerSystem) || Number(scenarioObj.MEKPerSystem) || 0;

      if (data.Component === data.Material) {
        let total = 0;
        let count = 0;

        gridData.forEach(innerData => {
          const innerScenarioObj = innerData?.[scenarioKey]?.[typeOfCost];
          const innerTargetCostObj = innerData?.[scenarioKey]?.['TargetCostMEK'];
          if (!innerData || !innerScenarioObj || !innerTargetCostObj) return;

          if (
            innerData.Assembly === data.Assembly &&
            innerData.VBLO === data.VBLO &&
            innerData.Component === data.Component &&
            innerData.Component !== innerData.Material
          ) {
            count++;
            total += Number(innerScenarioObj.PerSystem) || Number(innerScenarioObj.MEKPerSystem) || 0;
          }
        });

        mekPerSystem =
          count === 0
            ? perPiece * quantity * weight
            : total;

      } else {
        mekPerSystem = perPiece * quantity * weight;
      }

      if (!groupedDataMap.has(assemblyKey)) {
        groupedDataMap.set(assemblyKey, {
          Assembly: assemblyKey,
          TotalMEKPerSystem: 0
        });
      }

      const current = groupedDataMap.get(assemblyKey);
      current.TotalMEKPerSystem += mekPerSystem;
    });

    return Array.from(groupedDataMap.values());
  }

  updateSummaryRowsInSimulationData() {
    if (!this.TCSimulationData) return;

    let assemblyGroupRefTotal = 0;
    let refTotal = 0;
    this.TCSimulationData.forEach(simulation => {
      if (simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
        if (simulation.Name !== "Total" && simulation.Name !== "Overhead" && simulation.Name !== "Labour" && simulation.Name !== "Assembly group") {
          assemblyGroupRefTotal += Number(simulation.CostValue) || 0;
        }
      }
    });
    this.TCSimulationData.forEach(row => {
      if (
        row.Name === "Assembly group" &&
        row.ScenarioType === "Reference" &&
        row.TypeOfCost === "Actuals"
      ) {
        row.CostValue = Number(assemblyGroupRefTotal).toFixed(0);
        row.UserId = this.userInOrg.UserId;
      }
    });

    //Update the this.TCSimulationData Assmbly group row PercentageChange = (TargetAbs value of the same obj - assemblyGroupRefTotal) / TargetAbs

    this.TCSimulationData.forEach(simulation => {
      if (simulation.Name === "Assembly group" && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - assemblyGroupRefTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Assembly group" && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - assemblyGroupRefTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Assembly group" && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - assemblyGroupRefTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Assembly group" && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - assemblyGroupRefTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
    });

    //Update the Total row
    this.TCSimulationData.forEach(simulation => {
      if (simulation.ScenarioType === "Reference" && simulation.TypeOfCost === "Actuals") {
        if (simulation.Name === "Overhead" || simulation.Name === "Labour" || simulation.Name === "Assembly group") {
          refTotal += Number(simulation.CostValue) || 0;
        }
      }
    });

    this.TCSimulationData.forEach(row => {
      if (
        row.Name === "Total" &&
        row.ScenarioType === "Reference" &&
        row.TypeOfCost === "Actuals"
      ) {
        row.CostValue = Number(refTotal).toFixed(0);
        row.UserId = this.userInOrg.UserId;
      }
    });
    // this.TCSimulationData.find(row => row.CostType === "Total" && row.ScenarioType === "Reference" && row.TypeOfCost === "Actuals").CostValue = refTotal;

    this.TCSimulationData.forEach(simulation => {
      if (simulation.Name === "Total" && simulation.ScenarioType === "Target" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - refTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Total" && simulation.ScenarioType === "OptionA" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - refTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Total" && simulation.ScenarioType === "OptionB" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - refTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
      if (simulation.Name === "Total" && simulation.ScenarioType === "OptionC" && simulation.TypeOfCost === "Target") {
        simulation.PercentageChange = simulation.CostValue == 0 ? 0 : ((simulation.CostValue - refTotal) / simulation.CostValue) * 100;
        simulation.PercentageChange = Number(simulation.PercentageChange).toFixed(2);
        simulation.UserId = this.userInOrg.UserId;
      }
    });

    // Calculate Assembly group sums (excluding Overhead, Labour, Assembly group, Total)
    // let assemblyGroupRef = 0;
    // let assemblyGroupTargetAbs = 0;

    // this.TCSimulationData.forEach(row => {
    //   if (
    //     row.CostType !== "Overhead" &&
    //     row.CostType !== "Labour" &&
    //     row.CostType !== "Assembly group" &&
    //     row.CostType !== "Total"
    //   ) {
    //     assemblyGroupRef += Number(row.CostValue) || 0;
    //     assemblyGroupTargetAbs += Number(row.PercentageChange) || 0;
    //   }
    // });

    // // Update Assembly group row
    // const assemblyGroupRow = this.TCSimulationData.find(row => row.CostType === "Assembly group");
    // if (assemblyGroupRow) {
    //   assemblyGroupRow.CostValue = assemblyGroupRef;
    //   assemblyGroupRow.PercentageChange = assemblyGroupTargetAbs;
    // }

    // // Calculate Total sums (Overhead, Labour, Assembly group)
    // let totalRef = 0;
    // let totalTargetAbs = 0;

    // this.TCSimulationData.forEach(row => {
    //   if (
    //     row.CostType === "Overhead" ||
    //     row.CostType === "Labour" ||
    //     row.CostType === "Assembly group"
    //   ) {
    //     totalRef += Number(row.CostValue) || 0;
    //     totalTargetAbs += Number(row.PercentageChange) || 0;
    //   }
    // });

    // // Update Total row
    // const totalRow = this.TCSimulationData.find(row => row.CostType === "Total");
    // if (totalRow) {
    //   totalRow.CostValue = totalRef;
    //   totalRow.PercentageChange = totalTargetAbs;
    // }
  }

  loadTarGridStructure() {
    this.tarColumnDefs = [
      {
        field: "Assembly",
        hide: true,
      },
      {
        field: "KMAT",
        hide: true,
      },
      {
        field: "KMATText",
        hide: true,
      },
      {
        field: "VBLO",
        hide: true,
      },
      {
        field: "VBLODescription",
        hide: true,
      },
      {
        field: "EcoId",
        hide: true,
      },
      {
        field: "GMKGroup",
        hide: true,
      },
      {
        field: "Plant",
        hide: true,
      },
      {
        field: "ProcurementType",
        hide: true,
      },
      {
        field: "SupplierNo",
        hide: true,
      },
      {
        field: "SupplierName1",
        hide: true,
      },
      {
        field: "SupplierName2",
        hide: true,
      },
      {
        field: "SupplierCountry",
        hide: true,
      },
      {
        field: "PurchaseCurrencyPUC",
        hide: true,
      },
      {
        field: "Material",
        hide: true,
      },
      {
        field: "MaterialDescription",
        hide: true,
      },
      {
        field: "Component",
        hide: true,
      },
      {
        field: "ComponentDescription",
        hide: true,
      },
      {
        headerName: "Target Cost (MEK)",
        headerTooltip: "Target Cost (MEK)",
        headerClass: "right-border left-border",
        children: [
          {
            headerName: "Qty",
            field: "TargetScenario.TargetCostMEK.Quantity",
            tooltipField: "Quantity",
            width: 50,
            headerClass: "right-border left-border",
            headerTooltip: "Quantity",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            cellClass: (params) => {
              //  if (!params.node.group) {
              return "right-border left-border"
              //}
            },
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "W",
            field: "TargetScenario.TargetCostMEK.Weight",
            tooltipField: "Weight",
            width: 50,
            headerTooltip: "Weight",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per piece",
            headerClass: "right-border left-border",
            field: "TargetScenario.TargetCostMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            cellClass: "right-border left-border",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "TargetScenario.TargetCostMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.TargetScenario.TargetCostMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  }
                  params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
                  return total;

                } else {
                  params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  return params.node.data.TargetScenario.TargetCostMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
            hide: false,
            tooltipField: "Delta TC vs. Reference MEK",
            headerTooltip: "Delta TC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.TargetScenario.TargetCostMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
                if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                  return 0;
                }
                else {
                  params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                  params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                  return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          }
        ]
      },
      {
        headerName: "Forecast (MEK)",
        headerTooltip: "Forecast (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "per piece",
            headerClass: "right-border",
            field: "TargetScenario.ForecastMEK.PerPiece",
            // tooltipField: "perpiece",
            headerTooltip: "perpiece",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (!params.node.group) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "right-border colorTotal";
                }
              }
              return "right-border";
            },
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
                if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return false;
                }
                return params.node.data.IsEditable;
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            // tooltipValueGetter: CurrencyCellRenderer,
            tooltipValueGetter: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "Automatically calculated Forecast based on supplier specific targets";
                }
              }
              return CurrencyCellRenderer(params);
            },
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "TargetScenario.ForecastMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.TargetScenario.ForecastMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  }
                  params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
                  return total;

                } else {
                  params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  return params.node.data.TargetScenario.ForecastMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
            tooltipField: "Delta FC vs. Reference MEK",
            headerTooltip: "Delta FC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.TargetScenario.ForecastMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                    return 0
                  }
                  else {
                    params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                    params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                    return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          }
        ]
      },
      {
        headerName: "Actuals (MEK)",
        headerTooltip: "Actuals (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "Actuals (MEK) per piece",
            field: "TargetScenario.ForecastMEK.ActualsMEK",
            tooltipField: "Actuals (MEK) per piece",
            width: 80,
            headerClass: "right-border",
            cellClass: "right-border colorTotal",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
                }
              });
              return result;
            },
            headerTooltip: "Actuals (MEK) per piece",
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          },
          {
            headerName: "Actuals (MEK) per system",
            headerClass: "right-border",
            field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
            tooltipField: "Actuals (MEK) per system",
            headerTooltip: "Actuals (MEK) per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  }
                  params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
                  return total;


                } else {
                  params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
                  return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          },
          {
            headerName: "Δ TC",
            field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
            tooltipField: "Delta TC vs. ACT",
            width: 50,
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
                  ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
                }
              });
              // if(ref===0)
              // result=100;
              // else
              // result = ((target - ref) / ref) * 100;
              // return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            headerTooltip: "Delta TC vs. ACT",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                    params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                    return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            },
          }
        ]
      },
      {
        headerName: "BKs per piece",
        headerClass: "right-border left-border",
        aggFunc: params => {
          let result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(child => {
            if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
              result += Number(child.data.BKsPerPiece);
            }
          });
          return result;
        },
        cellClass: "left-border right-border colorTotal",
        field: "BKsPerPiece",
        hide: true,
        tooltipField: "BKs per piece",
        headerTooltip: "BKs per piece",
        width: 88,
        editable: (params) => {
          if (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M"))) {
            return params.node.data.IsEditable;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "MEKs per piece",
        headerClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKsPerPiece;
            }
          });
          return result;
        },
        cellClass: "right-border colorTotal",
        field: "ReferencceScenario.MEKsPerPiece",
        hide: true,
        tooltipField: "MEKs per piece",
        headerTooltip: "MEKs per piece",
        width: 88,
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")) {
              let bk = params.node.data.BKsPerPiece;
              let type = params.node.data.ProcurementType;
              if (type == "E" || type == "" || type == "X") {
                let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
              } else {
                return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
              }
            } else {
              return (params.node.data.ReferencceScenario.MEKsPerPiece);
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Qty",
        field: "ReferencceScenario.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        headerTooltip: "Quantity",
        singleClickEdit: true,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "W",
        field: "ReferencceScenario.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Weight",
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
              return false;
            }
            else {
              return params.node.data.IsEditable;
            }
          }
        },
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "MEK per system",
        field: "ReferencceScenario.MEKPerSystem",
        hide: true,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          return result;
        },
        tooltipField: "MEK per system",
        width: 88,
        cellClass: "colorTotal right-border",
        headerTooltip: "MEK per system",
        headerClass: "right-border",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + node.data.ReferencceScenario.MEKPerSystem;
                }
              })
              if (count == 0) {
                total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              }
              params.node.data.ReferencceScenario.MEKPerSystem = total;
              return total;

            } else {
              params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              return params.node.data.ReferencceScenario.MEKPerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Qty",
        field: "OptionA.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "W",
        field: "OptionA.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionA.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data?.Component === data?.Material) {
            let total = 0;
            let count = 0;

            params.api.forEachNode((node) => {
              const nodeData = node.data;
              if (
                !node.group &&
                nodeData?.Assembly === data?.Assembly &&
                nodeData?.KMAT === data?.KMAT &&
                nodeData?.VBLO === data?.VBLO &&
                nodeData?.Component === data?.Component &&
                nodeData?.Component !== nodeData?.Material
              ) {
                count++;
                total +=
                  Number(nodeData?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
            });

            if (count === 0) {
              total =
                Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            }

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
              return total;

            }


          } else if (!params.node.group) {
            const perPiece = Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0);
            const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
            const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            const total = perPiece * quantity * weight;

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
            }


          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (data && !data.HasChild && (data.IsActive == null || data.IsActive === true)) {
              target += Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100;
          // return ((target - ref) / ref) * 100;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            }
            else {

              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
                return total;

              }

            } else {
              const perPiece = Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
              }

            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);

          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (
              data &&
              !data.HasChild &&
              (data.IsActive == null || data.IsActive === true)
            ) {
              target += Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100; // Avoid division by zero

          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (!data.hasOwnProperty("Pinned")) {
              const perSystem = Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

              let delta = perSystem - refMEK;
              if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
                delta = 0;
              } else {
                delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
              }
              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.DeltaFCVsRefMEK = delta;
              }

              return delta;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionA.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        hide: true,
        suppressColumnsToolPanel: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (
                  !node.group &&
                  node.data?.Assembly == params.node.data?.Assembly &&
                  node.data?.KMAT == params.node.data?.KMAT &&
                  node.data?.VBLO == params.node.data?.VBLO &&
                  node.data?.Component == params.node.data?.Component &&
                  node.data?.Component != node.data?.Material
                ) {
                  count++;
                  total +=
                    Number(node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });
              if (count == 0) {
                total =
                  Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionA.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionA?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionA.TargetCostMEK.PerSystem);
            }
          });
          // ...existing code...
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            // Only proceed if OptionA and its subfields exist
            const actualsMEKPerSystem = Number(data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem ?? 0);
            const targetPerSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);

            if (!data?.hasOwnProperty("Pinned")) {
              if ((actualsMEKPerSystem === 0 || data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem == null) &&
                (targetPerSystem === 0 || data?.OptionA?.TargetCostMEK?.PerSystem == null)) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (data?.OptionA?.ForecastMEK) {
                  data.OptionA.ForecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Qty",
        field: "OptionB.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "W",
        field: "OptionB.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionB.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.TargetCostMEK) {
              data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.ForecastMEK) {
              data.OptionB.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionB.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionB = nodeData?.OptionB;
                const nodeForecastMEK = nodeOptionB?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionB?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionB.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionB?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionB.TargetCostMEK.PerSystem);
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Qty",
        field: "OptionC.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "W",
        field: "OptionC.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionC.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);


              }

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
                return total;
              }



            } else {
              const perPiece = Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.TargetCostMEK) {
              data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
                return total;
              }



            } else {
              const perPiece = Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }

            if (data?.OptionC?.ForecastMEK) {
              data.OptionC.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionC.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionC = nodeData?.OptionC;
                const nodeForecastMEK = nodeOptionC?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionC?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
      {
        headerName: "Δ TC",
        field: "OptionC.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true)
            ) {
              // Add full nullable checks before accessing properties
              if (
                node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
              ) {
                target += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
              }
              if (
                node.data.OptionC?.TargetCostMEK?.PerSystem != null
              ) {
                ref += Number(node.data.OptionC.TargetCostMEK.PerSystem);
              }
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        },
      },
    ]

    this.getRowHeightTar = 25;

    this.tarDefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params.colDef.editable === 'function'
            ? !params.colDef.editable(params)
            : params.colDef.editable === false
      },
      // minWidth: 10,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
      filter: true
    }

    this.domLayoutTar = "autoHeight";

    this.tarFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onTarGridReady(params: any) {
    this.tarGridApi = params.api;
    this.tarGridColumnApi = params.columnApi;
    this.tarGridApi.setGroupHeaderHeight(20);
    this.sizeToFitRefreshTar = 1;

    if (this.gridDataSummary != undefined) {
      this.calculateSummaryMekTotalTarget();
    }

    grids = document.querySelectorAll('.ag-body-viewport'); // Adjust selector based on your AG Grid structure
    // Attach the scroll event listener to all grids
    grids.forEach(grid => {
      grid.addEventListener('scroll', syncVerticalScroll);
    });
    // this.setRowHeightsForDisplayAssembly(this.tarGridApi);
  }

  onGridTarChanged(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedTar(params) {
    if (this.sizeToFitRefreshTar != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  calculateSummaryMekTotalRef() {
    let total = 0;
    this.refGridApi.forEachNodeAfterFilter(node => {
      if (!node.group && !node.data?.HasChild && (node.data.IsActive == null || node.data?.IsActive == true)) {
        total += Number(node.data?.ReferencceScenario?.MEKPerSystem ?? 0)
      }
    })
    this.gridDataSummary.find(x => x.Name == "MEKTotal").ReferenceScenario.PerSystem = total;
    this.refSummaryGridApi.redrawRows();
  }

  calculateSummaryMekTotalTarget() {
    let targetCostTotal = 0;
    let forecastTotal = 0;
    let actualTotal = 0;
    this.tarGridApi.forEachNodeAfterFilter(node => {
      if (
        !node.group &&
        node.data &&
        !node.data.HasChild &&
        (node.data.IsActive == null || node.data.IsActive == true)
      ) {
        // Add null checks before accessing nested properties
        if (node.data.TargetScenario?.TargetCostMEK?.PerSystem != null) {
          targetCostTotal += Number(node.data.TargetScenario.TargetCostMEK.PerSystem);
        }
        if (node.data.TargetScenario?.ForecastMEK?.PerSystem != null) {
          forecastTotal += Number(node.data.TargetScenario.ForecastMEK.PerSystem);
        }
        // Keep ActualsMEKPerSystem for actualTotal calculation
        if (node.data.TargetScenario?.ForecastMEK?.ActualsMEKPerSystem != null) {
          actualTotal += Number(node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem);
        }
      }
    });

    // Defensive checks before assignment
    const data = this.gridDataSummary?.find(x => x.Name == "MEKTotal");
    if (data?.TargetScenario?.TargetCost) {
      data.TargetScenario.TargetCost.PerSystem = targetCostTotal;
    }
    if (data?.TargetScenario?.Forecast) {
      data.TargetScenario.Forecast.PerSystem = forecastTotal;
      data.TargetScenario.Forecast.ActualMEKs = actualTotal;
    }
    this.tarSummaryGridApi.redrawRows();
    // This will force AG Grid to re-evaluate valueGetters and cellRenderers for all rows
    // this.tarSummaryGridApi.refreshCells({ force: true });

    // // If you use aggregation, also call:
    // this.tarSummaryGridApi.refreshClientSideRowModel('aggregate');
  }

  calculateSummaryMekTotalOptionA() {
    let targetCostTotal = 0;
    let forecastTotal = 0;
    let actualTotal = 0;
    this.optAGridApi.forEachNodeAfterFilter(node => {
      if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        targetCostTotal += Number(node.data.OptionA.TargetCostMEK.PerSystem)
        forecastTotal += Number(node.data.OptionA.ForecastMEK.PerSystem)
        actualTotal += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem)
      }
    })

    let data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
    data.OptionA.TargetCost.PerSystem = targetCostTotal;
    data.OptionA.Forecast.PerSystem = forecastTotal;
    data.OptionA.Forecast.ActualMEKs = actualTotal;
    this.optASummaryGridApi.redrawRows();
  }

  calculateSummaryMekTotalOptionB() {
    let targetCostTotal = 0;
    let forecastTotal = 0;
    let actualTotal = 0;
    this.optBGridApi.forEachNodeAfterFilter(node => {
      if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        targetCostTotal += Number(node.data.OptionB.TargetCostMEK.PerSystem)
        forecastTotal += Number(node.data.OptionB.ForecastMEK.PerSystem)
        actualTotal += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem)
      }
    })

    let data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
    data.OptionB.TargetCost.PerSystem = targetCostTotal;
    data.OptionB.Forecast.PerSystem = forecastTotal;
    data.OptionB.Forecast.ActualMEKs = actualTotal;
    this.optBSummaryGridApi.redrawRows();
  }

  calculateSummaryMekTotalOptionC() {
    let targetCostTotal = 0;
    let forecastTotal = 0;
    let actualTotal = 0;
    this.optCGridApi.forEachNodeAfterFilter(node => {
      if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        targetCostTotal += Number(node.data.OptionC.TargetCostMEK.PerSystem)
        forecastTotal += Number(node.data.OptionC.ForecastMEK.PerSystem)
        actualTotal += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem)
      }
    })

    let data = this.gridDataSummary.find(x => x.Name == "MEKTotal");
    data.OptionC.TargetCost.PerSystem = targetCostTotal;
    data.OptionC.Forecast.PerSystem = forecastTotal;
    data.OptionC.Forecast.ActualMEKs = actualTotal;
    this.optCSummaryGridApi.redrawRows();
  }

  onTarCellValueChanged(params) {
    this.tarGridApi.redrawRows();
    this.tarGridApi.refreshClientSideRowModel('aggregate');

    this.calculateSummaryMekTotalTarget();

    this.hasUnsavedChanges = true;

    if (params.node.data) {
      const assemblyName = params.node.data.Assembly;

      // 1. Get the latest Target MEK total for this assembly using your grouping method (uses TargetCostMEK's Quantity/Weight)
      const grouped = this.getGroupedDataByAssemblyForScenario(
        this.getRefGridData(),
        "TargetScenario",
        "TargetCostMEK"
      );
      const targetCostValue = grouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;

      // 2. Get the Reference value using getTotalMEKPerSystemForAssembly (uses Reference scenario's Quantity/Weight)
      const referenceCostValue = this.getTotalMEKPerSystemForAssembly(
        this.getRefGridData(),
        assemblyName
      );
      // 3. Update only new and unconfirmed simulation rows
      this.TCSimulationData.forEach(sim => {
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "Target" &&
          sim.TypeOfCost === "Target" &&
          sim.IsNewAndUnconfirmed // Only update if still unconfirmed
        ) {
          sim.CostValue = targetCostValue;
          sim.PercentageChange = targetCostValue !== 0
            ? Number((((targetCostValue - referenceCostValue) / targetCostValue) * 100).toFixed(2))
            : 0;
        }
        // If you want to update Forecast rows as well, add similar logic here:
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "Target" &&
          sim.TypeOfCost === "Forecast" &&
          sim.IsNewAndUnconfirmed
        ) {
          // Get Forecast MEK total for this assembly
          const forecastGrouped = this.getGroupedDataByAssemblyForScenario(
            this.getRefGridData(),
            "TargetScenario",
            "ForecastMEK"
          );
          const forecastCostValue = forecastGrouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;
          sim.CostValue = forecastCostValue;
          sim.PercentageChange = forecastCostValue !== 0
            ? Number((((forecastCostValue - referenceCostValue) / forecastCostValue) * 100).toFixed(2))
            : 0;
        }
      });
    }

    if (params.node.data.EQId != 0) {
      let isPushed = false;
      if (this.modifiedGridData.length == 0) {
        this.modifiedGridData.push(params.node.data);
        isPushed = true;
      }
      else {
        this.modifiedGridData.forEach(row => {
          if (params.node.data.EQId == row.EQId) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedGridData.push(params.node.data);
      }
    }
  }


  loadOptAGridStructure() {
    this.optAColumnDefs = [
      {
        field: "Assembly",
        hide: true,
      },
      {
        field: "KMAT",
        hide: true,
      },
      {
        field: "KMATText",
        hide: true,
      },
      {
        field: "VBLO",
        hide: true,
      },
      {
        field: "VBLODescription",
        hide: true,
      },
      {
        field: "EcoId",
        hide: true,
      },
      {
        field: "GMKGroup",
        hide: true,
      },
      {
        field: "Plant",
        hide: true,
      },
      {
        field: "ProcurementType",
        hide: true,
      },
      {
        field: "SupplierNo",
        hide: true,
      },
      {
        field: "SupplierName1",
        hide: true,
      },
      {
        field: "SupplierName2",
        hide: true,
      },
      {
        field: "SupplierCountry",
        hide: true,
      },
      {
        field: "PurchaseCurrencyPUC",
        hide: true,
      },
      {
        field: "Material",
        hide: true,
      },
      {
        field: "MaterialDescription",
        hide: true,
      },
      {
        field: "Component",
        hide: true,
      },
      {
        field: "ComponentDescription",
        hide: true,
      },
      {
        headerName: "Target Cost (MEK)",
        headerTooltip: "Target Cost (MEK)",
        headerClass: "right-border left-border",
        children: [
          {
            headerName: "Qty",
            field: "OptionA.TargetCostMEK.Quantity",
            tooltipField: "Quantity",
            width: 50,
            headerClass: "right-border left-border",
            headerTooltip: "Quantity",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            cellClass: (params) => {
              // if (!params.node.group) {
              return "right-border left-border"
              //}
            },
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "W",
            field: "OptionA.TargetCostMEK.Weight",
            tooltipField: "Weight",
            width: 50,
            headerTooltip: "Weight",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per piece",
            headerClass: "right-border left-border",
            field: "OptionA.TargetCostMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            cellClass: "right-border left-border",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionA.TargetCostMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionA.TargetCostMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionA.TargetCostMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionA.TargetCostMEK.PerPiece)) * (Number(node.data.OptionA.TargetCostMEK.Quantity)) * (Number(node.data.OptionA.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionA.TargetCostMEK.PerPiece * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionA.TargetCostMEK.PerSystem = total;
                  return total;

                } else {
                  params.node.data.OptionA.TargetCostMEK.PerSystem = params.node.data.OptionA.TargetCostMEK.PerPiece * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  return params.node.data.OptionA.TargetCostMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
            tooltipField: "Delta TC vs. Reference MEK",
            headerTooltip: "Delta TC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionA.TargetCostMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
                if ((params.node.data.OptionA.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionA.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                  return 0;
                } else {
                  params.node.data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.OptionA.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                  params.node.data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionA.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100

                  return params.node.data.OptionA.TargetCostMEK.DeltaTCVsRefMEK;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast (MEK)",
        headerTooltip: "Forecast (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "per piece",
            headerClass: "right-border",
            field: "OptionA.ForecastMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (!params.node.group) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "right-border colorTotal";
                }
              }
              return "right-border";
            },
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionA.ForecastMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
                if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return false;
                }
                return params.node.data.IsEditable;
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            // tooltipValueGetter: CurrencyCellRenderer,
            tooltipValueGetter: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "Automatically calculated Forecast based on supplier specific targets";
                }
              }
              return CurrencyCellRenderer(params);
            },
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionA.ForecastMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionA.ForecastMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionA.ForecastMEK.PerPiece)) * (Number(node.data.OptionA.TargetCostMEK.Quantity)) * (Number(node.data.OptionA.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionA.ForecastMEK.PerPiece * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionA.ForecastMEK.PerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionA.ForecastMEK.PerSystem = params.node.data.OptionA.ForecastMEK.PerPiece * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  return params.node.data.OptionA.ForecastMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
            tooltipField: "Delta FC vs. Reference MEK",
            headerTooltip: "Delta FC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionA.ForecastMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionA.ForecastMEK.PerSystem == null || Number(params.node.data.OptionA.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionA.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.OptionA.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                    params.node.data.OptionA.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionA.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                    return params.node.data.OptionA.ForecastMEK.DeltaFCVsRefMEK;
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals (MEK)",
        headerTooltip: "Actuals (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "Actuals (MEK) per piece",
            field: "OptionA.ForecastMEK.ActualsMEK",
            tooltipField: "Actuals (MEK) per piece",
            width: 80,
            headerClass: "right-border",
            cellClass: "right-border colorTotal",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionA.ForecastMEK.ActualsMEK;
                }
              });
              return result;
            },
            headerTooltip: "Actuals (MEK) per piece",
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Actuals (MEK) per system",
            headerClass: "right-border",
            field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
            tooltipField: "Actuals (MEK) per system",
            headerTooltip: "Actuals (MEK) per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionA.ForecastMEK.ActualsMEKPerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionA.ForecastMEK.ActualsMEK)) * (Number(node.data.OptionA.TargetCostMEK.Quantity)) * (Number(node.data.OptionA.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionA.ForecastMEK.ActualsMEK * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                  return total;

                } else {
                  params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = params.node.data.OptionA.ForecastMEK.ActualsMEK * params.node.data.OptionA.TargetCostMEK.Quantity * params.node.data.OptionA.TargetCostMEK.Weight;
                  return params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ TC",
            field: "OptionA.ForecastMEK.DeltaTCVsACT",
            tooltipField: "Delta TC vs. ACT",
            width: 50,
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionA.ForecastMEK.ActualsMEKPerSystem;
                  ref += node.data.OptionA.TargetCostMEK.PerSystem;
                }
              });
              // if(ref===0)
              // result=100;
              // else
              // result = ((target - ref) / ref) * 100;
              // return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            headerTooltip: "Delta TC vs. ACT",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.OptionA.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionA.TargetCostMEK.PerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionA.ForecastMEK.DeltaTCVsACT = Number(params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.OptionA.TargetCostMEK.PerSystem)
                    params.node.data.OptionA.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.OptionA.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.OptionA.ForecastMEK.DeltaTCVsACT / Number(params.node.data.OptionA.TargetCostMEK.PerSystem)) * 100
                    return params.node.data.OptionA.ForecastMEK.DeltaTCVsACT
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "BKs per piece",
        headerClass: "right-border left-border",
        aggFunc: params => {
          let result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(child => {
            if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
              result += Number(child.data.BKsPerPiece);
            }
          });
          return result;
        },
        cellClass: "left-border right-border colorTotal",
        field: "BKsPerPiece",
        hide: true,
        tooltipField: "BKs per piece",
        headerTooltip: "BKs per piece",
        width: 88,
        editable: (params) => {
          if (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M"))) {
            return params.node.data.IsEditable;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEKs per piece",
        headerClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKsPerPiece;
            }
          });
          return result;
        },
        cellClass: "right-border colorTotal",
        field: "ReferencceScenario.MEKsPerPiece",
        hide: true,
        tooltipField: "MEKs per piece",
        headerTooltip: "MEKs per piece",
        width: 88,
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")) {
              let bk = params.node.data.BKsPerPiece;
              let type = params.node.data.ProcurementType;
              if (type == "E" || type == "" || type == "X") {
                let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
              } else {
                return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
              }
            } else {
              return (params.node.data.ReferencceScenario.MEKsPerPiece);
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "ReferencceScenario.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        headerTooltip: "Quantity",
        singleClickEdit: true,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "ReferencceScenario.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Weight",
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
              return false;
            }
            else {
              return params.node.data.IsEditable;
            }
          }
        },
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEK per system",
        field: "ReferencceScenario.MEKPerSystem",
        hide: true,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          return result;
        },
        tooltipField: "MEK per system",
        width: 88,
        cellClass: "colorTotal right-border",
        headerTooltip: "MEK per system",
        headerClass: "right-border",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + node.data.ReferencceScenario.MEKPerSystem;
                }
              })
              if (count == 0) {
                total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              }
              params.node.data.ReferencceScenario.MEKPerSystem = total;
              return total;


            } else {
              params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              return params.node.data.ReferencceScenario.MEKPerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "TargetScenario.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border ",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "TargetScenario.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "TargetScenario.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.TargetCostMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
            if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
              return 0;
            } else {
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
              return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      // {
      //   headerName: "Actuals (MEK)",
      //   field: "TargetScenario.ForecastMEK.ActualsMEK",
      //   hide: true,
      //   tooltipField: "Actuals (MEK)",
      //   width: 80,
      //   headerClass: "right-border",
      //   cellClass: "right-border colorTotal",
      //   aggFunc: params => {
      //     var result = 0;
      //     const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
      //     displayedLeafChildren.forEach(node => {
      //       if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //         result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
      //       }
      //     });
      //     return result;
      //   },
      //   headerTooltip: "Actuals (MEK)",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRendererReadOnly,
      //   cellRenderer: CurrencyCellRendererReadOnly,
      // },
      {
        headerName: "Actuals (MEK) per piece",
        field: "TargetScenario.ForecastMEK.ActualsMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per piece",
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
              return total;

            } else {
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
        hide: true,
        tooltipField: "Delta TC vs. ACT",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
              ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionB.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionB.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionB.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.TargetCostMEK) {
              data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.ForecastMEK) {
              data.OptionB.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionB.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionB = nodeData?.OptionB;
                const nodeForecastMEK = nodeOptionB?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionB?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionB.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionB?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionB.TargetCostMEK.PerSystem);
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionC.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionC.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionC.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.TargetCostMEK) {
              data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
          return result;
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.ForecastMEK) {
              data.OptionC.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionC.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionC = nodeData?.OptionC;
                const nodeForecastMEK = nodeOptionC?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionC?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionC.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true)
            ) {
              // Add full nullable checks before accessing properties
              if (
                node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
              ) {
                target += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
              }
              if (
                node.data.OptionC?.TargetCostMEK?.PerSystem != null
              ) {
                ref += Number(node.data.OptionC.TargetCostMEK.PerSystem);
              }
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
    ]

    this.getRowHeightoptA = 25;

    this.optADefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params?.colDef?.editable === 'function'
            ? !params?.colDef?.editable(params)
            : params?.colDef?.editable === false
      },
      // minWidth: 10,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
      filter: true
    }

    this.OptADomLayout = "autoHeight";

    this.optAFrameworkComponents = {
      doublingEditor: DoublingEditorComponent
    };
  }

  onOptAGridReady(params: any) {
    this.optAGridApi = params.api;
    this.optAGridColumnApi = params.columnApi;
    this.optAGridApi.setGroupHeaderHeight(20);
    this.sizeToFitRefreshOptA = 1;

    if (this.gridDataSummary != undefined) {
      this.calculateSummaryMekTotalOptionA();
    }

    grids = document.querySelectorAll('.ag-body-viewport'); // Adjust selector based on your AG Grid structure
    // Attach the scroll event listener to all grids
    grids.forEach(grid => {
      grid.addEventListener('scroll', syncVerticalScroll);
    });

    // setTimeout(() => {
    //   this.isExpanded = !this.isExpanded;
    //   this.onExpandCollapse();
    // }, 100);
    this.optAGridColumnApi.setRowGroupColumns(this.groupedColumns);
    this.optAGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false,
    })
  }

  onGridOptAChanged(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChangedOptA(params) {
    if (this.sizeToFitRefreshOptA != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onOptACellValueChangedCS(params) {
    this.optAGridApi.redrawRows();
    this.optAGridApi.refreshClientSideRowModel('aggregate');

    this.calculateSummaryMekTotalOptionA();

    this.hasUnsavedChanges = true;

    if (params.node.data) {
      const assemblyName = params.node.data.Assembly;

      // 1. Get the latest Target MEK total for this assembly using your grouping method (uses TargetCostMEK's Quantity/Weight)
      const grouped = this.getGroupedDataByAssemblyForScenario(
        this.getRefGridData(),
        "OptionA",
        "TargetCostMEK"
      );
      const targetCostValue = grouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;

      // 2. Get the Reference value using getTotalMEKPerSystemForAssembly (uses Reference scenario's Quantity/Weight)
      const referenceCostValue = this.getTotalMEKPerSystemForAssembly(
        this.getRefGridData(),
        assemblyName
      );

      // 3. Update only new and unconfirmed simulation rows
      this.TCSimulationData.forEach(sim => {
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionA" &&
          sim.TypeOfCost === "Target" &&
          sim.IsNewAndUnconfirmed // Only update if still unconfirmed
        ) {
          sim.CostValue = targetCostValue;
          sim.PercentageChange = targetCostValue !== 0
            ? Number((((targetCostValue - referenceCostValue) / targetCostValue) * 100).toFixed(2))
            : 0;
        }
        // If you want to update Forecast rows as well, add similar logic here:
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionA" &&
          sim.TypeOfCost === "Forecast" &&
          sim.IsNewAndUnconfirmed
        ) {
          // Get Forecast MEK total for this assembly
          const forecastGrouped = this.getGroupedDataByAssemblyForScenario(
            this.getRefGridData(),
            "OptionA",
            "ForecastMEK"
          );
          const forecastCostValue = forecastGrouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;
          sim.CostValue = forecastCostValue;
          sim.PercentageChange = forecastCostValue !== 0
            ? Number((((forecastCostValue - referenceCostValue) / forecastCostValue) * 100).toFixed(2))
            : 0;
        }
      });
    }

    if (params.node.data.OptionA.TargetCostMEK.EQId != 0) {
      let isPushed = false;
      if (this.modifiedGridData.length == 0) {
        this.modifiedGridData.push(params.node.data);
        isPushed = true;
      }
      else {
        this.modifiedGridData.forEach(row => {
          if (params.node.data.EQId == row.EQId) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedGridData.push(params.node.data);
      }
    }
  }

  loadOptBGridStructure() {
    this.optBColumnDefs = [
      {
        field: "Assembly",
        hide: true,
      },
      {
        field: "KMAT",
        hide: true,
      },
      {
        field: "KMATText",
        hide: true,
      },
      {
        field: "VBLO",
        hide: true,
      },
      {
        field: "VBLODescription",
        hide: true,
      },
      {
        field: "EcoId",
        hide: true,
      },
      {
        field: "GMKGroup",
        hide: true,
      },
      {
        field: "Plant",
        hide: true,
      },
      {
        field: "ProcurementType",
        hide: true,
      },
      {
        field: "SupplierNo",
        hide: true,
      },
      {
        field: "SupplierName1",
        hide: true,
      },
      {
        field: "SupplierName2",
        hide: true,
      },
      {
        field: "SupplierCountry",
        hide: true,
      },
      {
        field: "PurchaseCurrencyPUC",
        hide: true,
      },
      {
        field: "Material",
        hide: true,
      },
      {
        field: "MaterialDescription",
        hide: true,
      },
      {
        field: "Component",
        hide: true,
      },
      {
        field: "ComponentDescription",
        hide: true,
      },

      {
        headerName: "Target Cost (MEK)",
        headerTooltip: "Target Cost (MEK)",
        headerClass: "right-border left-border",
        children: [
          {
            headerName: "Qty",
            field: "OptionB.TargetCostMEK.Quantity",
            tooltipField: "Quantity",
            width: 50,
            headerClass: "right-border left-border",
            headerTooltip: "Quantity",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            cellClass: (params) => {
              //if (!params.node.group) {
              return "right-border left-border"
              //  }
            },
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "W",
            field: "OptionB.TargetCostMEK.Weight",
            tooltipField: "Weight",
            width: 50,
            headerTooltip: "Weight",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per piece",
            headerClass: "right-border left-border",
            field: "OptionB.TargetCostMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            cellClass: "right-border left-border",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionB.TargetCostMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionB.TargetCostMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionB.TargetCostMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionB.TargetCostMEK.PerPiece)) * (Number(node.data.OptionB.TargetCostMEK.Quantity)) * (Number(node.data.OptionB.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionB.TargetCostMEK.PerPiece * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionB.TargetCostMEK.PerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionB.TargetCostMEK.PerSystem = params.node.data.OptionB.TargetCostMEK.PerPiece * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  return params.node.data.OptionB.TargetCostMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
            tooltipField: "Delta TC vs. Reference MEK",
            headerTooltip: "Delta TC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionB.TargetCostMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },

            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
                if ((params.node.data.OptionB.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionB.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                  return 0;
                } else {
                  params.node.data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.OptionB.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                  params.node.data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionB.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100

                  return params.node.data.OptionB.TargetCostMEK.DeltaTCVsRefMEK;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast (MEK)",
        headerTooltip: "Forecast (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "per piece",
            headerClass: "right-border",
            field: "OptionB.ForecastMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (!params.node.group) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "right-border colorTotal";
                }
              }
              return "right-border";
            },
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionB.ForecastMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
                if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return false;
                }
                return params.node.data.IsEditable;
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            // tooltipValueGetter: CurrencyCellRenderer,
            tooltipValueGetter: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "Automatically calculated Forecast based on supplier specific targets";
                }
              }
              return CurrencyCellRenderer(params);
            },
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionB.ForecastMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionB.ForecastMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionB.ForecastMEK.PerPiece)) * (Number(node.data.OptionB.TargetCostMEK.Quantity)) * (Number(node.data.OptionB.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionB.ForecastMEK.PerPiece * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionB.ForecastMEK.PerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionB.ForecastMEK.PerSystem = params.node.data.OptionB.ForecastMEK.PerPiece * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  return params.node.data.OptionB.ForecastMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
            tooltipField: "Delta FC vs. Reference MEK",
            headerTooltip: "Delta FC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionB.ForecastMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionB.ForecastMEK.PerSystem == null || Number(params.node.data.OptionB.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionB.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.OptionB.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                    params.node.data.OptionB.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionB.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                    return params.node.data.OptionB.ForecastMEK.DeltaFCVsRefMEK;
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals (MEK)",
        headerTooltip: "Actuals (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "Actuals (MEK) per piece",
            field: "OptionB.ForecastMEK.ActualsMEK",
            tooltipField: "Actuals (MEK) per piece",
            width: 80,
            headerClass: "right-border",
            cellClass: "right-border colorTotal",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionB.ForecastMEK.ActualsMEK;
                }
              });
              return result;
            },
            headerTooltip: "Actuals (MEK) per piece",
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Actuals (MEK) per system",
            headerClass: "right-border",
            field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
            tooltipField: "Actuals (MEK) per system",
            headerTooltip: "Actuals (MEK) per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionB.ForecastMEK.ActualsMEKPerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionB.ForecastMEK.ActualsMEK)) * (Number(node.data.OptionB.TargetCostMEK.Quantity)) * (Number(node.data.OptionB.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionB.ForecastMEK.ActualsMEK * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem = params.node.data.OptionB.ForecastMEK.ActualsMEK * params.node.data.OptionB.TargetCostMEK.Quantity * params.node.data.OptionB.TargetCostMEK.Weight;
                  return params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ TC",
            field: "OptionB.ForecastMEK.DeltaTCVsACT",
            tooltipField: "Delta TC vs. ACT",
            width: 50,
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionB.ForecastMEK.ActualsMEKPerSystem;
                  ref += node.data.OptionB.TargetCostMEK.PerSystem;
                }
              });
              // if(ref===0)
              // result=100;
              // else
              // result = ((target - ref) / ref) * 100;
              // return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            headerTooltip: "Delta TC vs. ACT",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.OptionB.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionB.TargetCostMEK.PerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionB.ForecastMEK.DeltaTCVsACT = Number(params.node.data.OptionB.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.OptionB.TargetCostMEK.PerSystem)
                    params.node.data.OptionB.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.OptionB.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.OptionB.ForecastMEK.DeltaTCVsACT / Number(params.node.data.OptionB.TargetCostMEK.PerSystem)) * 100
                    return params.node.data.OptionB.ForecastMEK.DeltaTCVsACT
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "BKs per piece",
        headerClass: "right-border left-border",
        aggFunc: params => {
          let result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(child => {
            if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
              result += Number(child.data.BKsPerPiece);
            }
          });
          return result;
        },
        cellClass: "left-border right-border colorTotal",
        field: "BKsPerPiece",
        hide: true,
        tooltipField: "BKs per piece",
        headerTooltip: "BKs per piece",
        width: 88,
        editable: (params) => {
          if (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M"))) {
            return params.node.data.IsEditable;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEKs per piece",
        headerClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKsPerPiece;
            }
          });
          return result;
        },
        cellClass: "right-border colorTotal",
        field: "ReferencceScenario.MEKsPerPiece",
        hide: true,
        tooltipField: "MEKs per piece",
        headerTooltip: "MEKs per piece",
        width: 88,
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")) {
              let bk = params.node.data.BKsPerPiece;
              let type = params.node.data.ProcurementType;
              if (type == "E" || type == "" || type == "X") {
                let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
              } else {
                return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
              }
            } else {
              return (params.node.data.ReferencceScenario.MEKsPerPiece);
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "ReferencceScenario.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        headerTooltip: "Quantity",
        singleClickEdit: true,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "ReferencceScenario.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Weight",
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
              return false;
            }
            else {
              return params.node.data.IsEditable;
            }
          }
        },
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEK per system",
        field: "ReferencceScenario.MEKPerSystem",
        hide: true,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          return result;
        },
        tooltipField: "MEK per system",
        width: 88,
        cellClass: "colorTotal right-border",
        headerTooltip: "MEK per system",
        headerClass: "right-border",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + node.data.ReferencceScenario.MEKPerSystem;
                }
              })
              if (count == 0) {
                total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              }
              params.node.data.ReferencceScenario.MEKPerSystem = total;
              return total;


            } else {
              params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              return params.node.data.ReferencceScenario.MEKPerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "TargetScenario.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "TargetScenario.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "TargetScenario.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.TargetCostMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
            if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
              return 0;
            } else {
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
              return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      // {
      //   headerName: "Actuals (MEK)",
      //   field: "TargetScenario.ForecastMEK.ActualsMEK",
      //   hide: true,
      //   tooltipField: "Actuals (MEK)",
      //   width: 80,
      //   headerClass: "right-border",
      //   cellClass: "right-border colorTotal",
      //   aggFunc: params => {
      //     var result = 0;
      //     const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
      //     displayedLeafChildren.forEach(node => {
      //       if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //         result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
      //       }
      //     });
      //     return result;
      //   },
      //   headerTooltip: "Actuals (MEK)",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRendererReadOnly,
      //   cellRenderer: CurrencyCellRendererReadOnly,
      // },
      {
        headerName: "Actuals (MEK) per piece",
        field: "TargetScenario.ForecastMEK.ActualsMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per piece",
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
        hide: true,
        tooltipField: "Delta TC vs. ACT",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
              ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionA.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionA.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionA.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data?.Component === data?.Material) {
            let total = 0;
            let count = 0;

            params.api.forEachNode((node) => {
              const nodeData = node.data;
              if (
                !node.group &&
                nodeData?.Assembly === data?.Assembly &&
                nodeData?.KMAT === data?.KMAT &&
                nodeData?.VBLO === data?.VBLO &&
                nodeData?.Component === data?.Component &&
                nodeData?.Component !== nodeData?.Material
              ) {
                count++;
                total +=
                  Number(nodeData?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
            });

            if (count === 0) {
              total =
                Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            }

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
              return total;

            }


          } else if (!params.node.group) {
            const perPiece = Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0);
            const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
            const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            const total = perPiece * quantity * weight;

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
            }


          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (data && !data.HasChild && (data.IsActive == null || data.IsActive === true)) {
              target += Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100;
          // return ((target - ref) / ref) * 100;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
                return total;

              }

            } else {
              const perPiece = Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
              }

            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);

          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (
              data &&
              !data.HasChild &&
              (data.IsActive == null || data.IsActive === true)
            ) {
              target += Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100; // Avoid division by zero

          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (!data.hasOwnProperty("Pinned")) {
              const perSystem = Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

              let delta = perSystem - refMEK;
              if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
                delta = 0;
              } else {
                delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
              }
              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.DeltaFCVsRefMEK = delta;
              }

              return delta;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionA.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        hide: true,
        suppressColumnsToolPanel: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (
                  !node.group &&
                  node.data?.Assembly == params.node.data?.Assembly &&
                  node.data?.KMAT == params.node.data?.KMAT &&
                  node.data?.VBLO == params.node.data?.VBLO &&
                  node.data?.Component == params.node.data?.Component &&
                  node.data?.Component != node.data?.Material
                ) {
                  count++;
                  total +=
                    Number(node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });
              if (count == 0) {
                total =
                  Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionA.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionA?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionA.TargetCostMEK.PerSystem);
            }
          });
          // ...existing code...
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            // Only proceed if OptionA and its subfields exist
            const actualsMEKPerSystem = Number(data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem ?? 0);
            const targetPerSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);

            if (!data?.hasOwnProperty("Pinned")) {
              if ((actualsMEKPerSystem === 0 || data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem == null) &&
                (targetPerSystem === 0 || data?.OptionA?.TargetCostMEK?.PerSystem == null)) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (data?.OptionA?.ForecastMEK) {
                  data.OptionA.ForecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionC.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionC.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionC.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.TargetCostMEK) {
                data.OptionC.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.TargetCostMEK) {
              data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionC?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionC?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionC?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionC?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionC?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionC?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionC?.ForecastMEK) {
                data.OptionC.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionC?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionC?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionC?.ForecastMEK) {
              data.OptionC.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionC.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionC = nodeData?.OptionC;
                const nodeForecastMEK = nodeOptionC?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionC?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionC.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true)
            ) {
              // Add full nullable checks before accessing properties
              if (
                node.data.OptionC?.ForecastMEK?.ActualsMEKPerSystem != null
              ) {
                target += Number(node.data.OptionC.ForecastMEK.ActualsMEKPerSystem);
              }
              if (
                node.data.OptionC?.TargetCostMEK?.PerSystem != null
              ) {
                ref += Number(node.data.OptionC.TargetCostMEK.PerSystem);
              }
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionC = data?.OptionC;
            const forecastMEK = optionC?.ForecastMEK;
            const targetCostMEK = optionC?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
    ]

    this.getRowHeightoptB = 25;

    this.optBDefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params?.colDef?.editable === 'function'
            ? !params?.colDef?.editable(params)
            : params?.colDef?.editable === false
      },
      // minWidth: 10,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
      filter: true
    }

    this.OptBDomLayout = "autoHeight";

    this.optBFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptBGridReady(params: any) {
    this.optBGridApi = params.api;
    this.optBGridColumnApi = params.columnApi;
    this.optBGridApi.setGroupHeaderHeight(20);
    this.sizeToFitRefreshOptB = 1;

    if (this.gridDataSummary != undefined) {
      this.calculateSummaryMekTotalOptionB();
    }

    grids = document.querySelectorAll('.ag-body-viewport'); // Adjust selector based on your AG Grid structure
    // Attach the scroll event listener to all grids
    grids.forEach(grid => {
      grid.addEventListener('scroll', syncVerticalScroll);
    });

    // setTimeout(() => {
    //   this.isExpanded = !this.isExpanded;
    //   this.onExpandCollapse();
    // }, 100);

    this.optBGridColumnApi.setRowGroupColumns(this.groupedColumns);
    this.optBGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false,
    })

  }

  onDisplayedColumnsChangedOptB(params) {
    if (this.sizeToFitRefreshOptB != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onGridOptBChanged(params) {
    params.api.sizeColumnsToFit();
  }

  onOptBCellValueChangedCS(params) {
    this.optBGridApi.redrawRows();
    this.optBGridApi.refreshClientSideRowModel('aggregate');

    this.calculateSummaryMekTotalOptionB();

    this.hasUnsavedChanges = true;

    if (params.node.data) {
      const assemblyName = params.node.data.Assembly;

      // 1. Get the latest Target MEK total for this assembly using your grouping method (uses TargetCostMEK's Quantity/Weight)
      const grouped = this.getGroupedDataByAssemblyForScenario(
        this.getRefGridData(),
        "OptionB",
        "TargetCostMEK"
      );
      const targetCostValue = grouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;

      // 2. Get the Reference value using getTotalMEKPerSystemForAssembly (uses Reference scenario's Quantity/Weight)
      const referenceCostValue = this.getTotalMEKPerSystemForAssembly(
        this.getRefGridData(),
        assemblyName
      );

      // 3. Update only new and unconfirmed simulation rows
      this.TCSimulationData.forEach(sim => {
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionB" &&
          sim.TypeOfCost === "Target" &&
          sim.IsNewAndUnconfirmed // Only update if still unconfirmed
        ) {
          sim.CostValue = targetCostValue;
          sim.PercentageChange = targetCostValue !== 0
            ? Number((((targetCostValue - referenceCostValue) / targetCostValue) * 100).toFixed(2))
            : 0;
        }
        // If you want to update Forecast rows as well, add similar logic here:
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionB" &&
          sim.TypeOfCost === "Forecast" &&
          sim.IsNewAndUnconfirmed
        ) {
          // Get Forecast MEK total for this assembly
          const forecastGrouped = this.getGroupedDataByAssemblyForScenario(
            this.getRefGridData(),
            "OptionB",
            "ForecastMEK"
          );
          const forecastCostValue = forecastGrouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;
          sim.CostValue = forecastCostValue;
          sim.PercentageChange = forecastCostValue !== 0
            ? Number((((forecastCostValue - referenceCostValue) / forecastCostValue) * 100).toFixed(2))
            : 0;
        }
      });
    }

    if (params.node.data.OptionB.TargetCostMEK.EQId != 0) {
      let isPushed = false;
      if (this.modifiedGridData.length == 0) {
        this.modifiedGridData.push(params.node.data);
        isPushed = true;
      }
      else {
        this.modifiedGridData.forEach(row => {
          if (params.node.data.EQId == row.EQId) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedGridData.push(params.node.data);
      }
    }
  }
  loadOptCGridStructure() {
    this.optCColumnDefs = [
      {
        field: "Assembly",
        hide: true,
      },

      {
        field: "KMAT",
        hide: true,
      },
      {
        field: "KMATText",
        hide: true,
      },
      {
        field: "VBLO",
        hide: true,
      },
      {
        field: "VBLODescription",
        hide: true,
      },
      {
        field: "EcoId",
        hide: true,
      },
      {
        field: "GMKGroup",
        hide: true,
      },
      {
        field: "Plant",
        hide: true,
      },
      {
        field: "ProcurementType",
        hide: true,
      },
      {
        field: "SupplierNo",
        hide: true,
      },
      {
        field: "SupplierName1",
        hide: true,
      },
      {
        field: "SupplierName2",
        hide: true,
      },
      {
        field: "SupplierCountry",
        hide: true,
      },
      {
        field: "PurchaseCurrencyPUC",
        hide: true,
      },
      {
        field: "Material",
        hide: true,
      },
      {
        field: "MaterialDescription",
        hide: true,
      },
      {
        field: "Component",
        hide: true,
      },
      {
        field: "ComponentDescription",
        hide: true,
      },
      {
        headerName: "Target Cost (MEK)",
        headerTooltip: "Target Cost (MEK)",
        headerClass: "right-border left-border",
        children: [
          {
            headerName: "Qty",
            field: "OptionC.TargetCostMEK.Quantity",
            tooltipField: "Quantity",
            width: 50,
            headerClass: "right-border left-border",
            headerTooltip: "Quantity",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            cellClass: (params) => {
              // if (!params.node.group) {
              return "right-border left-border"
              //  }
            },
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "W",
            field: "OptionC.TargetCostMEK.Weight",
            tooltipField: "Weight",
            width: 50,
            headerTooltip: "Weight",
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per piece",
            headerClass: "right-border left-border",
            field: "OptionC.TargetCostMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            cellClass: "right-border left-border",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionC.TargetCostMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                return params.node.data.IsEditable
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionC.TargetCostMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionC.TargetCostMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionC.TargetCostMEK.PerPiece)) * (Number(node.data.OptionC.TargetCostMEK.Quantity)) * (Number(node.data.OptionC.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionC.TargetCostMEK.PerPiece * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionC.TargetCostMEK.PerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionC.TargetCostMEK.PerSystem = params.node.data.OptionC.TargetCostMEK.PerPiece * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  return params.node.data.OptionC.TargetCostMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionC.TargetCostMEK.DeltaTCVsRefMEK",
            tooltipField: "Delta TC vs. Reference MEK",
            headerTooltip: "Delta TC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionC.TargetCostMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer, valueGetter: (params) => {
              if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
                if ((params.node.data.OptionC.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionC.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                  return 0;
                } else {
                  params.node.data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.OptionC.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                  params.node.data.OptionC.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionC.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100

                  return params.node.data.OptionC.TargetCostMEK.DeltaTCVsRefMEK;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast (MEK)",
        headerTooltip: "Forecast (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "per piece",
            headerClass: "right-border",
            field: "OptionC.ForecastMEK.PerPiece",
            tooltipField: "perpiece",
            headerTooltip: "perpiece",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (!params.node.group) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "right-border colorTotal";
                }
              }
              return "right-border";
            },
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += Number(node.data.OptionC.ForecastMEK.PerPiece);
                }
              });
              return result;
            },
            width: 80,
            editable: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
                if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return false;
                }
                return params.node.data.IsEditable;
              }
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            // tooltipValueGetter: CurrencyCellRenderer,
            tooltipValueGetter: (params) => {
              if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
                if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
                  return "Automatically calculated Forecast based on supplier specific targets";
                }
              }
              return CurrencyCellRenderer(params);
            },
            cellRenderer: CurrencyCellRenderer,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "per system",
            headerClass: "right-border",
            field: "OptionC.ForecastMEK.PerSystem",
            tooltipField: "per system",
            headerTooltip: "per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionC.ForecastMEK.PerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionC.ForecastMEK.PerPiece)) * (Number(node.data.OptionC.TargetCostMEK.Quantity)) * (Number(node.data.OptionC.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionC.ForecastMEK.PerPiece * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionC.ForecastMEK.PerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionC.ForecastMEK.PerSystem = params.node.data.OptionC.ForecastMEK.PerPiece * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  return params.node.data.OptionC.ForecastMEK.PerSystem
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ Ref",
            headerClass: "right-border",
            field: "OptionC.ForecastMEK.DeltaFCVsRefMEK",
            tooltipField: "Delta FC vs. Reference MEK",
            headerTooltip: "Delta FC vs. Reference MEK",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionC.ForecastMEK.PerSystem;
                  ref += node.data.ReferencceScenario.MEKPerSystem;
                }
              });
              //     if(ref===0)
              // result=100;
              // else
              //     result = ((target - ref) / ref) * 100;
              //     return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            width: 50,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionC.ForecastMEK.PerSystem == null || Number(params.node.data.OptionC.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionC.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.OptionC.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                    params.node.data.OptionC.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.OptionC.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                    return params.node.data.OptionC.ForecastMEK.DeltaFCVsRefMEK;
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals (MEK)",
        headerTooltip: "Actuals (MEK)",
        headerClass: "right-border",
        children: [
          {
            headerName: "Actuals (MEK) per piece",
            field: "OptionC.ForecastMEK.ActualsMEK",
            tooltipField: "Actuals (MEK) per piece",
            width: 80,
            headerClass: "right-border",
            cellClass: "right-border colorTotal",
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionC.ForecastMEK.ActualsMEK;
                }
              });
              return result;
            },
            headerTooltip: "Actuals (MEK) per piece",
            editable: false,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Actuals (MEK) per system",
            headerClass: "right-border",
            field: "OptionC.ForecastMEK.ActualsMEKPerSystem",
            tooltipField: "Actuals (MEK) per system",
            headerTooltip: "Actuals (MEK) per system",
            cellClass: (params) => {
              if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
                if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
                if (params.node.data.Index == 1) return "right-border left-border colorTotal"
                if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
                return "colorTotal"
              } else {
                return "right-border colorTotal"
              }
            },
            width: 80,
            editable: false,
            aggFunc: params => {
              var result = 0;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  result += node.data.OptionC.ForecastMEK.ActualsMEKPerSystem;
                }
              });
              return result;
            },
            cellEditor: 'doublingEditor',
            singleClickEdit: true,
            tooltipValueGetter: CurrencyCellRendererReadOnly,
            cellRenderer: CurrencyCellRendererReadOnly,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (params.node.data.Component == params.node.data.Material) {
                  let total = 0;
                  let count = 0;
                  params.api.forEachNode((node) => {
                    if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                      count++;
                      total = total + (Number(node.data.OptionC.ForecastMEK.ActualsMEK)) * (Number(node.data.OptionC.TargetCostMEK.Quantity)) * (Number(node.data.OptionC.TargetCostMEK.Weight))
                    }
                  })
                  if (count == 0) {
                    total = params.node.data.OptionC.ForecastMEK.ActualsMEK * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  }
                  params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem = total;
                  return total;


                } else {
                  params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem = params.node.data.OptionC.ForecastMEK.ActualsMEK * params.node.data.OptionC.TargetCostMEK.Quantity * params.node.data.OptionC.TargetCostMEK.Weight;
                  return params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem;
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          },
          {
            headerName: "Δ TC",
            field: "OptionC.ForecastMEK.DeltaTCVsACT",
            tooltipField: "Delta TC vs. ACT",
            width: 50,
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-eq"
              } else {
                return "right-border colorTotal negative-num-color-eq"
              }
            },
            aggFunc: params => {
              var target = 0, ref = 0, result;
              const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
              displayedLeafChildren.forEach(node => {
                if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
                  target += node.data.OptionC.ForecastMEK.ActualsMEKPerSystem;
                  ref += node.data.OptionC.TargetCostMEK.PerSystem;
                }
              });
              // if(ref===0)
              // result=100;
              // else
              // result = ((target - ref) / ref) * 100;
              // return result;
              if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
                return 0;
              } else {
                return ref === 0 ? 100 : ((target - ref) / ref) * 100;
              }
            },
            headerTooltip: "Delta TC vs. ACT",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: (params) => {
              if (!params.node.group) {
                if (!params.node.data.hasOwnProperty("Pinned")) {
                  if ((params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.OptionC.TargetCostMEK.PerSystem == null || Number(params.node.data.OptionC.TargetCostMEK.PerSystem) == 0)) {
                    return 0;
                  } else {
                    params.node.data.OptionC.ForecastMEK.DeltaTCVsACT = Number(params.node.data.OptionC.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.OptionC.TargetCostMEK.PerSystem)
                    params.node.data.OptionC.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.OptionC.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.OptionC.ForecastMEK.DeltaTCVsACT / Number(params.node.data.OptionC.TargetCostMEK.PerSystem)) * 100
                    return params.node.data.OptionC.ForecastMEK.DeltaTCVsACT
                  }
                }
              }
            },
            filterParams: {
              comparator: (a: any, b: any) => {
                // Convert to numbers for comparison
                const numA = Number(a);
                const numB = Number(b);
                if (numA < numB) return -1;
                if (numA > numB) return 1;
                return 0;
              }
            }
          }
        ]
      },
      {
        headerName: "BKs per piece",
        headerClass: "right-border left-border",
        aggFunc: params => {
          let result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(child => {
            if (child.data && !child.data.HasChild && (child.data.IsActive == null || child.data.IsActive == true)) {
              result += Number(child.data.BKsPerPiece);
            }
          });
          return result;
        },
        cellClass: "left-border right-border colorTotal",
        field: "BKsPerPiece",
        hide: true,
        tooltipField: "BKs per piece",
        headerTooltip: "BKs per piece",
        width: 88,
        editable: (params) => {
          if (!params.node.group && (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M"))) {
            return params.node.data.IsEditable;
          } else {
            return false;
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEKs per piece",
        headerClass: "right-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKsPerPiece;
            }
          });
          return result;
        },
        cellClass: "right-border colorTotal",
        field: "ReferencceScenario.MEKsPerPiece",
        hide: true,
        tooltipField: "MEKs per piece",
        headerTooltip: "MEKs per piece",
        width: 88,
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.hasOwnProperty("IsManual") || params.node.data.Material.startsWith("M")) {
              let bk = params.node.data.BKsPerPiece;
              let type = params.node.data.ProcurementType;
              if (type == "E" || type == "" || type == "X") {
                let bkFactorValObj = this.bkFactorList.find(bkF => bkF.KMAT == params.data.KMAT && bkF.OverheadCostType === "BK Factor");
                let bkFactorVal = (bkFactorValObj && bkFactorValObj.FactorValue != null) ? bkFactorValObj.FactorValue : 1;
                return params.node.data.ReferencceScenario.MEKsPerPiece = Number(Number(bk) / Number(bkFactorVal));
              } else {
                return params.node.data.ReferencceScenario.MEKsPerPiece = bk;
              }
            } else {
              return (params.node.data.ReferencceScenario.MEKsPerPiece);
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "ReferencceScenario.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        headerTooltip: "Quantity",
        singleClickEdit: true,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "ReferencceScenario.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Weight",
        singleClickEdit: true,
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data.hasOwnProperty("AssemblyRow") || params.node.data.hasOwnProperty("Pinned")) {
              return false;
            }
            else {
              return params.node.data.IsEditable;
            }
          }
        },
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "MEK per system",
        field: "ReferencceScenario.MEKPerSystem",
        hide: true,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          return result;
        },
        tooltipField: "MEK per system",
        width: 88,
        cellClass: "colorTotal right-border",
        headerTooltip: "MEK per system",
        headerClass: "right-border",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + node.data.ReferencceScenario.MEKPerSystem;
                }
              })
              if (count == 0) {
                total = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              }
              params.node.data.ReferencceScenario.MEKPerSystem = total;
              return total;


            } else {
              params.node.data.ReferencceScenario.MEKPerSystem = params.node.data.ReferencceScenario.MEKsPerPiece * params.node.data.ReferencceScenario.Quantity * params.node.data.ReferencceScenario.Weight;
              return params.node.data.ReferencceScenario.MEKPerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "TargetScenario.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "TargetScenario.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "TargetScenario.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.TargetCostMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.TargetCostMEK.PerSystem = params.node.data.TargetScenario.TargetCostMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.TargetCostMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group && !params.node.data.hasOwnProperty("Pinned")) {
            if ((params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
              return 0;
            } else {
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
              params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
              return params.node.data.TargetScenario.TargetCostMEK.DeltaTCVsRefMEK;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.PerPiece)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.PerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.PerSystem = params.node.data.TargetScenario.ForecastMEK.PerPiece * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.PerSystem
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.PerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) == 0) && (params.node.data.ReferencceScenario.MEKPerSystem == null || Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = Number(params.node.data.TargetScenario.ForecastMEK.PerSystem) - Number(params.node.data.ReferencceScenario.MEKPerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK = (Number(params.node.data.ReferencceScenario.MEKPerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK / Number(params.node.data.ReferencceScenario.MEKPerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaFCVsRefMEK;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      // {
      //   headerName: "Actuals (MEK)",
      //   field: "TargetScenario.ForecastMEK.ActualsMEK",
      //   hide: true,
      //   tooltipField: "Actuals (MEK)",
      //   width: 80,
      //   headerClass: "right-border",
      //   cellClass: "right-border colorTotal",
      //   aggFunc: params => {
      //     var result = 0;
      //     const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
      //     displayedLeafChildren.forEach(node => {
      //       if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //         result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
      //       }
      //     });
      //     return result;
      //   },
      //   headerTooltip: "Actuals (MEK)",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRendererReadOnly,
      //   cellRenderer: CurrencyCellRendererReadOnly,
      // },
      {
        headerName: "Actuals (MEK) per piece",
        field: "TargetScenario.ForecastMEK.ActualsMEK",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per piece",
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.TargetScenario.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "TargetScenario.ForecastMEK.ActualsMEKPerSystem",
        suppressColumnsToolPanel: true,
        hide: true,
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (!node.group && node.data.Assembly == params.node.data.Assembly && node.data.KMAT == params.node.data.KMAT && node.data.VBLO == params.node.data.VBLO && node.data.Component == params.node.data.Component && node.data.Component != node.data.Material) {
                  count++;
                  total = total + (Number(node.data.TargetScenario.ForecastMEK.ActualsMEK)) * (Number(node.data.TargetScenario.TargetCostMEK.Quantity)) * (Number(node.data.TargetScenario.TargetCostMEK.Weight))
                }
              })
              if (count == 0) {
                total = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              }
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = total;
              return total;


            } else {
              params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem = params.node.data.TargetScenario.ForecastMEK.ActualsMEK * params.node.data.TargetScenario.TargetCostMEK.Quantity * params.node.data.TargetScenario.TargetCostMEK.Weight;
              return params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "TargetScenario.ForecastMEK.DeltaTCVsACT",
        hide: true,
        tooltipField: "Delta TC vs. ACT",
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem;
              ref += node.data.TargetScenario.TargetCostMEK.PerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (!params.node.data.hasOwnProperty("Pinned")) {
              if ((params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem == null || Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) == 0) && (params.node.data.TargetScenario.TargetCostMEK.PerSystem == null || Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0)) {
                return 0;
              } else {
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = Number(params.node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem) - Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)
                params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT = (Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem) == 0) ? 100 : (params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT / Number(params.node.data.TargetScenario.TargetCostMEK.PerSystem)) * 100
                return params.node.data.TargetScenario.ForecastMEK.DeltaTCVsACT
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionA.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionA.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionA.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data?.Component === data?.Material) {
            let total = 0;
            let count = 0;

            params.api.forEachNode((node) => {
              const nodeData = node.data;
              if (
                !node.group &&
                nodeData?.Assembly === data?.Assembly &&
                nodeData?.KMAT === data?.KMAT &&
                nodeData?.VBLO === data?.VBLO &&
                nodeData?.Component === data?.Component &&
                nodeData?.Component !== nodeData?.Material
              ) {
                count++;
                total +=
                  Number(nodeData?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
            });

            if (count === 0) {
              total =
                Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            }

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
              return total;

            }


          } else if (!params.node.group) {
            const perPiece = Number(data?.OptionA?.TargetCostMEK?.PerPiece ?? 0);
            const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
            const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
            const total = perPiece * quantity * weight;

            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.PerSystem = total;
            }


          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (data && !data.HasChild && (data.IsActive == null || data.IsActive === true)) {
              target += Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          //if (ref === 0) return 100;
          // return ((target - ref) / ref) * 100;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionA?.TargetCostMEK) {
              data.OptionA.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionA?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionA?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
                return total;

              }

            } else {
              const perPiece = Number(data?.OptionA?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.PerSystem = total;
              }

            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          let target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);

          displayedLeafChildren.forEach(node => {
            const data = node.data;
            if (
              data &&
              !data.HasChild &&
              (data.IsActive == null || data.IsActive === true)
            ) {
              target += Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              ref += Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);
            }
          });

          // if (ref === 0) return 100; // Avoid division by zero

          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (!data.hasOwnProperty("Pinned")) {
              const perSystem = Number(data?.OptionA?.ForecastMEK?.PerSystem ?? 0);
              const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

              let delta = perSystem - refMEK;
              if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
                delta = 0;
              } else {
                delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
              }
              if (data?.OptionA?.ForecastMEK) {
                data.OptionA.ForecastMEK.DeltaFCVsRefMEK = delta;
              }

              return delta;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionA.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionA.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        hide: true,
        suppressColumnsToolPanel: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            // Add full nullable checks for OptionA and ForecastMEK
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            if (params.node.data.Component == params.node.data.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                if (
                  !node.group &&
                  node.data?.Assembly == params.node.data?.Assembly &&
                  node.data?.KMAT == params.node.data?.KMAT &&
                  node.data?.VBLO == params.node.data?.VBLO &&
                  node.data?.Component == params.node.data?.Component &&
                  node.data?.Component != node.data?.Material
                ) {
                  count++;
                  total +=
                    Number(node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                    Number(node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
                }
              });
              if (count == 0) {
                total =
                  Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0) *
                  Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              }
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(params.node.data?.OptionA?.ForecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(params.node.data?.OptionA?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(params.node.data?.OptionA?.TargetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (params.node.data?.OptionA?.ForecastMEK) {
                params.node.data.OptionA.ForecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionA.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        hide: true,
        suppressColumnsToolPanel: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionA?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionA?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionA.TargetCostMEK.PerSystem);
            }
          });
          // ...existing code...
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            // Only proceed if OptionA and its subfields exist
            const actualsMEKPerSystem = Number(data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem ?? 0);
            const targetPerSystem = Number(data?.OptionA?.TargetCostMEK?.PerSystem ?? 0);

            if (!data?.hasOwnProperty("Pinned")) {
              if ((actualsMEKPerSystem === 0 || data?.OptionA?.ForecastMEK?.ActualsMEKPerSystem == null) &&
                (targetPerSystem === 0 || data?.OptionA?.TargetCostMEK?.PerSystem == null)) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (data?.OptionA?.ForecastMEK) {
                  data.OptionA.ForecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Qty",
        field: "OptionB.TargetCostMEK.Quantity",
        hide: true,
        tooltipField: "Quantity",
        width: 50,
        headerClass: "right-border",
        headerTooltip: "Quantity",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (!params.node.group) {
            return "right-border"
          }
        },
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "W",
        field: "OptionB.TargetCostMEK.Weight",
        hide: true,
        tooltipField: "Weight",
        width: 50,
        headerTooltip: "Weight",
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border left-border",
        field: "OptionB.TargetCostMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        cellClass: "right-border left-border",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.TargetCostMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            return params.node.data.IsEditable
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.TargetCostMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeData?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.TargetCostMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.TargetCostMEK) {
                data.OptionB.TargetCostMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.TargetCostMEK.DeltaTCVsRefMEK",
        hide: true,
        tooltipField: "Delta TC vs. Reference MEK",
        headerTooltip: "Delta TC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.TargetCostMEK.PerSystem;
              ref += node.data.ReferencceScenario.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.TargetCostMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.TargetCostMEK) {
              data.OptionB.TargetCostMEK.DeltaTCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per piece",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerPiece",
        hide: true,
        tooltipField: "perpiece",
        headerTooltip: "perpiece",
        // cellClass: "right-border",
        cellClass: (params) => {
          if (!params.node.group) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "right-border colorTotal";
            }
          }
          return "right-border";
        },
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += Number(node.data.OptionB?.ForecastMEK.PerPiece);
            }
          });
          return result;
        },
        width: 80,
        editable: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            // CHANGE: non-editable if SupplierNo exists AND is found in supplier info list
            if (params.node.data.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return false;
            }
            return params.node.data.IsEditable;
          }
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        // tooltipValueGetter: CurrencyCellRenderer,
        tooltipValueGetter: (params) => {
          if (!params.node.group && (params.node.data.IsActive == null || params.node.data.IsActive == true)) {
            if (params.node.data?.SupplierNo && this.isSupplierNoInList(params.node.data.SupplierNo)) {
              return "Automatically calculated Forecast based on supplier specific targets";
            }
          }
          return CurrencyCellRenderer(params);
        },
        cellRenderer: CurrencyCellRenderer,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.PerSystem",
        hide: true,
        tooltipField: "per system",
        headerTooltip: "per system",
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              result += node.data.OptionB?.ForecastMEK.PerSystem;
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data) {
            if (data.Component === data.Material) {
              let total = 0;
              let count = 0;

              params.api.forEachNode((node) => {
                const nodeData = node.data;
                if (
                  !node.group &&
                  nodeData?.Assembly === data.Assembly &&
                  nodeData?.KMAT === data.KMAT &&
                  nodeData?.VBLO === data.VBLO &&
                  nodeData?.Component === data.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  total +=
                    Number(nodeData?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                    Number(nodeData?.OptionB?.TargetCostMEK?.Weight ?? 0);
                  count++;
                }
              });

              if (count === 0) {
                total =
                  Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0) *
                  Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              }

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
                return total;

              }



            } else {
              const perPiece = Number(data?.OptionB?.ForecastMEK?.PerPiece ?? 0);
              const quantity = Number(data?.OptionB?.TargetCostMEK?.Quantity ?? 0);
              const weight = Number(data?.OptionB?.TargetCostMEK?.Weight ?? 0);
              const total = perPiece * quantity * weight;

              if (data?.OptionB?.ForecastMEK) {
                data.OptionB.ForecastMEK.PerSystem = total;
              }


            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ Ref",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.DeltaFCVsRefMEK",
        hide: true,
        tooltipField: "Delta FC vs. Reference MEK",
        headerTooltip: "Delta FC vs. Reference MEK",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (node.data && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
              target += node.data.OptionB?.ForecastMEK.PerSystem;
              ref += node.data.ReferencceScenario?.MEKPerSystem;
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        width: 50,
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          const data = params.node.data;
          if (!params.node.group && data && !data.hasOwnProperty("Pinned")) {
            const perSystem = Number(data?.OptionB?.ForecastMEK?.PerSystem ?? 0);
            const refMEK = Number(data?.ReferencceScenario?.MEKPerSystem ?? 0);

            let delta = perSystem - refMEK;
            if ((perSystem == null || Number(perSystem) == 0) && (refMEK == null || Number(refMEK) == 0)) {
              delta = 0;
            } else {
              delta = refMEK === 0 ? 100 : (delta / refMEK) * 100;
            }
            if (data?.OptionB?.ForecastMEK) {
              data.OptionB.ForecastMEK.DeltaFCVsRefMEK = delta;
            }

            return delta;
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per piece",
        field: "OptionB.ForecastMEK.ActualsMEK",
        tooltipField: "Actuals (MEK) per piece",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 80,
        headerClass: "right-border",
        cellClass: "right-border colorTotal",
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEK != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEK);
            }
          });
          return result;
        },
        headerTooltip: "Actuals (MEK) per piece",
        editable: false,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Actuals (MEK) per system",
        headerClass: "right-border",
        field: "OptionB.ForecastMEK.ActualsMEKPerSystem",
        tooltipField: "Actuals (MEK) per system",
        headerTooltip: "Actuals (MEK) per system",
        suppressColumnsToolPanel: true,
        hide: true,
        cellClass: (params) => {
          if (!params.node.group && params.node.data.hasOwnProperty("Pinned")) {
            if (params.node.data.Index == 0) return "right-border top-border left-border colorTotal"
            if (params.node.data.Index == 1) return "right-border left-border colorTotal"
            if (params.node.data.Index == 2) return "right-border bottom-border left-border colorTotal"
            return "colorTotal"
          } else {
            return "right-border colorTotal"
          }
        },
        width: 80,
        editable: false,
        aggFunc: params => {
          var result = 0;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null
            ) {
              result += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
            }
          });
          return result;
        },
        cellEditor: 'doublingEditor',
        singleClickEdit: true,
        tooltipValueGetter: CurrencyCellRendererReadOnly,
        cellRenderer: CurrencyCellRendererReadOnly,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (data?.Component === data?.Material) {
              let total = 0;
              let count = 0;
              params.api.forEachNode((node) => {
                const nodeData = node.data;
                const nodeOptionB = nodeData?.OptionB;
                const nodeForecastMEK = nodeOptionB?.ForecastMEK;
                const nodeTargetCostMEK = nodeOptionB?.TargetCostMEK;
                if (
                  !node.group &&
                  nodeData?.Assembly === data?.Assembly &&
                  nodeData?.KMAT === data?.KMAT &&
                  nodeData?.VBLO === data?.VBLO &&
                  nodeData?.Component === data?.Component &&
                  nodeData?.Component !== nodeData?.Material
                ) {
                  count++;
                  total +=
                    Number(nodeForecastMEK?.ActualsMEK ?? 0) *
                    Number(nodeTargetCostMEK?.Quantity ?? 0) *
                    Number(nodeTargetCostMEK?.Weight ?? 0);
                }
              });
              if (count === 0) {
                total =
                  Number(forecastMEK?.ActualsMEK ?? 0) *
                  Number(targetCostMEK?.Quantity ?? 0) *
                  Number(targetCostMEK?.Weight ?? 0);
              }
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
                return total;

              }
            } else {
              const actualsMEK = Number(forecastMEK?.ActualsMEK ?? 0);
              const quantity = Number(targetCostMEK?.Quantity ?? 0);
              const weight = Number(targetCostMEK?.Weight ?? 0);
              const total = actualsMEK * quantity * weight;
              if (forecastMEK) {
                forecastMEK.ActualsMEKPerSystem = total;
              }
              return total;
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
      {
        headerName: "Δ TC",
        field: "OptionB.ForecastMEK.DeltaTCVsACT",
        tooltipField: "Delta TC vs. ACT",
        suppressColumnsToolPanel: true,
        hide: true,
        width: 50,
        headerClass: "right-border",
        cellClass: (params) => {
          if (params.value > 0) {
            return "right-border colorTotal positive-num-color-eq"
          } else {
            return "right-border colorTotal negative-num-color-eq"
          }
        },
        aggFunc: params => {
          var target = 0, ref = 0, result;
          const displayedLeafChildren = this.getDisplayedLeafChildren(params.rowNode);
          displayedLeafChildren.forEach(node => {
            if (
              node.data &&
              !node.data.HasChild &&
              (node.data.IsActive == null || node.data.IsActive == true) &&
              node.data.OptionB?.ForecastMEK?.ActualsMEKPerSystem != null &&
              node.data.OptionB?.TargetCostMEK?.PerSystem != null
            ) {
              target += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem);
              ref += Number(node.data.OptionB.TargetCostMEK.PerSystem);
            }
          });
          // if(ref===0)
          // result=100;
          // else
          // result = ((target - ref) / ref) * 100;
          // return result;
          if ((target == null || Number(target) == 0) && (ref == null || Number(ref) == 0)) {
            return 0;
          } else {
            return ref === 0 ? 100 : ((target - ref) / ref) * 100;
          }
        },
        headerTooltip: "Delta TC vs. ACT",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: (params) => {
          if (!params.node.group) {
            const data = params.node.data;
            const optionB = data?.OptionB;
            const forecastMEK = optionB?.ForecastMEK;
            const targetCostMEK = optionB?.TargetCostMEK;

            if (!data?.hasOwnProperty("Pinned")) {
              const actualsMEKPerSystem = Number(forecastMEK?.ActualsMEKPerSystem ?? 0);
              const targetPerSystem = Number(targetCostMEK?.PerSystem ?? 0);

              if (
                (forecastMEK?.ActualsMEKPerSystem == null || actualsMEKPerSystem === 0) &&
                (targetCostMEK?.PerSystem == null || targetPerSystem === 0)
              ) {
                return 0;
              } else {
                let delta = actualsMEKPerSystem - targetPerSystem;
                delta = (targetPerSystem === 0) ? 100 : (delta / targetPerSystem) * 100;
                if (forecastMEK) {
                  forecastMEK.DeltaTCVsACT = delta;
                }
                return delta;
              }
            }
          }
        },
        filterParams: {
          comparator: (a: any, b: any) => {
            // Convert to numbers for comparison
            const numA = Number(a);
            const numB = Number(b);
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
          }
        }
      },
    ]

    this.getRowHeightoptC = 25;

    this.optCDefaultColDef = {
      suppressMovable: true,
      sortable: true,
      resizable: true,
      cellClassRules: {
        'click-not-allowed': params =>
          typeof params?.colDef?.editable === 'function'
            ? !params?.colDef?.editable(params)
            : params?.colDef?.editable === false
      },
      // minWidth: 10,
      //  maxWidth: 150,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
      filter: true
    }

    this.OptCDomLayout = "autoHeight";

    this.optCFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptCGridReady(params: any) {
    this.optCGridApi = params.api;
    this.optCGridColumnApi = params.columnApi;
    this.optCGridApi.setGroupHeaderHeight(20);
    this.sizeToFitRefreshOptC = 1;

    if (this.gridDataSummary != undefined) {
      this.calculateSummaryMekTotalOptionC();
    }

    grids = document.querySelectorAll('.ag-body-viewport'); // Adjust selector based on your AG Grid structure
    // Attach the scroll event listener to all grids
    grids.forEach(grid => {
      grid.addEventListener('scroll', syncVerticalScroll);
    });

    // setTimeout(() => {
    //   this.isExpanded = !this.isExpanded;
    //   this.onExpandCollapse();
    // }, 100);
    this.optCGridColumnApi.setRowGroupColumns(this.groupedColumns);
    this.optCGridColumnApi.applyColumnState({
      state: this.sortingState,
      applyOrder: false,
    })
  }

  onDisplayedColumnsChangedOptC(params) {
    if (this.sizeToFitRefreshOptC != 0) {
      params.api.sizeColumnsToFit()
    }
  }

  onGridOptCChanged(params) {
    params.api.sizeColumnsToFit();

  }

  onOptCCellValueChangedCS(params) {
    this.optCGridApi.redrawRows();
    this.optCGridApi.refreshClientSideRowModel('aggregate');

    this.calculateSummaryMekTotalOptionC();

    this.hasUnsavedChanges = true;

    if (params.node.data) {
      const assemblyName = params.node.data.Assembly;

      // 1. Get the latest Target MEK total for this assembly using your grouping method (uses TargetCostMEK's Quantity/Weight)
      const grouped = this.getGroupedDataByAssemblyForScenario(
        this.getRefGridData(),
        "OptionC",
        "TargetCostMEK"
      );
      const targetCostValue = grouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;

      // 2. Get the Reference value using getTotalMEKPerSystemForAssembly (uses Reference scenario's Quantity/Weight)
      const referenceCostValue = this.getTotalMEKPerSystemForAssembly(
        this.getRefGridData(),
        assemblyName
      );

      // 3. Update only new and unconfirmed simulation rows
      this.TCSimulationData.forEach(sim => {
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionC" &&
          sim.TypeOfCost === "Target" &&
          sim.IsNewAndUnconfirmed // Only update if still unconfirmed
        ) {
          sim.CostValue = targetCostValue;
          sim.PercentageChange = targetCostValue !== 0
            ? Number((((targetCostValue - referenceCostValue) / targetCostValue) * 100).toFixed(2))
            : 0;
        }
        // If you want to update Forecast rows as well, add similar logic here:
        if (
          sim.Name === assemblyName &&
          sim.ScenarioType === "OptionC" &&
          sim.TypeOfCost === "Forecast" &&
          sim.IsNewAndUnconfirmed
        ) {
          // Get Forecast MEK total for this assembly
          const forecastGrouped = this.getGroupedDataByAssemblyForScenario(
            this.getRefGridData(),
            "OptionC",
            "ForecastMEK"
          );
          const forecastCostValue = forecastGrouped.find(t => t.Assembly === assemblyName)?.TotalMEKPerSystem || 0;
          sim.CostValue = forecastCostValue;
          sim.PercentageChange = forecastCostValue !== 0
            ? Number((((forecastCostValue - referenceCostValue) / forecastCostValue) * 100).toFixed(2))
            : 0;
        }
      });
    }

    if (params.node.data.OptionC.TargetCostMEK.EQId != 0) {
      let isPushed = false;
      if (this.modifiedGridData.length == 0) {
        this.modifiedGridData.push(params.node.data);
        isPushed = true;
      }
      else {
        this.modifiedGridData.forEach(row => {
          if (params.node.data.EQId == row.EQId) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedGridData.push(params.node.data);
      }
    }
  }

  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  // Check if comment has unsaved changes
  canDeactivateComment(): boolean {
    return this.hasCommentUnsavedChanges;
  }

  // Handle comment unsaved changes event from child
  onCommentUnsavedChange(hasChanges: boolean) {
    this.hasCommentUnsavedChanges = hasChanges;
  }

  // Submit comment changes
  async submitComment(): Promise<boolean> {
    if (this.commentBox && this.hasCommentUnsavedChanges) {
      return await this.commentBox.saveCommentIfNeeded();
    }
    return true;
  }
  getUserInfo() {
    return this.userInOrg.UserId;
  }

  getConfigurationId() {
    return this.configurationId
  }

  onFocusView() {
    document.getElementById("focus-button").style.display = "none";
    document.getElementById("normal-button").style.display = "inline-block";

    (<HTMLInputElement>document.getElementById("addOption")).disabled = true;
    document.getElementById("br-summary").style.display = "none";

    let summaryGrid = document.querySelectorAll(".summary") as NodeListOf<HTMLElement>;

    summaryGrid.forEach(x => {
      x.style.display = 'none';
    });

    document.getElementById("configGrid").style.height = `${window.innerHeight - 190}px`;
    document.getElementById("refGrid").style.height = `${window.innerHeight - 190}px`;
    document.getElementById("tarGrid").style.height = `${window.innerHeight - 190}px`;
    if (this.optAVisible)
      document.getElementById("optAGrid").style.height = `${window.innerHeight - 190}px`;
    if (this.optBVisible)
      document.getElementById("optBGrid").style.height = `${window.innerHeight - 190}px`;
    if (this.optCVisible)
      document.getElementById("optCGrid").style.height = `${window.innerHeight - 190}px`;
  }

  onNormalView() {
    document.getElementById("focus-button").style.display = "inline-block";
    document.getElementById("normal-button").style.display = "none";

    (<HTMLInputElement>document.getElementById("addOption")).disabled = false;
    document.getElementById("br-summary").style.display = "block";

    let summaryGrid = document.querySelectorAll(".summary") as NodeListOf<HTMLElement>;

    summaryGrid.forEach(x => {
      x.style.display = 'inline-block';
    });

    document.getElementById("configGrid").style.height = `50vh`;
    document.getElementById("refGrid").style.height = `50vh`;
    document.getElementById("tarGrid").style.height = `50vh`;
    if (this.optAVisible)
      document.getElementById("optAGrid").style.height = `50vh`;
    if (this.optBVisible)
      document.getElementById("optBGrid").style.height = `50vh`;
    if (this.optCVisible)
      document.getElementById("optCGrid").style.height = `50vh`;
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.configSummaryGridApi.stopEditing();
    this.refGridApi.stopEditing();
    this.tarGridApi.stopEditing();
    this.configGridApi.stopEditing();
    this.tarSummaryGridApi.stopEditing();
    this.refSummaryGridApi.stopEditing()
    if (this.optAVisible) {
      this.optAGridApi.stopEditing();
      this.optASummaryGridApi.stopEditing();
    }
    if (this.optBVisible) {
      this.optBGridApi.stopEditing();
      this.optBSummaryGridApi.stopEditing();
    }
    if (this.optCVisible) {
      this.optCGridApi.stopEditing();
      this.optCSummaryGridApi.stopEditing();
    }
    this.menuService.onClickNextAndBack("back");
  }

  onClickNext() {
    this.configSummaryGridApi.stopEditing();
    this.refGridApi.stopEditing();
    this.tarGridApi.stopEditing();
    this.configGridApi.stopEditing();
    this.tarSummaryGridApi.stopEditing();
    this.refSummaryGridApi.stopEditing()
    if (this.optAVisible) {
      this.optAGridApi.stopEditing();
      this.optASummaryGridApi.stopEditing();
    }
    if (this.optBVisible) {
      this.optBGridApi.stopEditing();
      this.optBSummaryGridApi.stopEditing();
    }
    if (this.optCVisible) {
      this.optCGridApi.stopEditing();
      this.optCSummaryGridApi.stopEditing();
    }
    this.menuService.onClickNextAndBack("next");
  }

  submit(event?: any) {
    debugger;
    this.configSummaryGridApi.stopEditing();
    this.refGridApi.stopEditing();
    this.tarGridApi.stopEditing();
    this.configGridApi.stopEditing();
    this.tarSummaryGridApi.stopEditing();
    this.refSummaryGridApi.stopEditing()
    if (this.optAVisible) {
      this.optAGridApi.stopEditing();
      this.optASummaryGridApi.stopEditing();
    }
    if (this.optBVisible) {
      this.optBGridApi.stopEditing();
      this.optBSummaryGridApi.stopEditing();
    }
    if (this.optCVisible) {
      this.optCGridApi.stopEditing();
      this.optCSummaryGridApi.stopEditing();
    }
    if (!this.hasUnsavedChanges && event == undefined) {
      return true
    }
    let errorMessage = messages.cellEmptyErrorMesssage;
    let error = [];
    let response = null;
    this.submitted = true;

    // this.refGridApi.forEachNode(node => {
    //   if (!node.group && node.data.hasOwnProperty("IsManual")) {
    //     if (node.data.KMAT == "Please Select" || node.data.VBLO == "Please Select" || node.data.VBLODescription == "Add Description" || node.data.VBLODescription == "" || node.data.MaterialDescription == "Add Description" || node.data.MaterialDescription == " " || node.data.ProcurementType == ""  || node.data.Component == "Please Select") {
    //       error.push({ [messages.manualMaterial]: serverMessage.warning });
    //     }
    //   }
    // })

    this.refGridApi.forEachNode(node => {
      if (!node.group && node.data.hasOwnProperty("IsManual")) {
        const emptyFields = [];

        if (node.data.KMAT == "Please Select") emptyFields.push("KMAT");
        if (node.data.VBLO == "Please Select") emptyFields.push("VBLO");
        if (node.data.VBLODescription == "Add Description" || node.data.VBLODescription == "" || node.data.VBLODescription == undefined) emptyFields.push("VBLO Description");
        if (node.data.MaterialDescription == "Add Description" || node.data.MaterialDescription == " " || node.data.MaterialDescription == undefined) emptyFields.push("Material Description");
        if (node.data.ProcurementType == "" || node.data.ProcurementType == undefined) emptyFields.push("Procurement Type");
        if (node.data.Component == "Please Select") emptyFields.push("Component");

        if (emptyFields.length > 0) {
          error.push({
            [`You did not enter a value in : ${emptyFields.join(', ')} This information is mandatory. Please check if ${emptyFields.join(', ')} is hidden. `]: serverMessage.warning
          });
        }
      }
    })
    if (error.length > 0) {
      this.submitted = false;
      this.openAlertDialog(error);
      return false;
    }
    else {

      let sendData = this.sendData();
      response = this.eqtargetcostingService.insertUpdateTargetcostingData(sendData).toPromise().
        then((res) => {
          this.submitResponse = res;
          let successCode = this.submitResponse.StatusCode;
          let errorCode = this.submitResponse.Data.ErrorCode;
          let errorMsgeFromBack = this.submitResponse.Data.Message;
          if (successCode == 200) {
            if (errorCode == 0) {
              this.submitted = false;
              this.hasUnsavedChanges = false;
              let dataSaveMessage = serverMessage.dataSaveMessage;
              this.toast.notify(dataSaveMessage, "success");
              // this.expandCollapse = "Expand Groups";
              // this.isExpanded = false;
              this.modifiedGridData = [];
              this.isVisibleAddOption = true;
              if (event != undefined && event != "save") {
                this.localStorageService.remove("configuration");
                this.hasUnsavedChanges = false;
                this.router.navigate(['/tc-manageProject'])
              } else if (event == "save") {
                this.loadData(this.configurationId);


                // this.submitted = false;
                // this.hasUnsavedChanges = false;
                // let dataSaveMessage = serverMessage.dataSaveMessage;
                // this.toast.notify(dataSaveMessage, "success");
                // this.expandCollapse = "Expand Groups";
                // this.isExpanded = false;
                this.modifiedGridData = [];
                this.isVisibleAddOption = true;
              }
              return true;
            }
            else {
              //Show errorCode and errorMessage in the UI
              let errorContainer = [
                { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
                { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
              ]
              this.openAlertDialog(errorContainer)
              this.submitted = false;
              return false;
            }
          }
          else {
            let errorContainer = [
              { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
              { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
            ]
            this.openAlertDialog(errorContainer)
            this.submitted = false;
            return false;
          }
        },
          (error) => {
            this.submitted = false;
            this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
            return false;
          })

      return response;
    }
  }

  sendData() {
    debugger;
    let sendObj: Eqcosts;

    let summaries: Eqsummaries[] = this.TCEQTargetCostSummaries;
    let eqData: Eqtargetcosts[] = this.TCEQTargetCosts;

    // eqData = this.gridData.filter(x => (x.ReferencceScenario.EQId == 0 || x.TargetScenario.TargetCostMEK.EQId == 0 || x.OptionA?.TargetCostMEK.EQId == 0 || x.OptionB?.TargetCostMEK.EQId == 0 || x.OptionC?.TargetCostMEK.EQId == 0));

    this.refGridApi.forEachNode(node => {
      if (!node.group && node.data.hasOwnProperty("IsManual")) {
        if (node.data.KMAT != "Please Select" && node.data.KMATText != "Add Description" && node.data.VBLO != "Please Select" && node.data.VBLODescription != "Add Description" && node.data.VBLODescription != "" && node.data.MaterialDescription != "Add Description" && node.data.MaterialDescription != "" && node.data.ProcurementType != "" && node.data.Component != "Please Select") {
          eqData.push(node.data)
        }
      }
    })

    this.modifiedGridData.forEach(x => {
      if (eqData.findIndex(eq => eq.EQId == x.EQId) == -1) {
        x.IsActive = x.IsActive ?? true;
        //  x.ReferencceScenario.ScenarioTitle = this.refTitle;
        x.ModifiedBy = this.userInOrg.UserId;
        eqData.push(x);
      }
    });

    eqData.forEach(x => {
      x.EcoId = x.EcoId ?? "";
      x.IsActive = x.IsActive ?? true;
      x.CreatedBy = this.userInOrg.UserId;
      x.ReferencceScenario.ScenarioTitle = this.refTitle;
      x.TargetScenario.ScenarioTitle = this.tarTitle;
      if (x.OptionA != null) x.OptionA.ScenarioTitle = this.optATitle;
      if (x.OptionB != null) x.OptionB.ScenarioTitle = this.optBTitle;
      if (x.OptionC != null) x.OptionC.ScenarioTitle = this.optCTitle;
    })

    summaries.forEach((s, i) => {
      s.IsActive = true;

      if (s.Id == 0) {
        s.CreatedBy = this.userInOrg.UserId;
      } else {
        s.ModifiedBy = this.userInOrg.UserId;
      }

      let Reftotal = 0;
      const allRefRows = this.getAllGridDataIncludingHidden(this.refGridApi, this.masterGridData);
      allRefRows.forEach(row => {
        if (!row.group && !row.HasChild && (row.IsActive == null || row.IsActive == true)) {
          Reftotal += Number(row.ReferencceScenario.MEKPerSystem)
        }
      });
      // debugger

      // this.refGridApi.forEachNode(node => {
      //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //     Reftotal += Number(node.data.ReferencceScenario.MEKPerSystem)
      //   }
      // })
      // debugger;

      let perSysTotalTar = 0;
      let forecastPerSysTotalTar = 0;
      let forecastActualMekTotalTar = 0;

      // let perSysTotalTarNew = 0;
      // let forecastPerSysTotalTarNew = 0;
      // let forecastActualMekTotalTarNew = 0;

      const allTarRows = this.getAllGridDataIncludingHidden(this.tarGridApi, this.masterGridData);

      allTarRows.forEach(row => {
        if (!row.group && !row.HasChild && (row.IsActive == null || row.IsActive == true)) {
          perSysTotalTar += Number(row.TargetScenario.TargetCostMEK.PerSystem);
          forecastPerSysTotalTar += Number(row.TargetScenario.ForecastMEK.PerSystem);
          forecastActualMekTotalTar += Number(row.TargetScenario.ForecastMEK.ActualsMEKPerSystem);
        }
      });

      // this.tarGridApi.forEachNode(node => {
      //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
      //     perSysTotalTar += Number(node.data.TargetScenario.TargetCostMEK.PerSystem)
      //     forecastPerSysTotalTar += Number(node.data.TargetScenario.ForecastMEK.PerSystem)
      //     forecastActualMekTotalTar += Number(node.data.TargetScenario.ForecastMEK.ActualsMEKPerSystem)
      //   }
      // })
      // debugger;

      if (s.Name == "MEKTotal") {
        s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
        s.ReferenceScenario.PerSystem = Reftotal ?? 0;
        s.TargetScenario.TargetCost.PerSystem = perSysTotalTar ?? 0;
        s.TargetScenario.Forecast.PerSystem = forecastPerSysTotalTar ?? 0;
        s.TargetScenario.Forecast.ActualMEKs = forecastActualMekTotalTar ?? 0;
      }
      else if (s.Name == "TotalBK") {
        let total = 0;
        s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
        s.ReferenceScenario.PerSystem = this.calculateTotalBKOrOverhead(Reftotal, "Ref", true);
        s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotalTar, "Tar", true);
        s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotalTar, "TarForPerSys", true);
        s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotalTar, "TarForAct", true);
      }
      else if (s.Name == "Overhead") {
        let total = 0;
        s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
        s.ReferenceScenario.PerSystem = this.calculateTotalBKOrOverhead(Reftotal, "Ref", false);
        s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotalTar, "Tar", false);
        s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotalTar, "TarForPerSys", false);
        s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotalTar, "TarForAct", false);
      }
      else {
        s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
        s.ReferenceScenario.PerSystem = s.ReferenceScenario.PerSystem ?? 0;
        s.TargetScenario.TargetCost.PerSystem = s.TargetScenario.TargetCost.PerSystem ?? 0;
        s.TargetScenario.Forecast.PerSystem = s.TargetScenario.Forecast.PerSystem ?? 0;
        s.TargetScenario.Forecast.ActualMEKs = s.TargetScenario.Forecast.ActualMEKs ?? 0;
      }

      if (this.optAVisible) {
        let perSysTotaloptA = 0;
        let forecastPerSysTotaloptA = 0;
        let forecastActualMekTotaloptA = 0;
        const allOptARows = this.getAllGridDataIncludingHidden(this.optAGridApi, this.masterGridData);
        allOptARows.forEach(row => {
          if (!row.group && !row.HasChild && (row.IsActive == null || row.IsActive == true)) {
            perSysTotaloptA += Number(row.OptionA.TargetCostMEK.PerSystem);
            forecastPerSysTotaloptA += Number(row.OptionA.ForecastMEK.PerSystem);
            forecastActualMekTotaloptA += Number(row.OptionA.ForecastMEK.ActualsMEKPerSystem);
          }
        });
        // this.optAGridApi.forEachNode(node => {
        //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        //     perSysTotaloptA += Number(node.data.OptionA.TargetCostMEK.PerSystem)
        //     forecastPerSysTotaloptA += Number(node.data.OptionA.ForecastMEK.PerSystem)
        //     forecastActualMekTotaloptA += Number(node.data.OptionA.ForecastMEK.ActualsMEKPerSystem)
        //   }
        // })

        if (s.Name == "MEKTotal") {
          s.OptionA.TargetCost.PerSystem = perSysTotaloptA ?? 0;
          s.OptionA.Forecast.PerSystem = forecastPerSysTotaloptA ?? 0;
          s.OptionA.Forecast.ActualMEKs = forecastActualMekTotaloptA ?? 0;
        }
        else if (s.Name == "TotalBK") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptA, "OptA", true);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptA, "OptAForPerSys", true);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptA, "OptAForAct", true);
        }
        else if (s.Name == "Overhead") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptA, "OptA", false);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptA, "OptAForPerSys", false);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptA, "OptAForAct", false);
        }
        else {
          s.OptionA.TargetCost.PerSystem = s.OptionA.TargetCost.PerSystem ?? 0;
          s.OptionA.Forecast.PerSystem = s.OptionA.Forecast.PerSystem ?? 0;
          s.OptionA.Forecast.ActualMEKs = s.OptionA.Forecast.ActualMEKs ?? 0;
        }
      }
      if (this.optBVisible) {
        let perSysTotaloptB = 0;
        let forecastPerSysTotaloptB = 0;
        let forecastActualMekTotaloptB = 0;
        const allOptBRows = this.getAllGridDataIncludingHidden(this.optBGridApi, this.masterGridData);
        allOptBRows.forEach(row => {
          if (!row.group && !row.HasChild && (row.IsActive == null || row.IsActive == true)) {
            perSysTotaloptB += Number(row.OptionB.TargetCostMEK.PerSystem);
            forecastPerSysTotaloptB += Number(row.OptionB.ForecastMEK.PerSystem);
            forecastActualMekTotaloptB += Number(row.OptionB.ForecastMEK.ActualsMEKPerSystem);
          }
        });
        // this.optBGridApi.forEachNode(node => {
        //   if (!node.group && !node.data.HasChild && (node.data.IsActive == null || node.data.IsActive == true)) {
        //     perSysTotaloptB += Number(node.data.OptionB.TargetCostMEK.PerSystem)
        //     forecastPerSysTotaloptB += Number(node.data.OptionB.ForecastMEK.PerSystem)
        //     forecastActualMekTotaloptB += Number(node.data.OptionB.ForecastMEK.ActualsMEKPerSystem)
        //   }
        // })
        if (s.Name == "MEKTotal") {
          s.OptionB.TargetCost.PerSystem = perSysTotaloptB ?? 0;
          s.OptionB.Forecast.PerSystem = forecastPerSysTotaloptB ?? 0;
          s.OptionB.Forecast.ActualMEKs = forecastActualMekTotaloptB ?? 0;
        }
        else if (s.Name == "TotalBK") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptB, "OptB", true);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptB, "OptBForPerSys", true);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptB, "OptBForAct", true);
        }
        else if (s.Name == "Overhead") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptB, "OptB", false);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptB, "OptBForPerSys", false);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptB, "OptBForAct", false);
        }
        else {
          s.OptionB.TargetCost.PerSystem = s.OptionB.TargetCost.PerSystem ?? 0;
          s.OptionB.Forecast.PerSystem = s.OptionB.Forecast.PerSystem ?? 0;
          s.OptionB.Forecast.ActualMEKs = s.OptionB.Forecast.ActualMEKs ?? 0;
        }
      }
      if (this.optCVisible) {
        let perSysTotaloptC = 0;
        let forecastPerSysTotaloptC = 0;
        let forecastActualMekTotaloptC = 0;
        const allOptCRows = this.getAllGridDataIncludingHidden(this.optCGridApi, this.masterGridData);
        allOptCRows.forEach(row => {
          if (!row.group && !row.HasChild && (row.IsActive == null || row.IsActive == true)) {
            perSysTotaloptC += Number(row.OptionC.TargetCostMEK.PerSystem);
            forecastPerSysTotaloptC += Number(row.OptionC.ForecastMEK.PerSystem);
            forecastActualMekTotaloptC += Number(row.OptionC.ForecastMEK.ActualsMEKPerSystem);
          }
        });
        if (s.Name == "MEKTotal") {
          s.OptionC.TargetCost.PerSystem = perSysTotaloptC ?? 0;
          s.OptionC.Forecast.PerSystem = forecastPerSysTotaloptC ?? 0;
          s.OptionC.Forecast.ActualMEKs = forecastActualMekTotaloptC ?? 0;
        }
        else if (s.Name == "TotalBK") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptC, "OptC", true);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptC, "OptCForPerSys", true);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptC, "OptCForAct", true);
        }
        else if (s.Name == "Overhead") {
          s.ReferenceScenario.Id = s.ReferenceScenario.Id ?? 0;
          s.TargetScenario.TargetCost.PerSystem = this.calculateTotalBKOrOverhead(perSysTotaloptC, "OptC", false);
          s.TargetScenario.Forecast.PerSystem = this.calculateTotalBKOrOverhead(forecastPerSysTotaloptC, "OptCForPerSys", false);
          s.TargetScenario.Forecast.ActualMEKs = this.calculateTotalBKOrOverhead(forecastActualMekTotaloptC, "OptCForAct", false);
        }
        else {
          s.OptionC.TargetCost.PerSystem = s.OptionC.TargetCost.PerSystem ?? 0;
          s.OptionC.Forecast.PerSystem = s.OptionC.Forecast.PerSystem ?? 0;
          s.OptionC.Forecast.ActualMEKs = s.OptionC.Forecast.ActualMEKs ?? 0;
        }
      }
    });

    // Exclude rows where Id is 0 or null AND IsActive is false
    this.TCSimulationData = this.TCSimulationData.filter(row =>
      !((row.Id === 0 || row.Id === null) && row.IsActive === false)
    );

    sendObj = {
      TCEQTargetCostSummaries: summaries,
      TCEQTargetCosts: eqData,
      TCEQsimulationTargetCost: this.IsSimulationDataModified ? this.TCSimulationData : [],
      BusinessAreaId: this.businessAreaId,
      BusinessLineId: this.businessLineId
    }

    return sendObj
  }

  setRowHeightsForDisplayAssembly(gridApi) {
    gridApi.forEachNode(node => {
      if (node.data && node.data.IsDisplayAssembly === false) {
        node.setRowHeight(0);
      } else {
        node.setRowHeight(25); // or your default row height
      }
    });
    gridApi.onRowHeightChanged();
  }

  getAllGridDataIncludingHidden(gridApi, masterData, filterProp = 'IsDisplayAssembly') {
    // 1. Get all visible/edited rows from gridApi
    const visibleRows: any[] = [];
    gridApi.forEachNode(node => {
      if (node.data) visibleRows.push(node.data);
    });

    // 2. Get all hidden records from masterData
    const hiddenRows = masterData.filter(row =>
      row[filterProp] === false
    );
    // 3. Combine both arrays
    return [...visibleRows, ...hiddenRows];
  }

  calculateTotalBKOrOverhead(mekTotal: number, type: string, IsTotalBKOrOverhead: boolean) {
    let total = 0;
    let labor = 0;
    let overhead = 0;

    switch (type) {
      case 'Ref':
        labor = Number(this.refSummaryGridApi.getDisplayedRowAtIndex(9).data.ReferenceScenario.PerSystem);
        overhead = this.CalculateTotalRefOverhead(labor);
        break;
      case 'Tar':
        labor = Number(this.tarSummaryGridApi.getDisplayedRowAtIndex(9).data.TargetScenario.TargetCost.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'TargetScenario', 'TargetCostMEK', 'PerSystem');
        break;
      case 'TarForPerSys':
        labor = Number(this.tarSummaryGridApi.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'PerSystem');
        break;
      case 'TarForAct':
        labor = Number(this.tarSummaryGridApi.getDisplayedRowAtIndex(9).data.TargetScenario.Forecast.ActualMEKs);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'TargetScenario', 'ForecastMEK', 'ActualsMEKPerSystem');
        break;
      case 'OptA':
        labor = Number(this.optASummaryGridApi.getDisplayedRowAtIndex(9).data.OptionA.TargetCost.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionA', 'TargetCostMEK', 'PerSystem');
        break;
      case 'OptAForPerSys':
        labor = Number(this.optASummaryGridApi.getDisplayedRowAtIndex(9).data.OptionA.Forecast.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'PerSystem');
        break;
      case 'OptAForAct':
        labor = Number(this.optASummaryGridApi.getDisplayedRowAtIndex(9).data.OptionA.Forecast.ActualMEKs);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionA', 'ForecastMEK', 'ActualsMEKPerSystem');
        break;
      case 'OptB':
        labor = Number(this.optBSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionB.TargetCost.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionB', 'TargetCostMEK', 'PerSystem');
        break;
      case 'OptBForPerSys':
        labor = Number(this.optBSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionB.Forecast.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'PerSystem');
        break;
      case 'OptBForAct':
        labor = Number(this.optBSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionB.Forecast.ActualMEKs);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionB', 'ForecastMEK', 'ActualsMEKPerSystem');
        break;
      case 'OptC':
        labor = Number(this.optCSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionC.TargetCost.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionC', 'TargetCostMEK', 'PerSystem');
        break;
      case 'OptCForPerSys':
        labor = Number(this.optCSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionC.Forecast.PerSystem);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'PerSystem');
        break;
      case 'OptCForAct':
        labor = Number(this.optCSummaryGridApi.getDisplayedRowAtIndex(9).data.OptionC.Forecast.ActualMEKs);
        overhead = this.CalculateTotalScenarioOverhead(labor, 'OptionC', 'ForecastMEK', 'ActualsMEKPerSystem');
        break;
      default:
        labor = 0;
    }

    // let overhead = mekTotal * (Number(this.bkFactorValue ?? 1) - 1) + labor * (Number(this.fkFactorValue ?? 1) - 1)

    if (IsTotalBKOrOverhead) {
      total = overhead + labor + mekTotal;
    }
    else {
      total = overhead
    }
    return total;
  }

  isSupplierNoInList(supplierNo: string): boolean {
    if (!supplierNo || !this.supplierInfoMasterList || this.supplierInfoMasterList.length === 0) {
      return false;
    }
    return this.supplierInfoMasterList.some(
      s => s.SupplierNo === supplierNo || s.supplierNo === supplierNo
    );
  }

}

// creates row for summaries
function createDataTar(summary: any[], isEditable: boolean) {
  let result = [];

  summary.forEach((d, i) => {
    result.push({
      Index: i,
      TargetScenario: {
        TargetCostMEK: {
          Id: d.TargetScenario?.TargetCost?.Id ?? null,
          PerSystem: d.TargetScenario?.TargetCost?.PerSystem ?? null
        },
        ForecastMEK: {
          Id: d.TargetScenario?.Forecast?.Id ?? null,
          PerSystem: d.TargetScenario?.Forecast?.PerSystem ?? null,
          ActualsMEK: d.TargetScenario?.Forecast?.ActualMEKs ?? null,
        }
      },
      Pinned: true,
      IsEditable: isEditable
    })
  });

  return result;
};


// creates row for summaries
function createDataRef(summary: any[], isEditable: boolean) {
  let result = [];
  summary.forEach((d, i) => {
    result.push({
      VBLO: d.Description,
      Index: i,
      ReferencceScenario: { Id: d.ReferenceScenario.Id, MEKPerSystem: d.ReferenceScenario.PerSystem },
      Pinned: true,
      IsEditable: isEditable
    })
  });
  return result;
};

// creates row for summaries for OptionA
function createDataOptA(summary: any[], isEditable: boolean) {
  let result = [];

  summary.forEach((d, i) => {
    result.push({
      Index: i,
      OptionA: {
        TargetCostMEK: {
          Id: d.OptionA?.TargetCost?.Id ?? null,
          PerSystem: d.OptionA?.TargetCost?.PerSystem ?? null
        },
        ForecastMEK: {
          Id: d.OptionA?.Forecast?.Id ?? null,
          PerSystem: d.OptionA?.Forecast?.PerSystem ?? null,
          ActualsMEK: d.OptionA?.Forecast?.ActualMEKs ?? null,
        }
      },
      Pinned: true,
      IsEditable: isEditable
    })
  });

  return result;
}

// creates row for summaries for OptionB
function createDataOptB(summary: any[], isEditable: boolean) {
  let result = [];

  summary.forEach((d, i) => {
    result.push({
      Index: i,
      OptionB: {
        TargetCostMEK: {
          Id: d.OptionB?.TargetCost?.Id ?? null,
          PerSystem: d.OptionB?.TargetCost?.PerSystem ?? null
        },
        ForecastMEK: {
          Id: d.OptionB?.Forecast?.Id ?? null,
          PerSystem: d.OptionB?.Forecast?.PerSystem ?? null,
          ActualsMEK: d.OptionB?.Forecast?.ActualMEKs ?? null,
        }
      },
      Pinned: true,
      IsEditable: isEditable
    })
  });

  return result;
}

// creates row for summaries for OptionB
function createDataOptC(summary: any[], isEditable: boolean) {
  let result = [];

  summary.forEach((d, i) => {
    result.push({
      Index: i,
      OptionC: {
        TargetCostMEK: {
          Id: d.OptionC?.TargetCost?.Id ?? null,
          PerSystem: d.OptionC?.TargetCost?.PerSystem ?? null
        },
        ForecastMEK: {
          Id: d.OptionC?.Forecast?.Id ?? null,
          PerSystem: d.OptionC?.Forecast?.PerSystem ?? null,
          ActualsMEK: d.OptionC?.Forecast?.ActualMEKs ?? null,
        }
      },
      Pinned: true,
      IsEditable: isEditable
    })
  });

  return result;
}

// Function to synchronize vertical scrolling
function syncVerticalScroll(event) {
  const scrollTop = event.target.scrollTop; // Get the scroll position of the current grid
  grids.forEach(grid => {
    if (grid !== event.target) {
      grid.scrollTop = scrollTop; // Apply the scroll position to other grids
    }
  });
}

function sortGridData(data) {
  return data.sort((a, b) => {
    // Handle null and empty values
    const assemblyA = a.Assembly || '';  // Treat null or undefined as empty string
    const assemblyB = b.Assembly || '';  // Same for b

    // First, check for empty assemblies (empty should come first)
    if (assemblyA === '' && assemblyB !== '') return -1;  // a comes first
    if (assemblyB === '' && assemblyA !== '') return 1;   // b comes first

    // Then, if both are non-empty, compare alphabetically
    if (assemblyA < assemblyB) return -1;  // a comes first
    if (assemblyA > assemblyB) return 1;   // b comes first
    return 0;  // If equal
  });
}

let scrollTimeout;
function syncVerticalScrollDebounced(event) {
  const scrollTop = event.target.scrollTop;
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    grids.forEach(grid => {
      if (grid !== event.target) {
        grid.scrollTop = scrollTop;
      }
    });
  }, 10); // Adjust delay as needed
}

// used to format the cell in germman currency format;
function CurrencyCellRenderer(params: any) {
  const value = params.value;
  if (value === undefined || value === null || isNaN(value)) {
    return null;
  }
  if (value !== undefined || value !== null) {
    if (params.colDef.field == "TargetScenario.TargetCostMEK.DeltaTCVsRefMEK" || params.colDef.field == "TargetScenario.ForecastMEK.DeltaFCVsRefMEK" || params.colDef.field == "TargetScenario.ForecastMEK.DeltaTCVsACT" ||
      params.colDef.field == "OptionA.TargetCostMEK.DeltaTCVsRefMEK" || params.colDef.field == "OptionA.ForecastMEK.DeltaFCVsRefMEK" || params.colDef.field == "OptionA.ForecastMEK.DeltaTCVsACT" ||
      params.colDef.field == "OptionB.TargetCostMEK.DeltaTCVsRefMEK" || params.colDef.field == "OptionB.ForecastMEK.DeltaFCVsRefMEK" || params.colDef.field == "OptionB.ForecastMEK.DeltaTCVsACT" ||
      params.colDef.field == "OptionC.TargetCostMEK.DeltaTCVsRefMEK" || params.colDef.field == "OptionC.ForecastMEK.DeltaFCVsRefMEK" || params.colDef.field == "OptionC.ForecastMEK.DeltaTCVsACT"
    ) {
      return `${new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)))}%`;
    }
    else {
      return new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)));
    }
  }
  else {
    return new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)));
  }
  // return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)));
}

// used to format the cell in germman currency format;
function CurrencyCellRendererReadOnly(params: any) {
  return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(0)));
}

// Add near the top of the file, before the @Component decorator
function resolveFieldPath(data: any, fieldPath: string): any {
  if (!data || !fieldPath) return undefined;
  return fieldPath.split('.').reduce((obj, key) => obj?.[key], data);
}
